<template>
  <el-dialog @close="cancel" :title="content.title" :visible.sync="content.show" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" class="table-container-dialog">
    <div>
      <!-- 页面标题 -->
      <!-- <div class="page-title">
        <h2>Table 1 - Repeat Expansion Disorders</h2>
      </div> -->
      <!-- 新增筛选输入框 -->
      <div class="table-filter-wrapper" style="margin-bottom: 16px;">
        <el-input v-model="filterKeyword" @input="handleFilterInput" placeholder="" clearable prefix-icon="el-icon-search" size="medium" style="width: 300px;"></el-input>
      </div>
      <!-- 表格容器：添加自定义类名，提升样式权重 -->
      <div class="table-wrapper keyword-highlight-table">
        <el-table :data="filteredTableData" border stripe :header-cell-style="{background: '#f5f7fa', color: '#2c3e50', fontWeight: '600'}" :cell-style="{padding: '12px 8px', whiteSpace: 'normal', wordBreak: 'break-all'}" :row-style="{height: 'auto'}" size="medium" tooltip-effect="light">
          <!-- 动态列 -->
          <el-table-column v-for="(col, index) in tableColumns[content.type.toLowerCase().replace(/\s+/g, '')] || tableColumns.table1" :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align" :showOverflowTooltip="col.showOverflowTooltip">
            <template slot-scope="scope">
              <!-- 统一处理文本高亮 + 链接 -->
              <div v-html="highlightKeyword(scope.row, col)"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: "RepeatExpansionTable",
  data() {
    return {
      content: {
        show: false,
        type: '',
        title: ""
      },
      // Table 1 完整数据
      // Table1: [
      //   {
      //     disorder: "Amyotrophic Lateral Sclerosis / Frontotemporal Dementia [MIM: 105550]",
      //     gene: "C9orf72",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GGGGCC"
      //   },
      //   {
      //     disorder: "Amyotrophic Lateral Sclerosis, Susceptibility To, 13 [MIM: 183090]; Parkinson Disease Late-Onset, Susceptibility To [MIM: 168600]; Spinocerebellar Ataxia 2 [MIM: 183090]",
      //     gene: "ATXN2",
      //     inheritance: "Multifactorial / Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Blepharophimosis Epicanthus Inversus and Ptosis Types 1 and 2 [MIM: 110100]",
      //     gene: "FOXL2",
      //     inheritance: "Autosomal Dominant / Autosomal Recessive",
      //     repeat: "Polyalanine"
      //   },
      //   {
      //     disorder: "Brachydactyly Type D [MIM: 113200]; Brachydactyly Type E [MIM: 113300]; Syndactyly Type V [MIM: 186300]; Synpolydactyly 1 [MIM: 186000]",
      //     gene: "HOXD13",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "Polyalanine"
      //   },
      //   {
      //     disorder: "Central Hypoventilation Syndrome Congenital 1 With or Without Hirschsprung Disease [MIM: 209880]",
      //     gene: "PHOX2B",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "Polyalanine"
      //   },
      //   {
      //     disorder: "Cerebellar Ataxia, Neuropathy, and Vestibular Areflexia Syndrome (CANVAS) [MIM: 614575]",
      //     gene: "RFC1",
      //     inheritance: "Autosomal Recessive",
      //     repeat: "AAGGG/ACAGG"
      //   },
      //   {
      //     disorder: "Dentatorubral-Pallidoluysian Atrophy [MIM: 125370]",
      //     gene: "ATN1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Desbuquois Dysplasia 2 [MIM: 615777]",
      //     gene: "XYLT1",
      //     inheritance: "Autosomal Recessive",
      //     repeat: "GGC"
      //   },
      //   {
      //     disorder: "Developmental and Epileptic Encephalopathy 1 [MIM: 308350]",
      //     gene: "ARX",
      //     inheritance: "X-Linked",
      //     repeat: "GCG"
      //   },
      //   {
      //     disorder: "Familial Adult Myoclonic Epilepsy 1 [MIM: 601068]",
      //     gene: "SAMD12",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "TTTCA"
      //   },
      //   {
      //     disorder: "Familial Adult Myoclonic Epilepsy 6 [MIM: 618074]",
      //     gene: "TNRC6A",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "TTTCA"
      //   },
      //   {
      //     disorder: "Familial Adult Myoclonic Epilepsy 7 [MIM: 618075]",
      //     gene: "RAPGEF2",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "TTTCA"
      //   },
      //   {
      //     disorder: "Fragile X Syndrome [MIM: 300624]; Fragile X Tremor/Ataxia Syndrome [MIM: 300623]; Premature Ovarian Failure 1 [MIM: 311360]",
      //     gene: "FMR1",
      //     inheritance: "X-Linked",
      //     repeat: "CGG"
      //   },
      //   {
      //     disorder: "Friedreich Ataxia [MIM: 229300]; Friedreich Ataxia With Retained Reflexes [MIM: 229300]",
      //     gene: "FXN",
      //     inheritance: "Autosomal Recessive",
      //     repeat: "GAA"
      //   },
      //   {
      //     disorder: "Fuchs Endothelial Corneal Dystrophy / Pitt Hopkins Syndrome [MIM: 613267]",
      //     gene: "TCF4",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CTG"
      //   },
      //   {
      //     disorder: "Global Developmental Delay, Progressive Ataxia, Elevated Glutamine [MIM: 618412]",
      //     gene: "GLS",
      //     inheritance: "Autosomal Dominant / Autosomal Recessive",
      //     repeat: "GCA"
      //   },
      //   {
      //     disorder: "Hand-Foot-Genital Syndrome [MIM: 140000]",
      //     gene: "HOXA13",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "Polyalanine"
      //   },
      //   {
      //     disorder: "Holoprosencephaly 5 [MIM: 609637]",
      //     gene: "ZIC2",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "Polyalanine"
      //   },
      //   {
      //     disorder: "Huntington Disease [MIM: 143100]",
      //     gene: "HTT",
      //     inheritance: "Autosomal Dominant / Autosomal Recessive",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Huntington Disease-Like 2 [MIM: 606438]",
      //     gene: "JPH3",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CTG"
      //   },
      //   {
      //     disorder: "Intellectual Developmental Disorder, Autosomal Dominant, FRA12A Type [MIM: 136630]",
      //     gene: "DIP2B",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CGG"
      //   },
      //   {
      //     disorder: "Intellectual Developmental Disorder, X-linked, With Isolated Growth Hormone Deficiency [MIM: 300123]; Panhypopituitarism, X-linked [MIM: 312000]",
      //     gene: "SOX3",
      //     inheritance: "X-Linked",
      //     repeat: "GCG"
      //   },
      //   {
      //     disorder: "Myoclonus Epilepsy Type 1A (Unverricht and Lundborg) [MIM: 254800]",
      //     gene: "CSTB",
      //     inheritance: "Autosomal Recessive",
      //     repeat: "CCCCGCCCCGCG"
      //   },
      //   {
      //     disorder: "Myotonic Dystrophy Type 1 [MIM: 160900]",
      //     gene: "DMPK",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CTG"
      //   },
      //   {
      //     disorder: "Myotonic Dystrophy Type 2 [MIM: 602668]",
      //     gene: "CNBP",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CTG"
      //   },
      //   {
      //     disorder: "Neuronal Intranuclear Inclusion Disease [MIM: 603472]; Oculopharyngodistal Myopathy 3 [MIM: 619473]; Tremor Hereditary Essential 6 [MIM: 618866]",
      //     gene: "NOTCH2NLC",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GGC"
      //   },
      //   {
      //     disorder: "Neuropathy, Hereditary Sensory and Autonomic, Type VIII [MIM: 616458]",
      //     gene: "PRDM12",
      //     inheritance: "Autosomal Recessive",
      //     repeat: "GCC"
      //   },
      //   {
      //     disorder: "Oculopharyngeal Muscular Dystrophy [MIM: 164300]",
      //     gene: "PABPN1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GCG/GCA"
      //   },
      //   {
      //     disorder: "Oculopharyngodistal Myopathy [PMID: 39068203]",
      //     gene: "ABCD3",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GCC"
      //   },
      //   {
      //     disorder: "Oculopharyngodistal Myopathy Type 1 [MIM: 164310]; Amyotrophic Lateral Sclerosis 28 [MIM: 620452]",
      //     gene: "LRP12",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CGG"
      //   },
      //   {
      //     disorder: "Oculopharyngodistal Myopathy Type 2 [MIM: 618940]",
      //     gene: "GIPC1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GGC"
      //   },
      //   {
      //     disorder: "Oculopharyngodistal Myopathy With Leukoencephalopathy 1 [MIM: 618637]",
      //     gene: "NUTM2B-AS1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CCG"
      //   },
      //   {
      //     disorder: "Richieri-Costa-Pereira Syndrome / Robin Sequence With Cleft Mandible and Limb Anomalies [MIM: 268305]",
      //     gene: "EIF4A3",
      //     inheritance: "Autosomal Recessive",
      //     repeat: "TCGGCAGCGGCACAGCGAGG"
      //   },
      //   {
      //     disorder: "Spastic Paraplegia 6 [MIM: 600363]",
      //     gene: "NIPA1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GCG"
      //   },
      //   {
      //     disorder: "Spinal and Bulbar Muscular Atrophy, X-Linked 1 [MIM: 313200]",
      //     gene: "AR",
      //     inheritance: "X-Linked",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 1 [MIM: 164400]",
      //     gene: "ATXN1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 10 [MIM: 603516]",
      //     gene: "ATXN10",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "ATTCT"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 12 [MIM: 604326]",
      //     gene: "PPP2R2B",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 17 [MIM: 607136]; Parkinson Disease, Susceptibility To [MIM: 168600]",
      //     gene: "TBP",
      //     inheritance: "Multifactorial / Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia 27B, Late-Onset [MIM: 601515]",
      //     gene: "FGF14",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GAA"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 3 / Machado-Joseph Disease [MIM: 109150]; Parkinson Disease, Susceptibility To [MIM: 168600]",
      //     gene: "ATXN3",
      //     inheritance: "Multifactorial / Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia 31 [MIM: 117210]",
      //     gene: "BEAN1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "TGGAA"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 36 [MIM: 614153]",
      //     gene: "NOP56",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GGCCTG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 37 [MIM: 615945]",
      //     gene: "DAB1",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "ATTTC/ATTTT"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 4 [MIM: 600223]",
      //     gene: "ZFHX3",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "GGC"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 51 [MIM: 620947]",
      //     gene: "THAP11",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 6 [MIM: 183086]",
      //     gene: "CACNA1A",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 7 [MIM: 164500]",
      //     gene: "ATXN7",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG"
      //   },
      //   {
      //     disorder: "Spinocerebellar Ataxia Type 8 [MIM: 608768]; Parkinson Disease, Susceptibility To [MIM: 168600]",
      //     gene: "ATXN8 / ATXN8OS",
      //     inheritance: "Autosomal Dominant",
      //     repeat: "CAG/CTG"
      //   },
      //   {
      //     disorder: "X-Linked Intellectual Development Disorder 109 [MIM: 309548]",
      //     gene: "AFF2",
      //     inheritance: "X-Linked",
      //     repeat: "GCC"
      //   },
      //   {
      //     disorder: "X-Linked VACTERL Association [MIM: 314390]",
      //     gene: "ZIC3",
      //     inheritance: "X-Linked",
      //     repeat: "GCC"
      //   }
      // ],

      Table1: [
        {
          "Gene": "AR",
          "Phenotype MIM Number": "{Prostate cancer, susceptibility to} [MIM: 301120]; Androgen insensitivity [MIM: 300068]; Androgen insensitivity, partial, with or without breast cancer [MIM: 312300]; Hypospadias 1, X-linked [MIM: 300633]; Spinal and bulbar muscular atrophy, X-linked 1 [MIM: 313200]",
          "OMIM Entry": "313700",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "FOXL2",
          "Phenotype MIM Number": "Blepharophimosis Epicanthus Inversus and Ptosis Types 1 and 2 [MIM: 110100] ",
          "OMIM Entry": "110100",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HOXD13",
          "Phenotype MIM Number": "Brachydactyly Type D [MIM: 113200]; Brachydactyly Type E [MIM: 113300]; Syndactyly Type V [MIM: 186300]; Synpolydactyly 1 [MIM: 186000] ",
          "OMIM Entry": "142989",
          "Inheritance": "AD"
        },
        {
          "Gene": "PHOX2B",
          "Phenotype MIM Number": "Central Hypoventilation Syndrome Congenital 1 With or Without Hirschsprung Disease [MIM: 209880] ",
          "OMIM Entry": "209880",
          "Inheritance": "AD"
        },
        {
          "Gene": "RFC1",
          "Phenotype MIM Number": "Cerebellar ataxia neuropathy and vestibular areflexia syndrome [MIM: 614575]",
          "OMIM Entry": "102579",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATN1",
          "Phenotype MIM Number": "Congenital hypotonia, epilepsy, developmental delay, and digital anomalies [618494]; Dentatorubral-pallidoluysian atrophy [MIM: 125370]",
          "OMIM Entry": "607462",
          "Inheritance": "AD"
        },
        {
          "Gene": "TCF4",
          "Phenotype MIM Number": "Corneal dystrophy, Fuchs endothelial, 3 [MIM: 613267]; Pitt-Hopkins syndrome [MIM: 610954]",
          "OMIM Entry": "602272",
          "Inheritance": "AD"
        },
        {
          "Gene": "XYLT1",
          "Phenotype MIM Number": "Desbuquois Dysplasia 2 [MIM: 615777] ",
          "OMIM Entry": "615777",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARX",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 1 [MIM: 308350]; Hydranencephaly with abnormal genitalia [MIM:  300215]; Intellectual developmental disorder, X-linked 29 [MIM: 300419]; Lissencephaly, X-linked 2 [MIM:  300215]; Partington syndrome [MIM: 309510]; Proud syndrome [MIM: 300004]",
          "OMIM Entry": "300382",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "TNRC6A",
          "Phenotype MIM Number": "Epilepsy, familial adult myoclonic, 6 [MIM: 618074]",
          "OMIM Entry": "610739",
          "Inheritance": "AD"
        },
        {
          "Gene": "SAMD12",
          "Phenotype MIM Number": "Familial Adult Myoclonic Epilepsy 1 [MIM: 601068]",
          "OMIM Entry": "618073",
          "Inheritance": "AD"
        },
        {
          "Gene": "RAPGEF2",
          "Phenotype MIM Number": "Familial Adult Myoclonic Epilepsy 7 [MIM: 618075]",
          "OMIM Entry": "609530",
          "Inheritance": "AD"
        },
        {
          "Gene": "FMR1",
          "Phenotype MIM Number": "Fragile X syndrome [MIM: 300624]; Fragile X tremor/ataxia syndrome [MIM 300623]; Premature ovarian failure 1 [MIM: 311360]",
          "OMIM Entry": "309550",
          "Inheritance": "XLD, XL"
        },
        {
          "Gene": "FXN",
          "Phenotype MIM Number": "Friedreich ataxia [MIM: 229300]; Friedreich ataxia with retained reflexes [MIM: 229300]",
          "OMIM Entry": "606829",
          "Inheritance": "AR"
        },
        {
          "Gene": "C9orf72",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 1 [MIM: 105550]",
          "OMIM Entry": "614260",
          "Inheritance": "AD"
        },
        {
          "Gene": "GLS",
          "Phenotype MIM Number": "Global developmental delay progressive ataxia and elevated glutamine [MIM: 618412]",
          "OMIM Entry": "138280",
          "Inheritance": "AR"
        },
        {
          "Gene": "HOXA13",
          "Phenotype MIM Number": "Hand-Foot-Genital Syndrome [MIM: 140000]",
          "OMIM Entry": "140000",
          "Inheritance": "AD"
        },
        {
          "Gene": "ZIC2",
          "Phenotype MIM Number": "Holoprosencephaly 5 [MIM: 609637] ",
          "OMIM Entry": "603073",
          "Inheritance": "AD"
        },
        {
          "Gene": "HTT",
          "Phenotype MIM Number": "Huntington disease [MIM: 143100]; Lopes-Maciel-Rodan syndrome [MIM: 617435]",
          "OMIM Entry": "613004",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "JPH3",
          "Phenotype MIM Number": "Huntington disease-like 2 [MIM: 606438]",
          "OMIM Entry": "605268",
          "Inheritance": "AD"
        },
        {
          "Gene": "DIP2B",
          "Phenotype MIM Number": "Intellectual Developmental Disorder, Autosomal Dominant, FRA12A Type [MIM: 136630] ",
          "OMIM Entry": "136630",
          "Inheritance": "AD"
        },
        {
          "Gene": "SOX3",
          "Phenotype MIM Number": "Intellectual Developmental Disorder, X-linked, With Isolated Growth Hormone Deficiency [MIM: 300123]; Panhypopituitarism, X-linked [MIM: 312000] ",
          "OMIM Entry": "313430",
          "Inheritance": "X-Linked"
        },
        {
          "Gene": "CSTB",
          "Phenotype MIM Number": "Myoclonus Epilepsy Type 1A (Unverricht and Lundborg) [MIM: 254800] ",
          "OMIM Entry": "601145",
          "Inheritance": "AR"
        },
        {
          "Gene": "DMPK",
          "Phenotype MIM Number": "Myotonic dystrophy 1 [MIM: 160900]",
          "OMIM Entry": "605377",
          "Inheritance": "AD"
        },
        {
          "Gene": "CNBP",
          "Phenotype MIM Number": "Myotonic dystrophy 2 [MIM: 602668]",
          "OMIM Entry": "116955",
          "Inheritance": "AD"
        },
        {
          "Gene": "NOTCH2NLC",
          "Phenotype MIM Number": "Neuronal Intranuclear Inclusion Disease [MIM: 603472]; Oculopharyngodistal Myopathy 3 [MIM: 619473]; Tremor Hereditary Essential 6 [MIM: 618866]",
          "OMIM Entry": "618025",
          "Inheritance": "AD"
        },
        {
          "Gene": "PRDM12",
          "Phenotype MIM Number": "Neuropathy, Hereditary Sensory and Autonomic, Type VIII [MIM: 616488]",
          "OMIM Entry": "616458",
          "Inheritance": "AR"
        },
        {
          "Gene": "PABPN1",
          "Phenotype MIM Number": "Oculopharyngeal muscular dystrophy [MIM: 164300]",
          "OMIM Entry": "602279",
          "Inheritance": "AD"
        },
        {
          "Gene": " NUTM2B-AS1",
          "Phenotype MIM Number": "Oculopharyngeal myopathy with leukoencephalopathy 1 [MIM: 618637]",
          "OMIM Entry": "618639",
          "Inheritance": "AD"
        },
        {
          "Gene": "ABCD3",
          "Phenotype MIM Number": "Oculopharyngodistal Myopathy [MIM: 621446]; Bile acid synthesis defect, congenital, 5 [MIM: 616278]",
          "OMIM Entry": "170995",
          "Inheritance": "AR"
        },
        {
          "Gene": "LRP12",
          "Phenotype MIM Number": "Oculopharyngodistal Myopathy 1 [MIM: 164310]; Amyotrophic Lateral Sclerosis 28 [MIM: 620452] ",
          "OMIM Entry": "618299",
          "Inheritance": "AD"
        },
        {
          "Gene": "GIPC1",
          "Phenotype MIM Number": "Oculopharyngodistal myopathy 2 [MIM: 618940]",
          "OMIM Entry": "605072",
          "Inheritance": "AD"
        },
        {
          "Gene": "EIF4A3",
          "Phenotype MIM Number": "Richieri-Costa-Pereira Syndrome / Robin Sequence With Cleft Mandible and Limb Anomalies [MIM: 268305] ",
          "OMIM Entry": "268305",
          "Inheritance": "AR"
        },
        {
          "Gene": "NIPA1",
          "Phenotype MIM Number": "Spastic paraplegia 6, autosomal dominant [MIM: 600363]",
          "OMIM Entry": "608145",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 1 [MIM: 164400]",
          "OMIM Entry": "601556",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN10",
          "Phenotype MIM Number": "Spinocerebellar ataxia 10 [MIM: 603516]",
          "OMIM Entry": "611150",
          "Inheritance": "AD"
        },
        {
          "Gene": "PPP2R2B",
          "Phenotype MIM Number": "Spinocerebellar ataxia 12 [MIM: 604326]",
          "OMIM Entry": "604325",
          "Inheritance": "AD"
        },
        {
          "Gene": "TBP  ",
          "Phenotype MIM Number": "Spinocerebellar Ataxia 17 [MIM: 607136]; Parkinson Disease, Susceptibility To [MIM: 168600] ",
          "OMIM Entry": "600075",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 2 [MIM: 183090]; {Amyotrophic lateral sclerosis susceptibility to 13} [MIM: 183090]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "601517",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "FGF14",
          "Phenotype MIM Number": "Spinocerebellar ataxia 27A [MIM: 193003]; Spinocerebellar ataxia 27B, late-onset [MIM: 620174]",
          "OMIM Entry": "601515",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN3",
          "Phenotype MIM Number": "Spinocerebellar Ataxia 3 / Machado-Joseph Disease [MIM: 109150]; Parkinson Disease, Susceptibility To [MIM: 168600] ",
          "OMIM Entry": "607047",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "BEAN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 31 [MIM: 117210]",
          "OMIM Entry": "612051",
          "Inheritance": "AD"
        },
        {
          "Gene": "NOP56",
          "Phenotype MIM Number": "Spinocerebellar ataxia 36 [MIM: 614153]",
          "OMIM Entry": "614154",
          "Inheritance": "AD"
        },
        {
          "Gene": "DAB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 37 [MIM: 615945]",
          "OMIM Entry": "603448",
          "Inheritance": "AD"
        },
        {
          "Gene": "ZFHX3 ",
          "Phenotype MIM Number": "Spinocerebellar ataxia 4 [MIM: 600223]",
          "OMIM Entry": "104155",
          "Inheritance": "AD"
        },
        {
          "Gene": "THAP11",
          "Phenotype MIM Number": "Spinocerebellar Ataxia 51 [MIM: 620947]",
          "OMIM Entry": "609119",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNA1A",
          "Phenotype MIM Number": "Spinocerebellar ataxia 6 [MIM: 183086]",
          "OMIM Entry": "601011",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN7",
          "Phenotype MIM Number": "Spinocerebellar ataxia 7 [MIM: 164500]",
          "OMIM Entry": "607640",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN8/ATXN8OS",
          "Phenotype MIM Number": "Spinocerebellar ataxia 8 [MIM: 608768]; {Parkinson disease susceptibility to} [MIM: 168600]",
          "OMIM Entry": "613289; 603680",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "AFF2",
          "Phenotype MIM Number": "X-Linked Intellectual Development Disorder 109 [MIM: 309548] ",
          "OMIM Entry": "309548",
          "Inheritance": "X-Linked"
        },
        {
          "Gene": "ZIC3",
          "Phenotype MIM Number": "X-Linked VACTERL Association [MIM: 314390] ",
          "OMIM Entry": "314390",
          "Inheritance": "X-Linked"
        }
      ],
      Table2: [
        {
          "Gene": "AAAS",
          "Phenotype MIM Number": "Achalasia-addisonianism-alacrimia syndrome [MIM: 231550]",
          "OMIM Entry": "605378",
          "Inheritance": "AR"
        },
        {
          "Gene": "AARS1",
          "Phenotype MIM Number": "Leukoencephalopathy, hereditary diffuse, with spheroids 2 [MIM:619661]; Charcot-Marie-Tooth disease, axonal, type 2N [MIM: 613287]; Developmental and epileptic encephalopathy 29 [MIM: 616339]; Trichothiodystrophy 8, nonphotosensitive [MIM: 619691]",
          "OMIM Entry": "601065",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "AARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 8 [MIM: 614096]; Leukoencephalopathy, progressive, with ovarian failure [MIM: 615889]",
          "OMIM Entry": "612035",
          "Inheritance": "AR"
        },
        {
          "Gene": "AASS",
          "Phenotype MIM Number": "Hyperlysinemia",
          "OMIM Entry": "605113",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABCA1",
          "Phenotype MIM Number": "HDL deficiency, familial, 1 [MIM: 604091]; Tangier disease [MIM: 205400]",
          "OMIM Entry": "600046",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABCA2",
          "Phenotype MIM Number": "Intellectual developmental disorder with poor growth and with or without seizures or ataxia [MIM: 618808]",
          "OMIM Entry": "600047",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABCA7",
          "Phenotype MIM Number": "{Alzheimer disease 9, susceptibility to} [MIM: 608907]",
          "OMIM Entry": "605414",
          "Inheritance": "AD"
        },
        {
          "Gene": "ABCB7",
          "Phenotype MIM Number": "Anemia, sideroblastic, with ataxia [MIM: 301310]",
          "OMIM Entry": "300135",
          "Inheritance": "XL "
        },
        {
          "Gene": "ABCC8",
          "Phenotype MIM Number": "Diabetes mellitus, noninsulin-dependent [MIM:125853]; Diabetes mellitus, permanent neonatal 3 [MIM: 618857]; Diabetes mellitus, transient neonatal 2 [MIM: 610374]; Hyperinsulinemic hypoglycemia, familial, 1 [MIM: 256450]; Hypoglycemia of infancy, leucine-sensitive [MIM: 240800]; Maturity-onset diabetes of the young, type 12 [MIM: 621196]",
          "OMIM Entry": "600509",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ABCD1",
          "Phenotype MIM Number": "Adrenoleukodystrophy [MIM: 300100]; Adrenoleukodystrophy, adult [MIM: 300100]",
          "OMIM Entry": "300371",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ABCD3",
          "Phenotype MIM Number": "Bile acid synthesis defect, congenital, 5 [MIM: 616278]",
          "OMIM Entry": "170995",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABHD12",
          "Phenotype MIM Number": "Polyneuropathy, hearing loss, ataxia, retinitis pigmentosa, and cataract [MIM: 612674]",
          "OMIM Entry": "613599",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABHD5",
          "Phenotype MIM Number": "Chanarin-Dorfman syndrome [MIM: 275630]",
          "OMIM Entry": "604780",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACAD9",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 20 [MIM: 61126]",
          "OMIM Entry": "611103",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACADM",
          "Phenotype MIM Number": "Acyl-CoA dehydrogenase, medium chain, deficiency of [MIM: 201450]",
          "OMIM Entry": "607008",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACADS",
          "Phenotype MIM Number": "Acyl-CoA dehydrogenase, short-chain, deficiency of [MIM: 201470]",
          "OMIM Entry": "606885",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACADVL",
          "Phenotype MIM Number": "VLCAD deficiency [MIM: 201475]",
          "OMIM Entry": "609575",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACAT2",
          "Phenotype MIM Number": "ACAT2 deficiency [MIM: 614055]",
          "OMIM Entry": "100678",
          "Inheritance": "IC"
        },
        {
          "Gene": "ACBD5",
          "Phenotype MIM Number": "Retinal dystrophy with leukodystrophy [MIM: 618863]",
          "OMIM Entry": "616618",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACO2",
          "Phenotype MIM Number": "Infantile cerebellar-retinal degeneration [MIM: 614559]; Optic atrophy 9 [MIM: 616289]",
          "OMIM Entry": "100850",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ACOX1",
          "Phenotype MIM Number": "Mitchell syndrome [MIM: 618960]; Peroxisomal acyl-CoA oxidase deficiency [MIM: 264470]",
          "OMIM Entry": "609751",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ACOX2",
          "Phenotype MIM Number": "Bile acid synthesis defect, congenital, 6 [MIM:617308]",
          "OMIM Entry": "601641",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACP5",
          "Phenotype MIM Number": "Spondyloenchondrodysplasia with immune dysregulation [MIM: 607944]",
          "OMIM Entry": "171640",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACTA1",
          "Phenotype MIM Number": "Myopathy, scapulohumeroperoneal [MIM: 616582]; Congenital myopathy 2A, typical, autosomal dominant [MIM: 161800]; Congenital myopathy 2B, severe infantile, autosomal recessive [MIM: 620265]; Congenital myopathy 2C, severe infantile, autosomal dominant [MIM: 620278]",
          "OMIM Entry": "102610",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ACTB",
          "Phenotype MIM Number": "Baraitser-Winter syndrome 1 [MIM: 243310]; Becker nevus, syndromic or isolated, somatic mosaic [MIM: 604919]; Congenital smooth muscle hamartoma with or without hemihypertrophy, somatic mosaic [MIM: 620470];",
          "OMIM Entry": "102630",
          "Inheritance": "AD"
        },
        {
          "Gene": NaN,
          "Phenotype MIM Number": "Dystonia-deafness syndrome 1 [MIM: 607371]; Thrombocytopenia 8, with dysmorphic features and developmental delay [MIM: 620475]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "ACTL6B",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 76 [MIM: 618468]; Intellectual developmental disorder with severe speech and ambulation defects [MIM: 618470]",
          "OMIM Entry": "612458",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ACTN2",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1AA, with or without LVNC [MIM: 612158]; Cardiomyopathy, hypertrophic, 23, with or without LVNC [MIM: 612158]; Congenital myopathy 8 [MIM: 618654]; Myopathy, distal, 6, adult onset [MIM: 618655]",
          "OMIM Entry": "102573",
          "Inheritance": "AD "
        },
        {
          "Gene": "ADA2",
          "Phenotype MIM Number": "Sneddon syndrome [MIM: 182410]; Vasculitis, autoinflammation, immunodeficiency, and hematologic defects syndrome [MIM: 615688]",
          "OMIM Entry": "607575",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADAMTS13",
          "Phenotype MIM Number": "Thrombotic thrombocytopenic purpura, hereditary [MIM: 274150]",
          "OMIM Entry": "604134",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADAR",
          "Phenotype MIM Number": "Aicardi-Goutieres syndrome 6 [MIM: 615010]; Dyschromatosis symmetrica hereditaria [MIM: 127400]",
          "OMIM Entry": "146920",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ADCY5",
          "Phenotype MIM Number": "Dyskinesia with orofacial involvement, autosomal dominant [MIM: 606703]; Dyskinesia with orofacial involvement, autosomal recessive [MIM: 619647]; Neurodevelopmental disorder with hyperkinetic movements and dyskinesia [MIM: 619651]",
          "OMIM Entry": "600293",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ADCY6",
          "Phenotype MIM Number": "Lethal congenital contracture syndrome 8 [MIM: 616287]",
          "OMIM Entry": "600294",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADD3",
          "Phenotype MIM Number": "Cerebral palsy, spastic quadriplegic, 3 [MIM: 617008]",
          "OMIM Entry": "601568",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADGRG1",
          "Phenotype MIM Number": "Cortical dysplasia, complex, with other brain malformations 14A, (bilateral frontoparietal) [MIM: 606854]; Cortical dysplasia, complex, with other brain malformations 14B, (bilateral perisylvian) [MIM: 615752]",
          "OMIM Entry": "604110",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADH1C",
          "Phenotype MIM Number": "{Alcohol dependence, protection against} [MIM: 103780]; {Parkinson disease, susceptibility to} [MIM: 168600]",
          "OMIM Entry": "103730",
          "Inheritance": "AD, Mu"
        },
        {
          "Gene": "ADPRS",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, stress-induced, with variable ataxia and seizures [MIM: 618170]",
          "OMIM Entry": "610624",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADSL",
          "Phenotype MIM Number": "Adenylosuccinase deficiency [MIM: 103050]",
          "OMIM Entry": "608222",
          "Inheritance": "AR"
        },
        {
          "Gene": "ADSS1",
          "Phenotype MIM Number": "Myopathy, distal, 5 [MIM: 617030]",
          "OMIM Entry": "612498",
          "Inheritance": "AR"
        },
        {
          "Gene": "AFG3L2",
          "Phenotype MIM Number": "Optic atrophy 12 [MIM: 618977]; Spastic ataxia 5, autosomal recessive [MIM: 614487]; Spinocerebellar ataxia 28 [MIM: 610246]",
          "OMIM Entry": "604581",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "AGA",
          "Phenotype MIM Number": "Aspartylglucosaminuria [MIM: 208400]",
          "OMIM Entry": "613228",
          "Inheritance": "AR"
        },
        {
          "Gene": "AGK",
          "Phenotype MIM Number": "Cataract 38, autosomal recessive [MIM: 614691]; Sengers syndrome [MIM: 212350]",
          "OMIM Entry": "610345",
          "Inheritance": "AR"
        },
        {
          "Gene": "AGL",
          "Phenotype MIM Number": "Glycogen storage disease IIIa [MIM: 232400]; Glycogen storage disease IIIb [MIM: 232400]",
          "OMIM Entry": "610860",
          "Inheritance": "AR"
        },
        {
          "Gene": "AGRN",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 8, with pre- and postsynaptic defects [MIM: 615120]",
          "OMIM Entry": "103320",
          "Inheritance": "AR"
        },
        {
          "Gene": "AGTPBP1",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with cerebellar atrophy [MIM: 618276]",
          "OMIM Entry": "606830",
          "Inheritance": "AR"
        },
        {
          "Gene": "AHCY",
          "Phenotype MIM Number": "Hypermethioninemia with deficiency of S-adenosylhomocysteine hydrolase [MIM: 613752]",
          "OMIM Entry": "180960",
          "Inheritance": "AR"
        },
        {
          "Gene": "AHI1",
          "Phenotype MIM Number": "Joubert syndrome 3 [MIM: 608629]",
          "OMIM Entry": "608894",
          "Inheritance": "AR"
        },
        {
          "Gene": "AIFM1",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 6 [MIM: 300816]; Cowchock syndrome [MIM: 310490]; Deafness, X-linked 5 [MIM: 300614]; Spondyloepimetaphyseal dysplasia, X-linked, with hypomyelinating leukodystrophy [MIM: 300232]",
          "OMIM Entry": "300169",
          "Inheritance": "XLR"
        },
        {
          "Gene": "AIMP1",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 3 [MIM: 260600]",
          "OMIM Entry": "603605",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALAD",
          "Phenotype MIM Number": "{Lead poisoning, susceptibility to} [MIM: 612740]; Porphyria, acute hepatic [MIM: 612470]",
          "OMIM Entry": "125270",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALDH18A1",
          "Phenotype MIM Number": "Cutis laxa, autosomal dominant 3 [MIM: 616603]; Cutis laxa, autosomal recessive, type IIIA [MIM: 219150];",
          "OMIM Entry": "138250",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": NaN,
          "Phenotype MIM Number": "Spastic paraplegia 9A, autosomal dominant [MIM: 601162]; Spastic paraplegia 9B, autosomal recessive [MIM: 616586]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "ALDH3A2",
          "Phenotype MIM Number": "Sjogren-Larsson syndrome [MIM: 270200]",
          "OMIM Entry": "609523",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALDH5A1",
          "Phenotype MIM Number": "Succinic semialdehyde dehydrogenase deficiency [MIM: 271980]",
          "OMIM Entry": "610045",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALDH6A1",
          "Phenotype MIM Number": "Methylmalonate semialdehyde dehydrogenase deficiency [MIM: 614105] ",
          "OMIM Entry": "603178",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALG14",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 15, without tubular aggregates [MIM: 616227]; Intellectual developmental disorder with epilepsy, behavioral abnormalities, and coarse facies [MIM: 619031]; Myopathy, epilepsy, and progressive cerebral atrophy [MIM: 619036] ",
          "OMIM Entry": "612866",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALG2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ii [MIM: 607906]; Myasthenic syndrome, congenital, 14, with tubular aggregates [MIM: 616228]",
          "OMIM Entry": "607905",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALG6",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ic [MIM: 603147]",
          "OMIM Entry": "604566",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALS2",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 2, juvenile [MIM: 205100]",
          "OMIM Entry": "205100",
          "Inheritance": "AR"
        },
        {
          "Gene": "AMACR",
          "Phenotype MIM Number": "Alpha-methylacyl-CoA racemase deficiency [MIM: 614307]; Bile acid synthesis defect, congenital, 4 [MIM: 214950] ",
          "OMIM Entry": "604489",
          "Inheritance": "AR"
        },
        {
          "Gene": "AMPD2",
          "Phenotype MIM Number": "pastic paraplegia 63, autosomal recessive [MIM: 615686]; Pontocerebellar hypoplasia, type 9 [MIM: 615809]",
          "OMIM Entry": "102771",
          "Inheritance": "AR"
        },
        {
          "Gene": "ANG",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 9 [MIM: 611895]",
          "OMIM Entry": "105850",
          "Inheritance": NaN
        },
        {
          "Gene": "ANK3",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 37 [MIM: 615493]",
          "OMIM Entry": "600465",
          "Inheritance": "AR"
        },
        {
          "Gene": "ANKLE2",
          "Phenotype MIM Number": "Microcephaly 16, primary, autosomal recessive [MIM: 616681]",
          "OMIM Entry": "616062",
          "Inheritance": "AR"
        },
        {
          "Gene": "ANO10",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 10 [MIM: 613728]",
          "OMIM Entry": "613726",
          "Inheritance": "AR"
        },
        {
          "Gene": "ANO3",
          "Phenotype MIM Number": "Dystonia 24 [MIM: 615034]",
          "OMIM Entry": "610110",
          "Inheritance": "AD"
        },
        {
          "Gene": "ANO5",
          "Phenotype MIM Number": "Gnathodiaphyseal dysplasia [MIM: 166260]; Miyoshi muscular dystrophy 3 [MIM: 613319]; Muscular dystrophy, limb-girdle, autosomal recessive 12 [MIM: 611307]",
          "OMIM Entry": "608662",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ANOS1",
          "Phenotype MIM Number": "Hypogonadotropic hypogonadism 1 with or without anosmia (Kallmann syndrome 1) [MIM: 308700]",
          "OMIM Entry": "300836",
          "Inheritance": "XLR"
        },
        {
          "Gene": "AP1S2",
          "Phenotype MIM Number": "Pettigrew syndrome [MIM: 304340]",
          "OMIM Entry": "300629",
          "Inheritance": "XLR"
        },
        {
          "Gene": "AP3B2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 48 [MIM: 617276]",
          "OMIM Entry": "602166",
          "Inheritance": "AR"
        },
        {
          "Gene": "AP3D1",
          "Phenotype MIM Number": "Hermansky-Pudlak syndrome 10 [MIM: 617050]",
          "OMIM Entry": "607246",
          "Inheritance": "AR"
        },
        {
          "Gene": "AP4B1",
          "Phenotype MIM Number": "Spastic paraplegia 47, autosomal recessive [MIM: 614066]",
          "OMIM Entry": "607245",
          "Inheritance": "AR"
        },
        {
          "Gene": "AP4E1",
          "Phenotype MIM Number": "Spastic paraplegia 51, autosomal recessive [MIM: 613744]; Stuttering, familial persistent, 1 [MIM: 184450]",
          "OMIM Entry": "607244",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "AP4M1",
          "Phenotype MIM Number": "Spastic paraplegia 50, autosomal recessive [MIM: 612936]",
          "OMIM Entry": "602296",
          "Inheritance": "AR"
        },
        {
          "Gene": "AP4S1",
          "Phenotype MIM Number": "Spastic paraplegia 52, autosomal recessive [MIM: 614067]",
          "OMIM Entry": "607243",
          "Inheritance": "AR"
        },
        {
          "Gene": "AP5Z1",
          "Phenotype MIM Number": "Spastic paraplegia 48, autosomal recessive [MIM: 613647]",
          "OMIM Entry": "613653",
          "Inheritance": "AR"
        },
        {
          "Gene": "APOB",
          "Phenotype MIM Number": "Hypercholesterolemia, familial, 2 [MIM: 144010]; Hypobetalipoproteinemia [MIM: 615558]",
          "OMIM Entry": "107730",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "APP",
          "Phenotype MIM Number": "Alzheimer disease 1, familial [MIM: 104300]; Cerebral amyloid angiopathy, Dutch, Italian, Iowa, Flemish, Arctic variants [MIM: 605714]",
          "OMIM Entry": "104760",
          "Inheritance": "AD"
        },
        {
          "Gene": "APTX",
          "Phenotype MIM Number": "Ataxia, early-onset, with oculomotor apraxia and hypoalbuminemia [MIM: 208920]",
          "OMIM Entry": "606350",
          "Inheritance": "AR"
        },
        {
          "Gene": "AR",
          "Phenotype MIM Number": "{Prostate cancer, susceptibility to} [MIM: 301120]; Androgen insensitivity [MIM: 300068]; Androgen insensitivity, partial, with or without breast cancer [MIM: 312300]; Hypospadias 1, X-linked [MIM: 300633]; Spinal and bulbar muscular atrophy, X-linked 1 [MIM: 313200]",
          "OMIM Entry": "313700",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "ARCN1",
          "Phenotype MIM Number": "Short stature-micrognathia syndrome [MIM: 617164]",
          "OMIM Entry": "600820",
          "Inheritance": "AD"
        },
        {
          "Gene": "ARFGEF2",
          "Phenotype MIM Number": "Periventricular heterotopia with microcephaly [MIM: 608097]",
          "OMIM Entry": "605371",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARG1",
          "Phenotype MIM Number": "Argininemia [MIM: 207800]",
          "OMIM Entry": "608313",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARL13B",
          "Phenotype MIM Number": "Joubert syndrome 8 [MIM: 612291]",
          "OMIM Entry": "608922",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARL6",
          "Phenotype MIM Number": "{Bardet-Biedl syndrome 1, modifier of} [MIM: 209900]; Bardet-Biedl syndrome 3 [MIM: 600151]; Retinitis pigmentosa 55 [MIM: 613575]",
          "OMIM Entry": "608845",
          "Inheritance": "AD, AR, DR"
        },
        {
          "Gene": "ARL6IP1",
          "Phenotype MIM Number": "Spastic paraplegia 61, autosomal recessive [MIM: 615685]",
          "OMIM Entry": "607669",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARMC9",
          "Phenotype MIM Number": "Joubert syndrome 30 [MIM: 617622]",
          "OMIM Entry": "617612",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARNT2",
          "Phenotype MIM Number": "Webb-Dattani syndrome [MIM: 615926]",
          "OMIM Entry": "606036",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARSA",
          "Phenotype MIM Number": "Metachromatic leukodystrophy [MIM: 250100]",
          "OMIM Entry": "607574",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARV1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 38 [MIM: 617020]",
          "OMIM Entry": "611647",
          "Inheritance": "AR"
        },
        {
          "Gene": "ARX",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 1 [MIM: 308350]; Hydranencephaly with abnormal genitalia [MIM:  300215]; Intellectual developmental disorder, X-linked 29 [MIM: 300419]; Lissencephaly, X-linked 2 [MIM:  300215]; Partington syndrome [MIM: 309510]; Proud syndrome [MIM: 300004]",
          "OMIM Entry": "300382",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "ASAH1",
          "Phenotype MIM Number": "Farber lipogranulomatosis [MIM: 228000]; Spinal muscular atrophy with progressive myoclonic epilepsy [MIM: 159950]",
          "OMIM Entry": "613468",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASCC1",
          "Phenotype MIM Number": "Barrett esophagus/esophageal adenocarcinoma [MIM: 614266]; Spinal muscular atrophy with congenital bone fractures 2 [MIM: 616867]",
          "OMIM Entry": "614215",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASCC3",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 81 [MIM: 620700]",
          "OMIM Entry": "614217",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASL",
          "Phenotype MIM Number": "Argininosuccinic aciduria [MIM: 207900]",
          "OMIM Entry": "608310",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASNS",
          "Phenotype MIM Number": "Asparagine synthetase deficiency [MIM: 615574]",
          "OMIM Entry": "108370",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASS1",
          "Phenotype MIM Number": "Citrullinemia [MIM: 215700]",
          "OMIM Entry": "603470",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATCAY",
          "Phenotype MIM Number": "Ataxia, cerebellar, Cayman type [MIM: 601238]",
          "OMIM Entry": "608179",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATG5",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 25 [MIM: 617584]",
          "OMIM Entry": "604261",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATL1",
          "Phenotype MIM Number": "Neuropathy, hereditary sensory, type ID [MIM: 613708]; Spastic paraplegia 3A, autosomal dominant [MIM: 182600]",
          "OMIM Entry": "606439",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATM",
          "Phenotype MIM Number": "{Breast cancer, susceptibility to} [MIM: 114480]; Ataxia-telangiectasia [MIM: 208900]; Lymphoma, B-cell non-Hodgkin, somatic; Lymphoma, mantle cell, somatic; T-cell prolymphocytic leukemia, somatic",
          "OMIM Entry": "607585",
          "Inheritance": "AD, AR, Smu"
        },
        {
          "Gene": "ATN1",
          "Phenotype MIM Number": "Congenital hypotonia, epilepsy, developmental delay, and digital anomalies [618494]; Dentatorubral-pallidoluysian atrophy [MIM: 125370]",
          "OMIM Entry": "607462",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATP13A2",
          "Phenotype MIM Number": "Kufor-Rakeb syndrome [MIM: 606693]; Spastic paraplegia 78, autosomal recessive [MIM: 617225]",
          "OMIM Entry": "610513",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATP1A2",
          "Phenotype MIM Number": "Alternating hemiplegia of childhood 1 [MIM: 104290]; Developmental and epileptic encephalopathy 98 [MIM: 619605]; Fetal akinesia, respiratory insufficiency, microcephaly, polymicrogyria, and dysmorphic facies [MIM: 619602]; Migraine, familial basilar [MIM: 602481]; Migraine, familial hemiplegic, 2 [MIM: 602481]",
          "OMIM Entry": "182340",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ATP1A3",
          "Phenotype MIM Number": "Alternating hemiplegia of childhood 2 [MIM: 614820]; CAPOS syndrome [MIM: 601338]; Developmental and epileptic encephalopathy 99 [MIM: 619606]; Dystonia-12 [MIM: 128235]",
          "OMIM Entry": "182350",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATP2A1",
          "Phenotype MIM Number": "Brody myopathy [MIM: 601003]",
          "OMIM Entry": "108730",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATP2B3",
          "Phenotype MIM Number": "Spinocerebellar ataxia, X-linked 1 [MIM: 302500]",
          "OMIM Entry": "300014",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ATP5F1E",
          "Phenotype MIM Number": "Mitochondrial complex V (ATP synthase) deficiency, nuclear type 3 [MIM: 614053]",
          "OMIM Entry": "606153",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATP6AP2",
          "Phenotype MIM Number": "Parkinsonism with spasticity, X-linked [MIM: 300911]; Congenital disorder of glycosylation, type IIr [MIM: 301045]; Intellectual developmental disorder, X-linked syndromic, Hedera type [MIM: 300423]",
          "OMIM Entry": "300556",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ATP7A",
          "Phenotype MIM Number": "Menkes disease [MIM: 309400]; Neuronopathy, distal hereditary motor, X-linked [MIM: 300489]; Occipital horn syndrome [MIM: 304150]",
          "OMIM Entry": "300011",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ATP7B",
          "Phenotype MIM Number": "Wilson disease [MIM: 277900]",
          "OMIM Entry": "606882",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATP8A2",
          "Phenotype MIM Number": "Cerebellar ataxia, impaired intellectual development, and dysequilibrium syndrome 4 [MIM: 615268]",
          "OMIM Entry": "605870",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATPAF2",
          "Phenotype MIM Number": "Mitochondrial complex V (ATP synthase) deficiency, nuclear type 1 [MIM: 604273]",
          "OMIM Entry": "608918",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATRX",
          "Phenotype MIM Number": "Alpha-thalassemia myelodysplasia syndrome, somatic [MIM: 300448]; Alpha-thalassemia/impaired intellectual development syndrome [MIM: 301040]; Intellectual disability-hypotonic facies syndrome, X-linked [MIM: 309580]",
          "OMIM Entry": "300032",
          "Inheritance": "XLD, XLR"
        },
        {
          "Gene": "ATXN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 1 [MIM: 164400]",
          "OMIM Entry": "601556",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN10",
          "Phenotype MIM Number": "Spinocerebellar ataxia 10 [MIM: 603516]",
          "OMIM Entry": "611150",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 2 [MIM: 183090]; {Amyotrophic lateral sclerosis susceptibility to 13} [MIM: 183090]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "601517",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN3",
          "Phenotype MIM Number": "Machado-Joseph disease [MIM: 109150]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "607047",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN7",
          "Phenotype MIM Number": "Spinocerebellar ataxia 7 [MIM: 164500]",
          "OMIM Entry": "607640",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN8/ATXN8OS",
          "Phenotype MIM Number": "Spinocerebellar ataxia 8 [MIM: 608768]; {Parkinson disease susceptibility to} [MIM: 168600]",
          "OMIM Entry": "613289; 603680",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "AUH",
          "Phenotype MIM Number": "3-methylglutaconic aciduria, type I [MIM: 250950]",
          "OMIM Entry": "600529",
          "Inheritance": "AR"
        },
        {
          "Gene": "B3GALNT2",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 11 [MIM; 615181]",
          "OMIM Entry": "610194",
          "Inheritance": "AR"
        },
        {
          "Gene": "B3GALT6",
          "Phenotype MIM Number": "l-Gazali syndrome [MIM: 609465]; Ehlers-Danlos syndrome, spondylodysplastic type, 2 [MIM: 615349]; Spondyloepimetaphyseal dysplasia with joint laxity, type 1, with or without fractures [MIM: 271640]",
          "OMIM Entry": "615291",
          "Inheritance": "AR"
        },
        {
          "Gene": "B4GALNT1",
          "Phenotype MIM Number": "Spastic paraplegia 26, autosomal recessive [MIM: 609195]",
          "OMIM Entry": "601873",
          "Inheritance": "AR"
        },
        {
          "Gene": "B4GAT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 13 [MIM: 615287]",
          "OMIM Entry": "605517",
          "Inheritance": "AR"
        },
        {
          "Gene": "B9D1",
          "Phenotype MIM Number": "Meckel syndrome 9 [MIM: 614209]; Joubert syndrome 27 [MIM: 617120]",
          "OMIM Entry": "614144",
          "Inheritance": "AR"
        },
        {
          "Gene": "BAG3",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal dominant 15 [MIM: 621094]; Cardiomyopathy, dilated, 1HH [MIM: 613381]; Charcot-Marie-Tooth disease, axonal, type 2JJ [MIM; 621095]; Myopathy, myofibrillar, 6 [MIM: 612954] ",
          "OMIM Entry": "603883",
          "Inheritance": "AD"
        },
        {
          "Gene": "BBS1",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 1 [MIM: 209900]",
          "OMIM Entry": "209901",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "BBS10",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 10 [MIM: 615987]",
          "OMIM Entry": "610148",
          "Inheritance": "AR"
        },
        {
          "Gene": "BBS12",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 12 [MIM: 615989]",
          "OMIM Entry": "610683",
          "Inheritance": "AR"
        },
        {
          "Gene": "BBS2",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 2 [MIM: 615981]; Retinitis pigmentosa 74 [MIM: 616562]",
          "OMIM Entry": "606151",
          "Inheritance": "AR"
        },
        {
          "Gene": "BBS4",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 4 [MIM: 615982]",
          "OMIM Entry": "600374",
          "Inheritance": "AR"
        },
        {
          "Gene": "BBS5",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 5 [MIM: 615983]",
          "OMIM Entry": "603650",
          "Inheritance": "AR"
        },
        {
          "Gene": "BBS7",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 7 [MIM: 615984]",
          "OMIM Entry": "607590",
          "Inheritance": "AR"
        },
        {
          "Gene": "BBS9",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 9 [MIM: 615986]",
          "OMIM Entry": "615986",
          "Inheritance": "AR"
        },
        {
          "Gene": "BCAP31",
          "Phenotype MIM Number": "Deafness, dystonia, and cerebral hypomyelination [MIM: 300475]",
          "OMIM Entry": "300398",
          "Inheritance": "XLR"
        },
        {
          "Gene": "BCKDHA",
          "Phenotype MIM Number": "Maple syrup urine disease, type Ia [MIM: 248600]",
          "OMIM Entry": "608348",
          "Inheritance": "AR"
        },
        {
          "Gene": "BCKDHB",
          "Phenotype MIM Number": "Maple syrup urine disease, type Ib [MIM: 620698]",
          "OMIM Entry": "248611",
          "Inheritance": "AR"
        },
        {
          "Gene": "BCL11B",
          "Phenotype MIM Number": "Immunodeficiency 49, severe combined [MIM: 617237]; Intellectual developmental disorder with dysmorphic facies, speech delay, and T-cell abnormalities [MIM: 618092]",
          "OMIM Entry": "606558",
          "Inheritance": "AD"
        },
        {
          "Gene": "BCOR",
          "Phenotype MIM Number": "Microphthalmia, syndromic 2 [MIM: 300166]",
          "OMIM Entry": "300485",
          "Inheritance": "XLD "
        },
        {
          "Gene": "BCS1L",
          "Phenotype MIM Number": "Bjornstad syndrome [MIM: 262000]; GRACILE syndrome [MIM: 603358]; Mitochondrial complex III deficiency, nuclear type 1 [MIM: 124000]",
          "OMIM Entry": "603647",
          "Inheritance": "AR"
        },
        {
          "Gene": "BEAN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 31 [MIM: 117210]",
          "OMIM Entry": "612051",
          "Inheritance": "AD"
        },
        {
          "Gene": "BICD2",
          "Phenotype MIM Number": "Spinal muscular atrophy, lower extremity-predominant, 2A, autosomal dominant [MIM: 615290]; Spinal muscular atrophy, lower extremity-predominant, 2B, autosomal dominant [MIM: 618291] ",
          "OMIM Entry": "609797",
          "Inheritance": "AD"
        },
        {
          "Gene": "BIN1",
          "Phenotype MIM Number": "Centronuclear myopathy 2 [MIM: 255200]",
          "OMIM Entry": "601248",
          "Inheritance": "AR"
        },
        {
          "Gene": "BOLA3",
          "Phenotype MIM Number": "Multiple mitochondrial dysfunctions syndrome 2 with hyperglycinemia [MIM: 614299]",
          "OMIM Entry": "613183",
          "Inheritance": "AR"
        },
        {
          "Gene": "BRAT1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with cerebellar atrophy and with or without seizures [MIM: 618056]; Rigidity and multifocal seizure syndrome, lethal neonatal [MIM: 614498]",
          "OMIM Entry": "614506",
          "Inheritance": "AR"
        },
        {
          "Gene": "BSCL2",
          "Phenotype MIM Number": "Encephalopathy, progressive, with or without lipodystrophy [MIM: 615942]; Lipodystrophy, congenital generalized, type 2 [MIM: 269700]; Neuronopathy, distal hereditary motor, autosomal dominant 13 [MIM: 619122]; Silver spastic paraplegia syndrome [MIM: 270685]",
          "OMIM Entry": "606158",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "BTD",
          "Phenotype MIM Number": "Biotinidase deficiency [MIM: 253260]",
          "OMIM Entry": "609019",
          "Inheritance": "AR"
        },
        {
          "Gene": "C19orf12",
          "Phenotype MIM Number": "Spastic paraplegia 43, autosomal recessive [MIM: 615043]; Neurodegeneration with brain iron accumulation 4 [MIM: 614298]",
          "OMIM Entry": "614297",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "C1QBP",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 33 [MIM: 617773]",
          "OMIM Entry": "601269",
          "Inheritance": "AR"
        },
        {
          "Gene": "C9orf72",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 1 [MIM: 105550]",
          "OMIM Entry": "614260",
          "Inheritance": "AD"
        },
        {
          "Gene": "CA8",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 34 [MIM: 613227]",
          "OMIM Entry": "114815",
          "Inheritance": "AR"
        },
        {
          "Gene": "CACNA1A",
          "Phenotype MIM Number": "Spinocerebellar ataxia 6 [MIM: 183086]",
          "OMIM Entry": "601011",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNA1B",
          "Phenotype MIM Number": "Neurodevelopmental disorder with seizures and nonepileptic hyperkinetic movements [MIM: 618497]",
          "OMIM Entry": "601012",
          "Inheritance": "AR"
        },
        {
          "Gene": "CACNA1D",
          "Phenotype MIM Number": "Primary aldosteronism, seizures, and neurologic abnormalities [MIM: 615474]; Sinoatrial node dysfunction and deafness [MIM: 614896]",
          "OMIM Entry": "114206",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CACNA1G",
          "Phenotype MIM Number": "Spinocerebellar ataxia 42 [MIM: 616795]; Spinocerebellar ataxia 42, early-onset, severe, with neurodevelopmental deficits [MIM: 618087]",
          "OMIM Entry": "604065",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNA1S",
          "Phenotype MIM Number": "{Malignant hyperthermia susceptibility 5} [MIM: 601887]; {Thyrotoxic periodic paralysis, susceptibility to, 1} [MIM: 188580]; Congenital myopathy 18 due to dihydropyridine receptor defect [MIM: 620246]; Hypokalemic periodic paralysis, type 1 [MIM: 170400]",
          "OMIM Entry": "114208",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CACNA2D2",
          "Phenotype MIM Number": "Cerebellar atrophy with seizures and variable developmental delay [MIM: 618501]",
          "OMIM Entry": "607082",
          "Inheritance": "AR"
        },
        {
          "Gene": "CACNB4",
          "Phenotype MIM Number": "Episodic ataxia, type 5 [MIM: 613855]; {Epilepsy, idiopathic generalized, susceptibility to, 9}  [MIM: 607682]; {Epilepsy, juvenile myoclonic, susceptibility to, 6} [MIM: 607682]",
          "OMIM Entry": "601949",
          "Inheritance": "AD"
        },
        {
          "Gene": "CAMTA1",
          "Phenotype MIM Number": "Cerebellar dysfunction with variable cognitive and behavioral abnormalities [MIM: 614756]",
          "OMIM Entry": "611501",
          "Inheritance": "AD"
        },
        {
          "Gene": "CAPN1",
          "Phenotype MIM Number": "Spastic paraplegia 76, autosomal recessive [MIM: 616907]",
          "OMIM Entry": "114220",
          "Inheritance": "AR"
        },
        {
          "Gene": "CAPN3",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 4 [MIM: 618129]; Muscular dystrophy, limb-girdle, autosomal recessive 1 [MIM: 253600]",
          "OMIM Entry": "114240",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 27 [MIM: 616672]",
          "OMIM Entry": "612800",
          "Inheritance": "AR"
        },
        {
          "Gene": "CASK",
          "Phenotype MIM Number": "FG syndrome 4 [MIM: 300422]; Intellectual developmental disorder and microcephaly with pontine and cerebellar hypoplasia [MIM: 300749]; Intellectual developmental disorder, with or without nystagmus [MIM: 300422]",
          "OMIM Entry": "300172",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "CASQ1",
          "Phenotype MIM Number": "Myopathy, vacuolar, with CASQ1 aggregates [MIM: 616231]",
          "OMIM Entry": "114250",
          "Inheritance": "AD"
        },
        {
          "Gene": "CAV1",
          "Phenotype MIM Number": "Lipodystrophy, congenital generalized, type 3 [MIM: 612526]; Lipodystrophy, familial partial, type 7 [MIM: 606721]; Pulmonary hypertension, primary, 3 [MIM: 615343]",
          "OMIM Entry": "601047",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CAV3",
          "Phenotype MIM Number": "Cardiomyopathy, familial hypertrophic [MIM: 192600]; Creatine phosphokinase, elevated serum [MIM: 123320]; Long QT syndrome 9 [MIM: 611818]; Myopathy, distal, Tateyama type [MIM: 614321]; Rippling muscle disease 2 [MIM: 606072]",
          "OMIM Entry": "601253",
          "Inheritance": "AD, DD"
        },
        {
          "Gene": "CAVIN1",
          "Phenotype MIM Number": "Lipodystrophy, congenital generalized, type 4 [MIM: 613327]",
          "OMIM Entry": "603198",
          "Inheritance": "AR"
        },
        {
          "Gene": "CC2D2A",
          "Phenotype MIM Number": "COACH syndrome 2 [MIM: 619111]; Joubert syndrome 9 [MIM: 612285]; Meckel syndrome 6 [MIM: 612284]; Retinitis pigmentosa 93 [MIM: 619845]",
          "OMIM Entry": "612013",
          "Inheritance": "AR"
        },
        {
          "Gene": "CCDC28B",
          "Phenotype MIM Number": "{Bardet-Biedl syndrome 1, modifier of} [MIM: 209900] ",
          "OMIM Entry": "610162",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CCDC78",
          "Phenotype MIM Number": "Centronuclear myopathy 4 [MIM: 614807]",
          "OMIM Entry": "614666",
          "Inheritance": "AD"
        },
        {
          "Gene": "CCDC88C",
          "Phenotype MIM Number": "Spinocerebellar ataxia 40 [MIM: 616053]; Hydrocephalus, congenital, 1 [MIM: 236600]",
          "OMIM Entry": "611204",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CCT5",
          "Phenotype MIM Number": "Neuropathy, hereditary sensory, with spastic paraplegia [MIM: 256840]",
          "OMIM Entry": "610150",
          "Inheritance": "AR"
        },
        {
          "Gene": "CDKL5",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 2 [MIM: 300672]",
          "OMIM Entry": "300203",
          "Inheritance": "XLD"
        },
        {
          "Gene": "CEP104",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 77 [MIM: 619988]; Joubert syndrome 25 [MIM: 616781]",
          "OMIM Entry": "616690",
          "Inheritance": "AR"
        },
        {
          "Gene": "CEP120",
          "Phenotype MIM Number": "Joubert syndrome 31 [MIM: 617761]; Short-rib thoracic dysplasia 13 with or without polydactyly [MIM: 616300]",
          "OMIM Entry": "613446",
          "Inheritance": "AR"
        },
        {
          "Gene": "CEP152",
          "Phenotype MIM Number": "Microcephaly 9, primary, autosomal recessive [MIM: 614852]; Seckel syndrome 5 [MIM: 613823]",
          "OMIM Entry": "613529",
          "Inheritance": "AR"
        },
        {
          "Gene": "CEP290",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 14 [MIM: 615991]; Joubert syndrome 5 [MIM: 610188]; Leber congenital amaurosis 10 [MIM: 611755]; Meckel syndrome 4 [MIM: 611134]; Senior-Loken syndrome 6 [MIM: 610189]",
          "OMIM Entry": "610142",
          "Inheritance": "AR"
        },
        {
          "Gene": "CEP41",
          "Phenotype MIM Number": "Joubert syndrome 15 [MIM: 614464]",
          "OMIM Entry": "610523",
          "Inheritance": "AR"
        },
        {
          "Gene": "CFH",
          "Phenotype MIM Number": "{Hemolytic uremic syndrome, atypical, susceptibility to, 1} [MIM: 235400]; {Macular degeneration, age-related, 4} [MIM: 610698]; Basal laminar drusen [MIM: 126700]; Complement factor H deficiency [MIM: 609814]",
          "OMIM Entry": "134370",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CFL2",
          "Phenotype MIM Number": "Nemaline myopathy 7, autosomal recessive [MIM 610687]",
          "OMIM Entry": "601443",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHAMP1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with hypotonia, impaired language, and dysmorphic features [MIM: 616579]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "CHAT",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 6, presynaptic [MIM: 254210]",
          "OMIM Entry": "118490",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHCHD10",
          "Phenotype MIM Number": "Myopathy, isolated mitochondrial, autosomal dominant [MIM: 616209]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 2 [MIM: 615911]; Spinal muscular atrophy, Jokela type [MIM: 615048]",
          "OMIM Entry": "615903",
          "Inheritance": "AD"
        },
        {
          "Gene": "CHKB",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, megaconial type [MIM: 602541]",
          "OMIM Entry": "612395",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHMP1A",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 8 [MIM: 614961]",
          "OMIM Entry": "164010",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHMP2B",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 7 [MIM: 600795]",
          "OMIM Entry": "609512",
          "Inheritance": "AD"
        },
        {
          "Gene": "CHP1",
          "Phenotype MIM Number": "Spastic ataxia 9, autosomal recessive [MIM: 618438]",
          "OMIM Entry": "606988",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHRNA1",
          "Phenotype MIM Number": "Multiple pterygium syndrome, lethal type [MIM: 253290]; Myasthenic syndrome, congenital, 1A, slow-channel [MIM: 601462]; Myasthenic syndrome, congenital, 1B, fast-channel [MIM: 608930]",
          "OMIM Entry": "100690",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRNB1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 2C, associated with acetylcholine receptor deficiency [MIM: 616314]; Myasthenic syndrome, congenital, 2A, slow-channel [MIM: 616313]",
          "OMIM Entry": "100710",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRND",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 3A, slow-channel [MIM: 616321]; Myasthenic syndrome, congenital, 3C, associated with acetylcholine receptor deficiency [MIM: 616323]; Multiple pterygium syndrome, lethal type [MIM: 253290]; Myasthenic syndrome, congenital, 3B, fast-channel [MIM: 616322]",
          "OMIM Entry": "100720",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRNE",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 4A, slow-channel [MIM: 605809]; Myasthenic syndrome, congenital, 4B, fast-channel [MIM: 616324]; Myasthenic syndrome, congenital, 4C, associated with acetylcholine receptor deficiency [MIM: 608931]",
          "OMIM Entry": "100725",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRNG",
          "Phenotype MIM Number": "Escobar syndrome [MIM: 265000] Multiple pterygium syndrome, lethal type [MIM: 253290]",
          "OMIM Entry": "100730",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHST14",
          "Phenotype MIM Number": "Ehlers-Danlos syndrome, musculocontractural type 1 [MIM: 601776]",
          "OMIM Entry": "608429",
          "Inheritance": "AR"
        },
        {
          "Gene": "CIT",
          "Phenotype MIM Number": "Microcephaly 17, primary, autosomal recessive [MIM: 617090]",
          "OMIM Entry": "605629",
          "Inheritance": "AR"
        },
        {
          "Gene": "CKAP2L",
          "Phenotype MIM Number": "Filippi syndrome [MIM: 272440]",
          "OMIM Entry": "616174",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLCN1",
          "Phenotype MIM Number": "Myotonia congenita, dominant [MIM: 160880]; Myotonia congenita, recessive [MIM: 255700]; Myotonia levior [MIM: 160800]",
          "OMIM Entry": "118425",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CLCN2",
          "Phenotype MIM Number": "{Epilepsy, idiopathic generalized, susceptibility to, 11} [MIM: 607628]; {Epilepsy, juvenile absence, susceptibility to, 2} [MIM: 607628]; {Epilepsy, juvenile myoclonic, susceptibility to, 8} [MIM: 607628];  Hyperaldosteronism, familial, type II [MIM: 605635]; Leukoencephalopathy with ataxia [MIM: 615651]",
          "OMIM Entry": "600570",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CLN3",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 3 [MIM: 204200]",
          "OMIM Entry": "607042",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLN5",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 5 [MIM: 256731]",
          "OMIM Entry": "608102",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLN6",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 6A [MIM: 601780]; Ceroid lipofuscinosis, neuronal, 6B (Kufs type) [MIM: 204300]",
          "OMIM Entry": "606725",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLN8",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 8 [MIM: 600143]; Ceroid lipofuscinosis, neuronal, 8, Northern epilepsy variant [MIM: 610003]",
          "OMIM Entry": "607837",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLP1",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 10 [MIM: 615803]",
          "OMIM Entry": "608757",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLPB",
          "Phenotype MIM Number": "3-methylglutaconic aciduria, type VIIA, autosomal dominant [MIM: 619835]; 3-methylglutaconic aciduria, type VIIB, autosomal recessive [MIM: 616271]; Neutropenia, severe congenital, 9, autosomal dominant [MIM: 619813]",
          "OMIM Entry": "616254",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CLPP",
          "Phenotype MIM Number": "Perrault syndrome 3 [MIM: 614129]",
          "OMIM Entry": "601119",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLTC",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal dominant 56 [MIM: 617854]",
          "OMIM Entry": "118955",
          "Inheritance": "AD"
        },
        {
          "Gene": "CNBP",
          "Phenotype MIM Number": "Myotonic dystrophy 2 [MIM: 602668]",
          "OMIM Entry": "116955",
          "Inheritance": "AD"
        },
        {
          "Gene": "CNTN1",
          "Phenotype MIM Number": "Congenital myopathy 12 [MIM: 612540]",
          "OMIM Entry": "600016",
          "Inheritance": "AR"
        },
        {
          "Gene": "CNTN2",
          "Phenotype MIM Number": "Epilepsy, early-onset, 5, with or without developmental delay [MIM: 615400]",
          "OMIM Entry": "190197",
          "Inheritance": "AR"
        },
        {
          "Gene": "CNTNAP1",
          "Phenotype MIM Number": "Hypomyelinating neuropathy, congenital, 3 [MIM: 618186]; Lethal congenital contracture syndrome 7 [MIM: 616286]",
          "OMIM Entry": "602346",
          "Inheritance": "AR"
        },
        {
          "Gene": "CNTNAP2",
          "Phenotype MIM Number": "{Autism susceptibility 15} [MIM: 612100]; Pitt-Hopkins like syndrome 1 [MIM: 610042]",
          "OMIM Entry": "604569",
          "Inheritance": "AR"
        },
        {
          "Gene": "COA3",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 14 [MIM: 619058]",
          "OMIM Entry": "614775",
          "Inheritance": "AR"
        },
        {
          "Gene": "COA7",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 3 [MIM: 618387]",
          "OMIM Entry": "615623",
          "Inheritance": "AR"
        },
        {
          "Gene": "COA8",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 17 [MIM: 619061]",
          "OMIM Entry": "616003",
          "Inheritance": "AR"
        },
        {
          "Gene": "COASY",
          "Phenotype MIM Number": "Neurodegeneration with brain iron accumulation 6 [MIM: 615643]; Pontocerebellar hypoplasia, type 12 [MIM: 618266]",
          "OMIM Entry": "609855",
          "Inheritance": "AR"
        },
        {
          "Gene": "COG2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type IIq [MIM: 617395] ",
          "OMIM Entry": "606974",
          "Inheritance": "AR"
        },
        {
          "Gene": "COG4",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Iij [MIM: 613489]; Saul-Wilson syndrome [MIM: 618150]",
          "OMIM Entry": "606976",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COG5",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Iii [MIM: 613612]",
          "OMIM Entry": "606821",
          "Inheritance": "AR"
        },
        {
          "Gene": "COL12A1",
          "Phenotype MIM Number": "Ullrich congenital muscular dystrophy 2 [mim: 616470]; Bethlem myopathy 2 [MIM: 616471]",
          "OMIM Entry": "120320",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL13A1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 19 [MIM: 616720]",
          "OMIM Entry": "120350",
          "Inheritance": "AR"
        },
        {
          "Gene": "COL18A1",
          "Phenotype MIM Number": "Glaucoma, primary closed-angle [MIM: 618880]; Knobloch syndrome, type 1 [MIM: 267750]",
          "OMIM Entry": "120328",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "COL25A1",
          "Phenotype MIM Number": "Fibrosis of extraocular muscles, congenital, 5 [MIM: 616219]",
          "OMIM Entry": "610004",
          "Inheritance": "AR"
        },
        {
          "Gene": "COL4A1",
          "Phenotype MIM Number": "Retinal arteries, tortuosity of [MIM: 180000]; {Hemorrhage, intracerebral, susceptibility to} [MIM: 614519]; Angiopathy, hereditary, with nephropathy, aneurysms, and muscle cramps [MIM: 611773]; Brain small vessel disease with or without ocular anomalies [MIM: 175780]; Microangiopathy and leukoencephalopathy, pontine, autosomal dominant [MIM: 618564]",
          "OMIM Entry": "120130",
          "Inheritance": "AD"
        },
        {
          "Gene": "COL4A2",
          "Phenotype MIM Number": "{Hemorrhage, intracerebral, susceptibility to} [MIM: 614519]; Brain small vessel disease 2A, autosomal dominant [MIM: 614483]; Brain small vessel disease 2B, autosomal recessive [MIM: 621414]",
          "OMIM Entry": "120090",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL6A1",
          "Phenotype MIM Number": "Bethlem myopathy 1A [MIM: 158810]; Ullrich congenital muscular dystrophy 1A [MIM: 254090]",
          "OMIM Entry": "120220",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL6A2",
          "Phenotype MIM Number": "Myosclerosis, congenital [MIM: 255600]; Bethlem myopathy 1B [MIM: 620725]; Ullrich congenital muscular dystrophy 1B [MIM: 620727]",
          "OMIM Entry": "120240",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL6A3",
          "Phenotype MIM Number": "Bethlem myopathy 1C [MIM: 620726]; Dystonia 27 [MIM; 616411]; Ullrich congenital muscular dystrophy 1C [MIM: 620728]",
          "OMIM Entry": "120250",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COLQ",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 5 [MIM: 603034]",
          "OMIM Entry": "603033",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ2",
          "Phenotype MIM Number": "{Multiple system atrophy, susceptibility to} [MIM: 146500]; Coenzyme Q10 deficiency, primary, 1 [MIM: 607426]",
          "OMIM Entry": "609825",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COQ4",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 7 [MIM: 616276]; Spastic ataxia 10, autosomal recessive [MIM: 620666]",
          "OMIM Entry": "612898",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ5",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 9 (MIM: 619028]",
          "OMIM Entry": "616359",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ6",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 6 [MIM: 614650]",
          "OMIM Entry": "614647",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ7",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 8 [MIM: 616733]; Neuronopathy, distal hereditary motor, autosomal recessive 9 [MIM: 620402]",
          "OMIM Entry": "601683",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ8A",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 4 [MIM: 612016]",
          "OMIM Entry": "606980",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ9",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 5 [MIM: 614654]",
          "OMIM Entry": "612837",
          "Inheritance": "AR"
        },
        {
          "Gene": "COX10",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 3 [MIM: 619046]",
          "OMIM Entry": "602125",
          "Inheritance": "AR"
        },
        {
          "Gene": "COX14",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 10 [MIM: 619053]",
          "OMIM Entry": "614478",
          "Inheritance": "AR"
        },
        {
          "Gene": "COX15",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 6 [MIM: 615119]",
          "OMIM Entry": "603646",
          "Inheritance": "AR"
        },
        {
          "Gene": "COX20",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 11 [MIM: 619054]",
          "OMIM Entry": "614698",
          "Inheritance": "AR"
        },
        {
          "Gene": "COX6B1",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 7 [MIM: 619051]",
          "OMIM Entry": "124089",
          "Inheritance": "AR"
        },
        {
          "Gene": "COX8A",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 15 [MIM: 619059]",
          "OMIM Entry": "123870",
          "Inheritance": "AR"
        },
        {
          "Gene": "COXFA4",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 21 [MIM: 619065]",
          "OMIM Entry": "603833",
          "Inheritance": "AR"
        },
        {
          "Gene": "CP",
          "Phenotype MIM Number": "Aceruloplasminemia [MIM: 604290]",
          "OMIM Entry": "117700",
          "Inheritance": "AR"
        },
        {
          "Gene": "CPLANE1",
          "Phenotype MIM Number": "Joubert syndrome 17 [MIM: 614615]; Orofaciodigital syndrome VI [MIM: 277170]",
          "OMIM Entry": "614571",
          "Inheritance": "AR"
        },
        {
          "Gene": "CPS1",
          "Phenotype MIM Number": "Carbamoylphosphate synthetase I deficiency [MIM: 237300]",
          "OMIM Entry": "608307",
          "Inheritance": "AR"
        },
        {
          "Gene": "CPT1C",
          "Phenotype MIM Number": "Spastic paraplegia 73, autosomal dominant [MIM: 616282]",
          "OMIM Entry": "608846",
          "Inheritance": "AD"
        },
        {
          "Gene": "CPT2",
          "Phenotype MIM Number": "{Encephalopathy, acute, infection-induced, 4, susceptibility to} [MIM: 614212]; CPT II deficiency, infantile [MIM: 600649]; CPT II deficiency, lethal neonatal [MIM: 608836]; CPT II deficiency, myopathic, stress-induced [MIM: 255110]",
          "OMIM Entry": "600650",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CREBBP",
          "Phenotype MIM Number": "Menke-Hennekam syndrome 1 [MIM: 618332]; Rubinstein-Taybi syndrome 1 [MIM: 180849]",
          "OMIM Entry": "600140",
          "Inheritance": "AD"
        },
        {
          "Gene": "CRLF1",
          "Phenotype MIM Number": "Cold-induced sweating syndrome 1 [MIM: 272430]",
          "OMIM Entry": "604237",
          "Inheritance": "AR"
        },
        {
          "Gene": "CRPPA",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 7 [MIM: 614643]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 7 [MIM: 616052]",
          "OMIM Entry": "614631",
          "Inheritance": "AR"
        },
        {
          "Gene": "CRYAB",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1II [MIM: 615184]; Cataract 16, multiple types [MIM: 613763]; Myopathy, myofibrillar, 2A, adult-onset [MIM: 608810]; Myopathy, myofibrillar, 2B, infantile-onset [MIM: 613869]",
          "OMIM Entry": "123590",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CSF1R",
          "Phenotype MIM Number": "Brain abnormalities, neurodegeneration, and dysosteosclerosis [MIM: 618476]; Leukoencephalopathy, diffuse hereditary, with spheroids 1 [MIM: 221820]",
          "OMIM Entry": "164770",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CSPP1",
          "Phenotype MIM Number": "Joubert syndrome 21 [MIM: 615636]",
          "OMIM Entry": "611654",
          "Inheritance": "AR"
        },
        {
          "Gene": "CSTB",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 1A (Unverricht and Lundborg) [MIM: 254800]",
          "OMIM Entry": "601145",
          "Inheritance": "AR"
        },
        {
          "Gene": "CTBP1",
          "Phenotype MIM Number": "Hypotonia, ataxia, developmental delay, and tooth enamel defect syndrome [MIM: 617915]",
          "OMIM Entry": "602618",
          "Inheritance": "AD"
        },
        {
          "Gene": "CTC1",
          "Phenotype MIM Number": "Cerebroretinal microangiopathy with calcifications and cysts [MIM: 612199]",
          "OMIM Entry": "613129",
          "Inheritance": "AR"
        },
        {
          "Gene": "CTDP1",
          "Phenotype MIM Number": "Congenital cataracts, facial dysmorphism, and neuropathy [MIM: 604168]",
          "OMIM Entry": "604927",
          "Inheritance": "AR"
        },
        {
          "Gene": "CTNNB1",
          "Phenotype MIM Number": "Colorectal cancer, somatic [MIM: 114500]; Exudative vitreoretinopathy 7 [MIM: 617572]; Hepatocellular carcinoma, somatic [MIM: 114550]; Medulloblastoma, somatic [MIM: 155255]; Neurodevelopmental disorder with spastic diplegia and visual defects [MIM: 615075]; Ovarian cancer, somatic [MIM: 167000]; Pilomatricoma, somatic [MIM: 132600]",
          "OMIM Entry": "116806",
          "Inheritance": "AD"
        },
        {
          "Gene": "CTSD",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 10 [MIM: 610127]",
          "OMIM Entry": "116840",
          "Inheritance": "AR"
        },
        {
          "Gene": "CTSF",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 13 (Kufs type) [MIM: 615362]",
          "OMIM Entry": "603539",
          "Inheritance": "AR"
        },
        {
          "Gene": "CUL4B",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Cabezas type [MIM: 300354]",
          "OMIM Entry": "300304",
          "Inheritance": "XLR"
        },
        {
          "Gene": "CWF19L1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 17 [MIM: 616127]",
          "OMIM Entry": "616120",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYB5R3",
          "Phenotype MIM Number": "Methemoglobinemia, type I [MIM: 250800]; Methemoglobinemia, type II [MIM: 250800]",
          "OMIM Entry": "613213",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYC1",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 6 [MIM: 615453]",
          "OMIM Entry": "123980",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYP27A1",
          "Phenotype MIM Number": "Cerebrotendinous xanthomatosis [MIM: 213700]",
          "OMIM Entry": "606530",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYP2U1",
          "Phenotype MIM Number": "Spastic paraplegia 56, autosomal recessive [MIM: 615030]",
          "OMIM Entry": "610670",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYP7B1 ",
          "Phenotype MIM Number": "Bile acid synthesis defect, congenital, 3 [MIM: 613812]; Spastic paraplegia 5A, autosomal recessive [MIM: 270800]",
          "OMIM Entry": "603711",
          "Inheritance": "AR"
        },
        {
          "Gene": "DAB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 37 [MIM: 615945]",
          "OMIM Entry": "603448",
          "Inheritance": "AD"
        },
        {
          "Gene": "DAG1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 9 [MIM: 616538]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 9 [MIM: 613818]",
          "OMIM Entry": "128239",
          "Inheritance": "AR"
        },
        {
          "Gene": "DARS1",
          "Phenotype MIM Number": "Hypomyelination with brainstem and spinal cord involvement and leg spasticity [MIM: 615281]",
          "OMIM Entry": "603084",
          "Inheritance": "AR"
        },
        {
          "Gene": "DARS2",
          "Phenotype MIM Number": "Leukoencephalopathy with brain stem and spinal cord involvement and lactate elevation [MIM: 611105]",
          "OMIM Entry": "610956",
          "Inheritance": "AR"
        },
        {
          "Gene": "DBT",
          "Phenotype MIM Number": "Maple syrup urine disease, type II [MIM: 620699]",
          "OMIM Entry": "248610",
          "Inheritance": "AR"
        },
        {
          "Gene": "DCAF17",
          "Phenotype MIM Number": "Woodhouse-Sakati syndrome [MIM: 241080]",
          "OMIM Entry": "612515",
          "Inheritance": "AR"
        },
        {
          "Gene": "DCC",
          "Phenotype MIM Number": "Colorectal cancer, somatic [MIM: 114500]; Esophageal carcinoma, somatic [MIM: 133239]; Gaze palsy, familial horizontal, with progressive scoliosis, 2 [MIM: 617542]; Mirror movements 1 and/or agenesis of the corpus callosum [MIM:157600]",
          "OMIM Entry": "120470",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DCPS",
          "Phenotype MIM Number": "Al-Raqad syndrome [MIM: 616459]",
          "OMIM Entry": "610534",
          "Inheritance": "AR"
        },
        {
          "Gene": "DCTN1",
          "Phenotype MIM Number": "{Amyotrophic lateral sclerosis, susceptibility to} [MIM: 105400]; Neuronopathy, distal hereditary motor, autosomal dominant 14 [MIM: 607641]; perry syndrome [MIM: 168605]",
          "OMIM Entry": "601143",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DCX",
          "Phenotype MIM Number": "Lissencephaly, X-linked [MIM: 300067]; Subcortical laminal heterotopia, X-linked [MIM: 300067]",
          "OMIM Entry": "300121",
          "Inheritance": "XL"
        },
        {
          "Gene": "DDC",
          "Phenotype MIM Number": "Aromatic L-amino acid decarboxylase deficiency [MIM: 608643]",
          "OMIM Entry": "107930",
          "Inheritance": "AR"
        },
        {
          "Gene": "DDHD1",
          "Phenotype MIM Number": "Spastic paraplegia 28, autosomal recessive [MIM: 609340]",
          "OMIM Entry": "614603",
          "Inheritance": "AR"
        },
        {
          "Gene": "DDHD2",
          "Phenotype MIM Number": "Spastic paraplegia 54, autosomal recessive [MIM: 615033]",
          "OMIM Entry": "615003",
          "Inheritance": "AR"
        },
        {
          "Gene": "DDX3X",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Snijders Blok type [MIM: 300958]",
          "OMIM Entry": "300160",
          "Inheritance": "XLD, XLR"
        },
        {
          "Gene": "DEAF1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with hypotonia, impaired expressive language, and with or without seizures [MIM: 617171]; Vulto-van Silfout-de Vries syndrome [MIM: 615828]",
          "OMIM Entry": "602635",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DES",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1I [MIM: 604765]; Myopathy, myofibrillar, 1 [MIM: 601419]; Scapuloperoneal syndrome, neurogenic, Kaeser type [MIM: 181400]",
          "OMIM Entry": "125660",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DHCR24",
          "Phenotype MIM Number": "Desmosterolosis [MIM: 602398]",
          "OMIM Entry": "606418",
          "Inheritance": "AR"
        },
        {
          "Gene": "DHFR",
          "Phenotype MIM Number": "Megaloblastic anemia due to dihydrofolate reductase deficiency [MIM: 613839]",
          "OMIM Entry": "126060",
          "Inheritance": "AR"
        },
        {
          "Gene": "DHPS",
          "Phenotype MIM Number": "Neurodevelopmental disorder with seizures and speech and walking impairment [MIM: 618480]",
          "OMIM Entry": "600944",
          "Inheritance": "AR"
        },
        {
          "Gene": "DKC1",
          "Phenotype MIM Number": "Cataracts, hearing impairment, nephrotic syndrome, and enterocolitis 1  [MIM: 301108]; Dyskeratosis congenita, X-linked [MIM: 305000]",
          "OMIM Entry": "300126",
          "Inheritance": "XLD, XLR"
        },
        {
          "Gene": "DLAT",
          "Phenotype MIM Number": "Pyruvate dehydrogenase E2 deficiency [MIM: 245348]",
          "OMIM Entry": "608770",
          "Inheritance": "AR"
        },
        {
          "Gene": "DLD",
          "Phenotype MIM Number": "Dihydrolipoamide dehydrogenase deficiency [MIM: 246900]",
          "OMIM Entry": "238331",
          "Inheritance": "AR"
        },
        {
          "Gene": "DMD",
          "Phenotype MIM Number": "Becker muscular dystrophy [MIM: 300376]; Cardiomyopathy, dilated, 3B [MIM: 302045]; Duchenne muscular dystrophy [MIM: 310200]",
          "OMIM Entry": "300377",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "DMPK",
          "Phenotype MIM Number": "Myotonic dystrophy 1 [MIM: 160900]",
          "OMIM Entry": "605377",
          "Inheritance": "AD"
        },
        {
          "Gene": "DMXL2",
          "Phenotype MIM Number": "Deafness, autosomal dominant 71 [MIM: 617605]; Polyendocrine-polyneuropathy syndrome [MIM: 616113]; Developmental and epileptic encephalopathy 81 [MIM: 618663]",
          "OMIM Entry": "612186",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DNA2",
          "Phenotype MIM Number": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 6 [MIM: 615156]; Rothmund-Thomson syndrome, type 4 [MIM: 620819]; Seckel syndrome 8 [MIM: 615807]",
          "OMIM Entry": "601810",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DNAJB2",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal recessive 5 [MIM: 614881]",
          "OMIM Entry": "604139",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNAJB4",
          "Phenotype MIM Number": "Congenital myopathy 21 with early respiratory failure [MIM: 620326]",
          "OMIM Entry": "611327",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNAJB6",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 1 [MIM: 603511]",
          "OMIM Entry": "611332",
          "Inheritance": "AD"
        },
        {
          "Gene": "DNAJC12",
          "Phenotype MIM Number": "Hyperphenylalaninemia, mild, non-BH4-deficient [MIM: 617384]",
          "OMIM Entry": "606060",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNAJC19",
          "Phenotype MIM Number": "3-methylglutaconic aciduria, type V [MIM: 610198]",
          "OMIM Entry": "608977",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNAJC3",
          "Phenotype MIM Number": "Ataxia, combined cerebellar and peripheral, with hearing loss and diabetes mellitus [MIM: 616192]",
          "OMIM Entry": "601184",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNAJC5",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 4 (Kufs type), autosomal dominant [MIM: 162350]",
          "OMIM Entry": "611203",
          "Inheritance": "AD"
        },
        {
          "Gene": "DNAJC6",
          "Phenotype MIM Number": "Parkinson disease 19a, juvenile-onset [MIM: 615528]; Parkinson disease 19b, early-onset [MIM: 615528]",
          "OMIM Entry": "608375",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNM1L",
          "Phenotype MIM Number": "Encephalopathy, lethal, due to defective mitochondrial peroxisomal fission 1 [MIM: 614388]; Optic atrophy 5 [MIM: 610708]",
          "OMIM Entry": "603850",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DNM2",
          "Phenotype MIM Number": "Centronuclear myopathy 1 [MIM: 160150]; Charcot-Marie-Tooth disease, axonal type 2M [MIM: 606482]; Charcot-Marie-Tooth disease, dominant intermediate B [MIM: 606482]; Lethal congenital contracture syndrome 5 [MIM; 615368]",
          "OMIM Entry": "602378",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DNMT1",
          "Phenotype MIM Number": "Cerebellar ataxia, deafness, and narcolepsy, autosomal dominant [MIM: 604121]; Neuropathy, hereditary sensory, type IE [MIM: 614116]",
          "OMIM Entry": "126375",
          "Inheritance": "AD"
        },
        {
          "Gene": "DOCK3",
          "Phenotype MIM Number": "Neurodevelopmental disorder with impaired intellectual development, hypotonia, and ataxia [MIM: 618292]",
          "OMIM Entry": "603123",
          "Inheritance": "AR"
        },
        {
          "Gene": "DOCK8",
          "Phenotype MIM Number": "Hyper-IgE syndrome 2, autosomal recessive, with recurrent infections [MIM: 243700]",
          "OMIM Entry": "611432",
          "Inheritance": "AR"
        },
        {
          "Gene": "DOK7",
          "Phenotype MIM Number": "Fetal akinesia deformation sequence 3 [MIM: 618389]; Myasthenic syndrome, congenital, 10 [MIM: 254300]",
          "OMIM Entry": "610285",
          "Inheritance": "AR"
        },
        {
          "Gene": "DOLK",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Im [MIM: 610768]",
          "OMIM Entry": "610746",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPAGT1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ij [MIM: 608093]; Myasthenic syndrome, congenital, 13, with tubular aggregates [MIM: 614750]",
          "OMIM Entry": "191350",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPM1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ie [MIM: 608799]",
          "OMIM Entry": "603503",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPM2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Iu [MIM: 615042]",
          "OMIM Entry": "603564",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPM3",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 15 [MIM: 618992]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 15 [MIM: 612937]",
          "OMIM Entry": "605951",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPYD",
          "Phenotype MIM Number": "5-fluorouracil toxicity [MIM: 274270]; Dihydropyrimidine dehydrogenase deficiency [MIM: 274270]",
          "OMIM Entry": "612779",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPYS",
          "Phenotype MIM Number": "Dihydropyrimidinuria [MIM: 222748]",
          "OMIM Entry": "613326",
          "Inheritance": "AR"
        },
        {
          "Gene": "DRD3",
          "Phenotype MIM Number": "{Essential tremor, hereditary, 1} [MIM: 190300]; {Schizophrenia, susceptibility to} [MIM: 181500]",
          "OMIM Entry": "126451",
          "Inheritance": "AD"
        },
        {
          "Gene": "DRD5",
          "Phenotype MIM Number": "{Attention deficit-hyperactivity disorder, susceptibility to} [MIM: 143465]; {Blepharospasm, primary benign} [MIM: 606798]",
          "OMIM Entry": "126453",
          "Inheritance": "AD"
        },
        {
          "Gene": "DTNA",
          "Phenotype MIM Number": "Left ventricular noncompaction 1, with or without congenital heart defects [MIM: 604169]; Myopathy with myalgia, increased serum creatine kinase, and with or without episodic rhabdomyolysis 2 [MIM: 620971]",
          "OMIM Entry": "601239",
          "Inheritance": "AD"
        },
        {
          "Gene": "DYNC1H1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2O [MIM: 614228]; Cortical dysplasia, complex, with other brain malformations 13 [MIM: 614563]; Spinal muscular atrophy, lower extremity-predominant 1, AD [MIM: 158600]",
          "OMIM Entry": "600112",
          "Inheritance": "AD"
        },
        {
          "Gene": "DYRK1A",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal dominant 7 [MIM: 614104]",
          "OMIM Entry": "600855",
          "Inheritance": "AD"
        },
        {
          "Gene": "DYSF",
          "Phenotype MIM Number": "Miyoshi muscular dystrophy 1 [MIM: 254130]; Muscular dystrophy, limb-girdle, autosomal recessive 2 [MIM: 253601]; Myopathy, distal, with anterior tibial onset [MIM: 606768]",
          "OMIM Entry": "603009",
          "Inheritance": "AR"
        },
        {
          "Gene": "EARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 12 [MIM: 614924]",
          "OMIM Entry": "612799",
          "Inheritance": "AR"
        },
        {
          "Gene": "EBF3",
          "Phenotype MIM Number": "Hypotonia, ataxia, and delayed development syndrome [MIM: 617330]",
          "OMIM Entry": "607407",
          "Inheritance": "AD"
        },
        {
          "Gene": "ECEL1",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 5D [MIM: 615065]",
          "OMIM Entry": "605896",
          "Inheritance": "AR"
        },
        {
          "Gene": "ECHS1",
          "Phenotype MIM Number": "Mitochondrial short-chain enoyl-CoA hydratase 1 deficiency [MIM: 616277]",
          "OMIM Entry": "602292",
          "Inheritance": "AR"
        },
        {
          "Gene": "EEF2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 26 [MIM: 609306]",
          "OMIM Entry": "130610",
          "Inheritance": "ad"
        },
        {
          "Gene": "EGR2",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 1D [MIM: 607678]; Dejerine-Sottas disease [MIM: 145900]; Hypomyelinating neuropathy, congenital, 1 [MIM: 605253]",
          "OMIM Entry": "129010",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "EIF2B1",
          "Phenotype MIM Number": "Leukoencephalopathy with vanishing white matter 1, with or without ovarian failure [MIM: 603896]",
          "OMIM Entry": "606686",
          "Inheritance": "AR"
        },
        {
          "Gene": "EIF2B2",
          "Phenotype MIM Number": "Leukoencephalopathy with vanishing white matter 2, with or without ovarian failure [MIM: 620312]",
          "OMIM Entry": "606454",
          "Inheritance": "AR"
        },
        {
          "Gene": "EIF2B3",
          "Phenotype MIM Number": "Leukoencephalopathy with vanishing white matter 3, with or without ovarian failure [MIM: 620313]",
          "OMIM Entry": "606273",
          "Inheritance": "AR"
        },
        {
          "Gene": "EIF2B4",
          "Phenotype MIM Number": "Leukoencephalopathy with vanishing white matter 4, with or without ovarian failure [MIM: 620314]",
          "OMIM Entry": "606687",
          "Inheritance": "AR"
        },
        {
          "Gene": "EIF2B5",
          "Phenotype MIM Number": "Leukoencephalopathy with vanishing white matter 5, with or without ovarian failure [MIM: 620315]",
          "OMIM Entry": "603945",
          "Inheritance": "AR"
        },
        {
          "Gene": "EIF4G1",
          "Phenotype MIM Number": "{Parkinson disease 18} [MIM: 614251]",
          "OMIM Entry": "600495",
          "Inheritance": "AD"
        },
        {
          "Gene": "ELOVL1",
          "Phenotype MIM Number": "Ichthyotic keratoderma, spasticity, hypomyelination, and dysmorphic facies [MIM: 618527]",
          "OMIM Entry": "611813",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ELOVL4",
          "Phenotype MIM Number": "Ichthyosis, spastic quadriplegia, and impaired intellectual development [MIM: 614457]; Spinocerebellar ataxia 34 [MIM: 133190]; Stargardt disease 3 [MIM: 600110]",
          "OMIM Entry": "605512",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ELOVL5",
          "Phenotype MIM Number": "Spinocerebellar ataxia 38 [MIM: 615957]",
          "OMIM Entry": "611805",
          "Inheritance": "AD"
        },
        {
          "Gene": "ELP2",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 58 [MIM: 617270]",
          "OMIM Entry": "616054",
          "Inheritance": "AR"
        },
        {
          "Gene": "EMC1",
          "Phenotype MIM Number": "Cerebellar atrophy, visual impairment, and psychomotor retardation [MIM: 616875]",
          "OMIM Entry": "616846",
          "Inheritance": "AR"
        },
        {
          "Gene": "EMD",
          "Phenotype MIM Number": "Emery-Dreifuss muscular dystrophy 1, X-linked [MIM: 310300]",
          "OMIM Entry": "300384",
          "Inheritance": "XLR"
        },
        {
          "Gene": "EML1",
          "Phenotype MIM Number": "Band heterotopia [MIM: 600348]",
          "OMIM Entry": "602033",
          "Inheritance": "AR"
        },
        {
          "Gene": "ENO3",
          "Phenotype MIM Number": "Glycogen storage disease XIII [MIM: 612932]",
          "OMIM Entry": "131370",
          "Inheritance": "AR"
        },
        {
          "Gene": "ENTPD1",
          "Phenotype MIM Number": "Spastic paraplegia 64, autosomal recessive [MIM: 615683]",
          "OMIM Entry": "601752",
          "Inheritance": "AR"
        },
        {
          "Gene": "EPG5",
          "Phenotype MIM Number": "Vici syndrome [ MIM: 242820]",
          "OMIM Entry": "615068",
          "Inheritance": "AR"
        },
        {
          "Gene": "EPM2A",
          "Phenotype MIM Number": "Myoclonic epilepsy of Lafora 1 [MIM: 254780]",
          "OMIM Entry": "607566",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERAL1",
          "Phenotype MIM Number": "Perrault syndrome 6 [MIM: 617565]",
          "OMIM Entry": "607435",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERBB4",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 19 [MIM: 615515]",
          "OMIM Entry": "600543",
          "Inheritance": "AD"
        },
        {
          "Gene": "ERCC1",
          "Phenotype MIM Number": "Cerebrooculofacioskeletal syndrome 4 [MIM: 610758]",
          "OMIM Entry": "126380",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERCC2",
          "Phenotype MIM Number": "Cerebrooculofacioskeletal syndrome 2 [MIM: 610756]; Trichothiodystrophy 1, photosensitive [MIM: 601675];",
          "OMIM Entry": "126340",
          "Inheritance": "AR"
        },
        {
          "Gene": NaN,
          "Phenotype MIM Number": "Xeroderma pigmentosum, group D [MIM: 278730]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "ERCC3",
          "Phenotype MIM Number": "Trichothiodystrophy 2, photosensitive [MIM: 616390]; Xeroderma pigmentosum, group B [MIM: 610651]",
          "OMIM Entry": "133510",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERCC4",
          "Phenotype MIM Number": "Fanconi anemia, complementation group Q [MIM: 615272]; Xeroderma pigmentosum, group F [MIM: 278760]; Xeroderma pigmentosum, type F/Cockayne syndrome [MIM: 278760]; XFE progeroid syndrome [MIM: 610965]",
          "OMIM Entry": "133520",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERCC5",
          "Phenotype MIM Number": "Cerebrooculofacioskeletal syndrome 3 [MIM: 616570]; Xeroderma pigmentosum, group G [MIM: 278780];",
          "OMIM Entry": "133530",
          "Inheritance": "AR"
        },
        {
          "Gene": NaN,
          "Phenotype MIM Number": "Xeroderma pigmentosum, group G/Cockayne syndrome [MIM: 278780]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "ERCC6",
          "Phenotype MIM Number": "?De Sanctis-Cacchione syndrome [MIM: 278800]; {Lung cancer, susceptibility to} [MIM: 211980]; {Macular degeneration, age-related, susceptibility to, 5} [MIM: 613761]; Cerebrooculofacioskeletal syndrome 1 [MIM: 214150]; Cockayne syndrome, type B [MIM: 133540]; Premature ovarian failure 11 [MIM: 616946]; UV-sensitive syndrome 1 [MIM: 600630]",
          "OMIM Entry": "609413",
          "Inheritance": "AD, AR, Smu"
        },
        {
          "Gene": "ERCC8",
          "Phenotype MIM Number": "Cockayne syndrome, type A [MIM: 216400]; UV-sensitive syndrome 2 [MIM: 614621]",
          "OMIM Entry": "609412",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERLIN1",
          "Phenotype MIM Number": "Spastic paraplegia 62, autosomal recessive [MIM: 615681]",
          "OMIM Entry": "611604",
          "Inheritance": "AR"
        },
        {
          "Gene": "ERLIN2",
          "Phenotype MIM Number": "Spastic paraplegia 18A, autosomal dominant [MIM: 620512]; Spastic paraplegia 18B, autosomal recessive [MIM: 611225]",
          "OMIM Entry": "611605",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ETFA",
          "Phenotype MIM Number": "Glutaric acidemia IIA [MIM: 231680]",
          "OMIM Entry": "608053",
          "Inheritance": "AR"
        },
        {
          "Gene": "ETFB",
          "Phenotype MIM Number": "Glutaric acidemia IIB [MIM: 231680]",
          "OMIM Entry": "130410",
          "Inheritance": "AR"
        },
        {
          "Gene": "ETFDH",
          "Phenotype MIM Number": "Glutaric acidemia IIC [MIM: 231680]",
          "OMIM Entry": "231675",
          "Inheritance": "AR"
        },
        {
          "Gene": "ETHE1",
          "Phenotype MIM Number": "Ethylmalonic encephalopathy [MIM: 602473]",
          "OMIM Entry": "608451",
          "Inheritance": "AR"
        },
        {
          "Gene": "EXOSC3",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 1B [MIM: 614678]",
          "OMIM Entry": "606489",
          "Inheritance": "AR"
        },
        {
          "Gene": "EXOSC8",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 1C [MIM: 616081]",
          "OMIM Entry": "616081",
          "Inheritance": "AR"
        },
        {
          "Gene": "EXOSC9",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 1D [MIM: 618065]",
          "OMIM Entry": "606180",
          "Inheritance": "AR"
        },
        {
          "Gene": "EXT2",
          "Phenotype MIM Number": "Exostoses, multiple, type 2 [MIM: 133701]; Seizures, scoliosis, and macrocephaly syndrome [MIM: 616682]",
          "OMIM Entry": "608210",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "EZH2",
          "Phenotype MIM Number": "Weaver syndrome [MIM: 277590]",
          "OMIM Entry": "601573",
          "Inheritance": "AD"
        },
        {
          "Gene": "FA2H",
          "Phenotype MIM Number": "Spastic paraplegia 35, autosomal recessive [MIM: 612319]",
          "OMIM Entry": "611026",
          "Inheritance": "AR"
        },
        {
          "Gene": "FAR1",
          "Phenotype MIM Number": "Cataracts, spastic paraparesis, and speech delay [MIM: 619338]; Peroxisomal fatty acyl-CoA reductase 1 disorder [MIM: 616154]",
          "OMIM Entry": "616107",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "FARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 14 [MIM: 614946]; Spastic paraplegia 77, autosomal recessive [MIM: 617046]",
          "OMIM Entry": "611592",
          "Inheritance": "AR"
        },
        {
          "Gene": "FASTKD2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 44 [MIM: 618855]",
          "OMIM Entry": "612322",
          "Inheritance": "AR"
        },
        {
          "Gene": "FAT2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 45 [MIM: 617769]",
          "OMIM Entry": "604269",
          "Inheritance": "AD"
        },
        {
          "Gene": "FBXL4",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 13 (encephalomyopathic type) [MIM: 615471]",
          "OMIM Entry": "605654",
          "Inheritance": "AR"
        },
        {
          "Gene": "FBXO38",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal dominant 6 [MIM: 625575]",
          "OMIM Entry": "608553",
          "Inheritance": "AD"
        },
        {
          "Gene": "FBXO7",
          "Phenotype MIM Number": "Parkinson disease 15, autosomal recessive [MIM: 260300]",
          "OMIM Entry": "605648",
          "Inheritance": "AR"
        },
        {
          "Gene": "FDX2",
          "Phenotype MIM Number": "Mitochondrial myopathy, episodic, with optic atrophy and reversible leukoencephalopathy [MIM: 251900]",
          "OMIM Entry": "614585",
          "Inheritance": "AR"
        },
        {
          "Gene": "FERRY3",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 66 [MIM: 618221]",
          "OMIM Entry": "616082",
          "Inheritance": "AR"
        },
        {
          "Gene": "FGD4",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 4H [MIM: 609311]",
          "OMIM Entry": "611104",
          "Inheritance": "AR"
        },
        {
          "Gene": "FGF12",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 47 [MIM: 617166]",
          "OMIM Entry": "601513",
          "Inheritance": "AD"
        },
        {
          "Gene": "FGF14",
          "Phenotype MIM Number": "Spinocerebellar ataxia 27A [MIM: 193003]; Spinocerebellar ataxia 27B, late-onset [MIM: 620174]",
          "OMIM Entry": "601515",
          "Inheritance": "AD"
        },
        {
          "Gene": "FGFR1",
          "Phenotype MIM Number": "Encephalocraniocutaneous lipomatosis, somatic mosaic [MIM: 613001]; Hartsfield syndrome [MIM: 615465]; Hypogonadotropic hypogonadism 2 with or without anosmia [MIM: 147950]; Jackson-Weiss syndrome [MIM: 123150]; Osteoglophonic dysplasia [MIM: 166250]; Pfeiffer syndrome [MIM: 101600]; Trigonocephaly 1 [MIM: 190440]",
          "OMIM Entry": "136350",
          "Inheritance": "AD"
        },
        {
          "Gene": "FHL1",
          "Phenotype MIM Number": "Uruguay faciocardiomusculoskeletal syndrome [MIM: 300280]; Emery-Dreifuss muscular dystrophy 6, X-linked [MIM: 300696]; Myopathy, X-linked, with postural muscle atrophy [MIM: 300696]; Reducing body myopathy, X-linked 1a, severe, infantile or early childhood onset [MIM: 300717]; Reducing body myopathy, X-linked 1b, with late childhood or adult onset [MIM: 300718]; Scapuloperoneal myopathy, X-linked dominant [MIM: 300695]",
          "OMIM Entry": "300163",
          "Inheritance": "XL, XLR, XLD"
        },
        {
          "Gene": "FIG4",
          "Phenotype MIM Number": "Polymicrogyria, bilateral temporooccipital [MIM: 612691]; Amyotrophic lateral sclerosis 11 [MIM: 612577]; Charcot-Marie-Tooth disease, type 4J [MIM: 611228]; Yunis-Varon syndrome [MIM: 216340]",
          "OMIM Entry": "609390",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "FITM2",
          "Phenotype MIM Number": "Siddiqi syndrome [MIM: 618635]",
          "OMIM Entry": "612029",
          "Inheritance": "AR"
        },
        {
          "Gene": "FKBP14",
          "Phenotype MIM Number": "Ehlers-Danlos syndrome, kyphoscoliotic type, 2 [MIM: 614557]",
          "OMIM Entry": "614505",
          "Inheritance": "AR"
        },
        {
          "Gene": "FKRP",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 5 [MIM: 613153]; Muscular dystrophy-dystroglycanopathy (congenital with or without impaired intellectual development), type B, 5 [MIM: 606612]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 5 [MIM: 607155]",
          "OMIM Entry": "606596",
          "Inheritance": "AR"
        },
        {
          "Gene": "FKTN",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1X [MIM: 611615]; Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 4 [MIM: 253800]; Muscular dystrophy-dystroglycanopathy (congenital without impaired intellectual development), type B, 4 [MIM: 613152]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 4 [MIM: 611588]",
          "OMIM Entry": "607440",
          "Inheritance": "AR"
        },
        {
          "Gene": "FLAD1",
          "Phenotype MIM Number": "Lipid storage myopathy due to flavin adenine dinucleotide synthetase deficiency [MIM: 255100]",
          "OMIM Entry": "610595",
          "Inheritance": "AR"
        },
        {
          "Gene": "FLNA",
          "Phenotype MIM Number": "FG syndrome 2 [MIM: 300321]; Cardiac valvular dysplasia, X-linked [MIM: 314400]; Congenital short bowel syndrome [MIM: 300048]; Frontometaphyseal dysplasia 1 [MIM: 305620]; Heterotopia, periventricular, 1 [MIM: 300049]; Intestinal pseudoobstruction, neuronal [MIM: 300048]; Melnick-Needles syndrome [MIM: 309350]; Otopalatodigital syndrome, type I [MIM: 311300]; Otopalatodigital syndrome, type II [MIM: 304120]; Terminal osseous dysplasia [MIM: 300244]",
          "OMIM Entry": "300017",
          "Inheritance": "XL, XLR, XLD"
        },
        {
          "Gene": "FLNC",
          "Phenotype MIM Number": "Arrhythmogenic right ventricular dysplasia, familial [MIM: 617047]; Cardiomyopathy, familial hypertrophic, 26 [MIM: 617047]; Cardiomyopathy, familial restrictive 5 [MIM: 617047]; Myopathy, distal, 4 [MIM: 614065]; Myopathy, myofibrillar, 5 [MIM: 609524] ",
          "OMIM Entry": "102565",
          "Inheritance": "AD"
        },
        {
          "Gene": "FLVCR1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with microcephaly, absent speech, and hypotonia [MIM: 621060]; Retinopathy-sensory neuropathy syndrome [MIM: 609033]",
          "OMIM Entry": "609144",
          "Inheritance": "AR"
        },
        {
          "Gene": "FMR1",
          "Phenotype MIM Number": "Fragile X syndrome [MIM: 300624]; Fragile X tremor/ataxia syndrome [MIM 300623]; Premature ovarian failure 1 [MIM: 311360]",
          "OMIM Entry": "309550",
          "Inheritance": "XLD, XL"
        },
        {
          "Gene": "FOLR1",
          "Phenotype MIM Number": "Neurodegeneration due to cerebral folate transport deficiency [MIM: 613068]",
          "OMIM Entry": "136430",
          "Inheritance": "AR"
        },
        {
          "Gene": "FOXG1",
          "Phenotype MIM Number": "Rett syndrome, congenital variant [MIM: 613454]",
          "OMIM Entry": "164874",
          "Inheritance": "AD"
        },
        {
          "Gene": "FOXRED1",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 19 [MIM: 618241]",
          "OMIM Entry": "613622",
          "Inheritance": "AR"
        },
        {
          "Gene": "FRMD4A",
          "Phenotype MIM Number": "Corpus callosum, agenesis of, with facial anomalies and cerebellar ataxia [MIM: 616819]",
          "OMIM Entry": "616305",
          "Inheritance": "AR"
        },
        {
          "Gene": "FRRS1L",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 37 [MIM: 616981]",
          "OMIM Entry": "604574",
          "Inheritance": "AR"
        },
        {
          "Gene": "FTL",
          "Phenotype MIM Number": "Hyperferritinemia-cataract syndrome [MIM: 600886]; L-ferritin deficiency, dominant and recessive [MIM: 615604]; Neurodegeneration with brain iron accumulation 3 [MIM: 606159]",
          "OMIM Entry": "134790",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "FUCA1",
          "Phenotype MIM Number": "Fucosidosis [MIM: 230000]",
          "OMIM Entry": "612280",
          "Inheritance": "AR"
        },
        {
          "Gene": "FUS",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 6, with or without frontotemporal dementia [MIM: 608030]; Essential tremor, hereditary, 4 [MIM: 614782]",
          "OMIM Entry": "137070",
          "Inheritance": "AD"
        },
        {
          "Gene": "FXN",
          "Phenotype MIM Number": "Friedreich ataxia [MIM: 229300]; Friedreich ataxia with retained reflexes [MIM: 229300]",
          "OMIM Entry": "606829",
          "Inheritance": "AR"
        },
        {
          "Gene": "FXR1",
          "Phenotype MIM Number": "Congenital myopathy 9A with respiratory insufficiency and bone fractures [MIM: 618822]; Congenital myopathy 9B, proximal, with minicore lesions [MIM: 618823]",
          "OMIM Entry": "600819",
          "Inheritance": "AR"
        },
        {
          "Gene": "GAA",
          "Phenotype MIM Number": "Pompe disease, infantile-onset [MIM: 232300]; Pompe disease, late-onset [MIM: 621314]",
          "OMIM Entry": "606800",
          "Inheritance": "AR"
        },
        {
          "Gene": "GABRB1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 45 [MIM: 617153]",
          "OMIM Entry": "137190",
          "Inheritance": "AD"
        },
        {
          "Gene": "GABRB2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 92 [MIM: 617829]",
          "OMIM Entry": "600232",
          "Inheritance": "AD"
        },
        {
          "Gene": "GABRB3",
          "Phenotype MIM Number": "{Epilepsy, childhood absence, susceptibility to, 5} [MIM: 612269]; Developmental and epileptic encephalopathy 43 [MIM: 617113]",
          "OMIM Entry": "137192",
          "Inheritance": "AD"
        },
        {
          "Gene": "GAD1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 89 [MIM: 619124]",
          "OMIM Entry": "605363",
          "Inheritance": "AR"
        },
        {
          "Gene": "GALC",
          "Phenotype MIM Number": "Krabbe disease [MIM: 245200]",
          "OMIM Entry": "606890",
          "Inheritance": "AR"
        },
        {
          "Gene": "GAMT",
          "Phenotype MIM Number": "Cerebral creatine deficiency syndrome 2 [MIM: 612736]",
          "OMIM Entry": "612736",
          "Inheritance": "AR"
        },
        {
          "Gene": "GAN",
          "Phenotype MIM Number": "Giant axonal neuropathy-1 [MIM: 256850]",
          "OMIM Entry": "605379",
          "Inheritance": "AR"
        },
        {
          "Gene": "GATAD2B",
          "Phenotype MIM Number": "GAND syndrome [MIM: 615074]",
          "OMIM Entry": "614998",
          "Inheritance": "AD"
        },
        {
          "Gene": "GBA1",
          "Phenotype MIM Number": "{Lewy body dementia, susceptibility to} [MIM: 127750]; {Parkinson disease, late-onset, susceptibility to} [MIM: 168600]; Gaucher disease, perinatal lethal [MIM: 608013]; Gaucher disease, type I [MIM: 230800]; Gaucher disease, type II [MIM: 230900]; Gaucher disease, type III [MIM: 231000]; Gaucher disease, type IIIC [MIM: 231005]",
          "OMIM Entry": "606463",
          "Inheritance": "AD, AR, Mu"
        },
        {
          "Gene": "GBA2",
          "Phenotype MIM Number": "Spastic paraplegia 46, autosomal recessive [MIM: 614409]",
          "OMIM Entry": "609471",
          "Inheritance": "AR"
        },
        {
          "Gene": "GBE1",
          "Phenotype MIM Number": "Glycogen storage disease IV [MIM: 232500]; Polyglucosan body disease, adult form [MIM: 263570]",
          "OMIM Entry": "607839",
          "Inheritance": "AR"
        },
        {
          "Gene": "GCDH",
          "Phenotype MIM Number": "Glutaricaciduria, type I [MIM: 231670]",
          "OMIM Entry": "608801",
          "Inheritance": "AR"
        },
        {
          "Gene": "GCH1",
          "Phenotype MIM Number": "Dystonia, DOPA-responsive [MIM: 128230]; Hyperphenylalaninemia, BH4-deficient, B [MIM: 233910]",
          "OMIM Entry": "600225",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GCLC",
          "Phenotype MIM Number": "{Myocardial infarction, susceptibility to} [MIM: 608446]; Anemia, congenital, nonspherocytic hemolytic, 7 [MIM: 230450]",
          "OMIM Entry": "606857",
          "Inheritance": "AR"
        },
        {
          "Gene": "GDAP2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 27 [MIM: 618369]",
          "OMIM Entry": "618128",
          "Inheritance": "AR"
        },
        {
          "Gene": "GEMIN4",
          "Phenotype MIM Number": "Neurodevelopmental disorder with microcephaly, cataracts, and renal abnormalities [MIM: 617913]",
          "OMIM Entry": "606969",
          "Inheritance": "AR"
        },
        {
          "Gene": "GFAP",
          "Phenotype MIM Number": "Alexander disease [MIM: 203450]",
          "OMIM Entry": "137780",
          "Inheritance": "AD"
        },
        {
          "Gene": "GFER",
          "Phenotype MIM Number": "Myopathy, mitochondrial progressive, with congenital cataract and developmental delay [MIM: 613076]",
          "OMIM Entry": "600924",
          "Inheritance": "AR"
        },
        {
          "Gene": "GFM1",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 1 [MIM: 609060]",
          "OMIM Entry": "606639",
          "Inheritance": "AR"
        },
        {
          "Gene": "GFM2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 39 [MIM: 618397]",
          "OMIM Entry": "606544",
          "Inheritance": "AR"
        },
        {
          "Gene": "GFPT1",
          "Phenotype MIM Number": "Myasthenia, congenital, 12, with tubular aggregates [MIM: 610542]",
          "OMIM Entry": "138292",
          "Inheritance": "AR"
        },
        {
          "Gene": "GGPS1",
          "Phenotype MIM Number": "Muscular dystrophy, congenital hearing loss, and ovarian insufficiency syndrome [MIM: 619518]",
          "OMIM Entry": "606982",
          "Inheritance": "AR"
        },
        {
          "Gene": "GIGYF2",
          "Phenotype MIM Number": "{Parkinson disease 11} [MIM: 607688]",
          "OMIM Entry": "612003",
          "Inheritance": NaN
        },
        {
          "Gene": "GIPC1",
          "Phenotype MIM Number": "Oculopharyngodistal myopathy 2 [MIM: 618940]",
          "OMIM Entry": "605072",
          "Inheritance": "AD"
        },
        {
          "Gene": "GJA1",
          "Phenotype MIM Number": "Craniometaphyseal dysplasia, autosomal recessive [MIM: 218400]; Erythrokeratodermia variabilis et progressiva 3 [MIM: 617525]; Oculodentodigital dysplasia [MIM: 164200]; Oculodentodigital dysplasia, autosomal recessive [MIM: 257850]; Palmoplantar keratoderma with congenital alopecia [MIM: 104100]; Syndactyly, type III [MIM: 186100]",
          "OMIM Entry": "121014",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "GJC2",
          "Phenotype MIM Number": "Spastic paraplegia 44, autosomal recessive [MIM: 613206]; Leukodystrophy, hypomyelinating, 2 [MIM: 608804]; Lymphatic malformation 3 [MIM: 613480]",
          "OMIM Entry": "608803",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GLB1",
          "Phenotype MIM Number": "GM1-gangliosidosis, type I [MIM: 230500]; GM1-gangliosidosis, type II [MIM: 230600]; GM1-gangliosidosis, type III [MIM: 230650]; Mucopolysaccharidosis type IVB (Morquio) [MIM: 253010]",
          "OMIM Entry": "611458",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLDN",
          "Phenotype MIM Number": "Lethal congenital contracture syndrome 11 [MIM: 617194]",
          "OMIM Entry": "608603",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLE1",
          "Phenotype MIM Number": "Congenital arthrogryposis with anterior horn cell disease [MIM: 611890]; Lethal congenital contracture syndrome 1[ MIM: 253310]",
          "OMIM Entry": "603371",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLRA1",
          "Phenotype MIM Number": "Hyperekplexia 1 [MIM: 149400]",
          "OMIM Entry": "138491",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GLRX5",
          "Phenotype MIM Number": "Anemia, sideroblastic, 3, pyridoxine-refractory [MIM: 616860]; Spasticity, childhood-onset, with hyperglycinemia [MIM: 616859]",
          "OMIM Entry": "609588",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLS",
          "Phenotype MIM Number": "Global developmental delay progressive ataxia and elevated glutamine [MIM: 618412]",
          "OMIM Entry": "138280",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLYCTK",
          "Phenotype MIM Number": "D-glyceric aciduria [MIM: 220120]",
          "OMIM Entry": "610516",
          "Inheritance": "AR"
        },
        {
          "Gene": "GM2A",
          "Phenotype MIM Number": "GM2-gangliosidosis, AB variant [MIM: 272750]",
          "OMIM Entry": "613109",
          "Inheritance": "AR"
        },
        {
          "Gene": "GMPPA",
          "Phenotype MIM Number": "Alacrima, achalasia, and impaired intellectual development syndrome [MIM: 615510]",
          "OMIM Entry": "615495",
          "Inheritance": "AR"
        },
        {
          "Gene": "GMPPB",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 14 [MIM: 615350]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 14 [MIM: 615351]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 14 [MIM: 615352]",
          "OMIM Entry": "615320",
          "Inheritance": "AR"
        },
        {
          "Gene": "GNAL",
          "Phenotype MIM Number": "Dystonia 25 [MIM: 615073]",
          "OMIM Entry": "139312",
          "Inheritance": "AD"
        },
        {
          "Gene": "GNAO1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 17 [MIM: 615473]; Neurodevelopmental disorder with involuntary movements [MIM: 617493]",
          "OMIM Entry": "139311",
          "Inheritance": "AD"
        },
        {
          "Gene": "GNE",
          "Phenotype MIM Number": "Nonaka myopathy [MIM: 605820]; Sialuria [MIM: 269921]; Thrombocytopenia 12 with or without myopathy [MIM: 620757]",
          "OMIM Entry": "603824",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GOLGA2",
          "Phenotype MIM Number": "Developmental delay with hypotonia, myopathy, and brain abnormalities [MIM: 620240]",
          "OMIM Entry": "602580",
          "Inheritance": "AR"
        },
        {
          "Gene": "GOSR2",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 6 [MIM: 614018]; Muscular dystrophy, congenital, with or without seizures [MIM: 620166]",
          "OMIM Entry": "604027",
          "Inheritance": "AR"
        },
        {
          "Gene": "GPAA1",
          "Phenotype MIM Number": "Glycosylphosphatidylinositol biosynthesis defect 15 [MIM: 617810]",
          "OMIM Entry": "603048",
          "Inheritance": "AR"
        },
        {
          "Gene": "GPR88",
          "Phenotype MIM Number": "Chorea, childhood-onset, with psychomotor retardation [MIM: 616939]",
          "OMIM Entry": "607468",
          "Inheritance": "AR"
        },
        {
          "Gene": "GRIA3",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Wu type [MIM: 300699]",
          "OMIM Entry": "305915",
          "Inheritance": "XLR"
        },
        {
          "Gene": "GRID2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 18 [MIM: 616204]",
          "OMIM Entry": "602368",
          "Inheritance": "AR"
        },
        {
          "Gene": "GRIK2",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 6 [MIM: 611092]; Neurodevelopmental disorder with impaired language and ataxia and with or without seizures [MIM: 619580]",
          "OMIM Entry": "138244",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GRIN1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 101 [MIM: 619814]; Neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal dominant [MIM: 614254]; Neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal recessive [MIM: 617820]",
          "OMIM Entry": "138249",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GRIN2B",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 27 [MIM: 616139]; Intellectual developmental disorder, autosomal dominant 6, with or without seizures [MIM: 613970]",
          "OMIM Entry": "138252",
          "Inheritance": "AD"
        },
        {
          "Gene": "GRIN2D",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 46 [MIM: 617162]",
          "OMIM Entry": "602717",
          "Inheritance": "AD"
        },
        {
          "Gene": "GRM1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 44 [MIM: 617691]; Spinocerebellar ataxia, autosomal recessive 13 [MIM: 614831]",
          "OMIM Entry": "604473",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GRN",
          "Phenotype MIM Number": "Aphasia, primary progressive [MIM: 607485];  Ceroid lipofuscinosis, neuronal, 11 [MIM: 614706]; Frontotemporal dementia 2 [MIM: 607485]",
          "OMIM Entry": "138945",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GSS",
          "Phenotype MIM Number": "Anemia, congenital, nonspherocytic hemolytic, 6, glutatione synthetase deficient [MIM: 231900]; Glutathione synthetase deficiency [MIM: 266130]",
          "OMIM Entry": "601002",
          "Inheritance": "AR"
        },
        {
          "Gene": "GYG1",
          "Phenotype MIM Number": "Glycogen storage disease XV [MIM: 613507]; Polyglucosan body myopathy 2 [MIM: 616199]",
          "OMIM Entry": "603942",
          "Inheritance": "AR"
        },
        {
          "Gene": "GYS1",
          "Phenotype MIM Number": "Glycogen storage disease 0, muscle [MIM: 611556]",
          "OMIM Entry": "138570",
          "Inheritance": "AR"
        },
        {
          "Gene": "HACD1",
          "Phenotype MIM Number": "Congenital myopathy 11 [MIM: 619967]",
          "OMIM Entry": "610467",
          "Inheritance": "AR"
        },
        {
          "Gene": "HACE1",
          "Phenotype MIM Number": "Spastic paraplegia and psychomotor retardation with or without seizures [MIM: 616756]",
          "OMIM Entry": "610876",
          "Inheritance": "AR"
        },
        {
          "Gene": "HADHA",
          "Phenotype MIM Number": "Fatty liver, acute, of pregnancy [MIM: 609016]; HELLP syndrome, maternal, of pregnancy [MIM: 609016]; LCHAD deficiency [MIM: 609016]; Mitochondrial trifunctional protein deficiency 1 [MIM: 609015]",
          "OMIM Entry": "600890",
          "Inheritance": "AR"
        },
        {
          "Gene": "HADHB",
          "Phenotype MIM Number": "Mitochondrial trifunctional protein deficiency 2 [MIM: 620300]",
          "OMIM Entry": "143450",
          "Inheritance": "AR"
        },
        {
          "Gene": "HARS2",
          "Phenotype MIM Number": "Perrault syndrome 2 [MIM: 614926]",
          "OMIM Entry": "600783",
          "Inheritance": "AR"
        },
        {
          "Gene": "HCFC1",
          "Phenotype MIM Number": "Methylmalonic aciduria and homocysteinemia, cblX type [MIM: 309541]",
          "OMIM Entry": "300019",
          "Inheritance": "XLR"
        },
        {
          "Gene": "HCN1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 24 [MIM: 615871]; Generalized epilepsy with febrile seizures plus, type 10 [MIM: 618482]",
          "OMIM Entry": "602780",
          "Inheritance": "AD"
        },
        {
          "Gene": "HEPACAM",
          "Phenotype MIM Number": "Megalencephalic leukoencephalopathy with subcortical cysts 2A [MIM: 613925]; Megalencephalic leukoencephalopathy with subcortical cysts 2B, remitting, with or without impaired intellectual development [MIM: 613926]",
          "OMIM Entry": "611642",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HERC1",
          "Phenotype MIM Number": "Macrocephaly, dysmorphic facies, and psychomotor retardation [MIM: 617011]",
          "OMIM Entry": "605109",
          "Inheritance": "AR"
        },
        {
          "Gene": "HEXA",
          "Phenotype MIM Number": "[Hex A pseudodeficiency] [MIM: 272800]; GM2-gangliosidosis, several forms [MIM: 272800]; Tay-Sachs disease [MIM: 272800]",
          "OMIM Entry": "606869",
          "Inheritance": "AR"
        },
        {
          "Gene": "HEXB",
          "Phenotype MIM Number": "Sandhoff disease, infantile, juvenile, and adult forms [MIM: 268800]",
          "OMIM Entry": "606873",
          "Inheritance": "AR"
        },
        {
          "Gene": "HIBCH",
          "Phenotype MIM Number": "3-hydroxyisobutryl-CoA hydrolase deficiency [MIM: 250620]",
          "OMIM Entry": "610690",
          "Inheritance": "AR"
        },
        {
          "Gene": "HIKESHI",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 13 [MIM: 616881]",
          "OMIM Entry": "614908",
          "Inheritance": "AR"
        },
        {
          "Gene": "HK1",
          "Phenotype MIM Number": "Anemia, congenital, nonspherocytic hemolytic, 5, hexokinase deficient [MIM: 235700]; Neurodevelopmental disorder with visual defects and brain anomalies [MIM: 618547];  Neuropathy, hereditary motor and sensory, Russe type [MIM: 605285]; Retinitis pigmentosa 79 [MIM: 617460]",
          "OMIM Entry": "142600",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HMBS",
          "Phenotype MIM Number": "Encephalopathy, porphyria-related [MIM:  620704]; Leukoencephalopathy, porphyria-related [MIM: 620711]; Porphyria, acute intermittent [MIM: 176000]; Porphyria, acute intermittent, nonerythroid variant [MIM: 176000]",
          "OMIM Entry": "609806",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HMGCR",
          "Phenotype MIM Number": "[Low density lipoprotein cholesterol level QTL 3] [MIM: 620410]; [Statins, response to] [MIM: 620410]; Muscular dystrophy, limb-girdle, autosomal recessive 28 [MIM: 620375]",
          "OMIM Entry": "142910",
          "Inheritance": "AR"
        },
        {
          "Gene": "HNRNPA1",
          "Phenotype MIM Number": "Inclusion body myopathy with early-onset Paget disease without frontotemporal dementia 3  [MIM: 615424]; Myopathy, distal, 3 [MIM: 610099]; Amyotrophic lateral sclerosis 20 [MIM: 615426]",
          "OMIM Entry": "164017",
          "Inheritance": "AD"
        },
        {
          "Gene": "HNRNPA2B1",
          "Phenotype MIM Number": "Inclusion body myopathy with early-onset Paget disease with or without frontotemporal dementia 2 [MIM: 615422]; Oculopharyngeal muscular dystrophy 2 [MIM: 620460]",
          "OMIM Entry": "600124",
          "Inheritance": "AD"
        },
        {
          "Gene": "HNRNPDL",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 3 [MIM: 609155]",
          "OMIM Entry": "607137",
          "Inheritance": "AD"
        },
        {
          "Gene": "HNRNPH2",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Bain type [MIM: 300986]",
          "OMIM Entry": "300610",
          "Inheritance": "XLD"
        },
        {
          "Gene": "HPCA",
          "Phenotype MIM Number": "Dystonia 2, torsion, autosomal recessive [MIM: 224500]",
          "OMIM Entry": "142622",
          "Inheritance": "AR"
        },
        {
          "Gene": "HPDL",
          "Phenotype MIM Number": "Neurodevelopmental disorder with progressive spasticity and brain white matter abnormalities [MIM: 619026]; Spastic paraplegia 83, autosomal recessive [MIM: 619027]",
          "OMIM Entry": "618994",
          "Inheritance": "AR"
        },
        {
          "Gene": "HPRT1",
          "Phenotype MIM Number": "Hyperuricemia, HPRT-related [MIM:300323]; Lesch-Nyhan syndrome [MIM:  300322]",
          "OMIM Entry": "308000",
          "Inheritance": "XLR"
        },
        {
          "Gene": "HSD17B10",
          "Phenotype MIM Number": "HSD10 mitochondrial disease [MIM: 300438]",
          "OMIM Entry": "300256",
          "Inheritance": "XLD"
        },
        {
          "Gene": "HSD17B4",
          "Phenotype MIM Number": "D-bifunctional protein deficiency [MIM: 261515]; Perrault syndrome 1 [MIM: 233400]",
          "OMIM Entry": "601860",
          "Inheritance": "AR"
        },
        {
          "Gene": "HSPB1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2F [MIM: 606595]; Neuronopathy, distal hereditary motor, autosomal dominant 3 [MIM: 608634]",
          "OMIM Entry": "602195",
          "Inheritance": "AD"
        },
        {
          "Gene": "HSPB8",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2L [MIM: 608673]; Myopathy, myofibrillar, 13, with rimmed vacuoles [MIM: 621078]; Neuronopathy, distal hereditary motor, autosomal dominant 2 [MIM: 158590]",
          "OMIM Entry": "608014",
          "Inheritance": "AD"
        },
        {
          "Gene": "HSPD1",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 4 [MIM: 612233]; Spastic paraplegia 13, autosomal dominant [MIM: 605280]",
          "OMIM Entry": "118190",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HSPG2",
          "Phenotype MIM Number": "Dyssegmental dysplasia, Silverman-Handmaker type [MIM:  224410]; Schwartz-Jampel syndrome, type 1 [MIM: 255800]",
          "OMIM Entry": "142461",
          "Inheritance": "AR"
        },
        {
          "Gene": "HTRA1",
          "Phenotype MIM Number": "Cerebral arteriopathy, autosomal dominant, with subcortical infarcts and leukoencephalopathy 2 [MIM: 616779]; Cerebral arteriopathy, autosomal recessive, with subcortical infarcts and leukoencephalopathy 2 [MIM: 600142]",
          "OMIM Entry": "602194",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HTRA2",
          "Phenotype MIM Number": "{Parkinson disease 13} [MIM: 610297]; 3-methylglutaconic aciduria, type VIII [MIM: 617248]",
          "OMIM Entry": "606441",
          "Inheritance": "AR"
        },
        {
          "Gene": "HTT",
          "Phenotype MIM Number": "Huntington disease [MIM: 143100]; Lopes-Maciel-Rodan syndrome [MIM: 617435]",
          "OMIM Entry": "613004",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "IBA57",
          "Phenotype MIM Number": "Spastic paraplegia 74, autosomal recessive [MIM: 616451]; Multiple mitochondrial dysfunctions syndrome 3 [MIM: 615330]",
          "OMIM Entry": "615316",
          "Inheritance": "AR"
        },
        {
          "Gene": "IFIH1",
          "Phenotype MIM Number": "Aicardi-Goutieres syndrome 7 [MIM: 615846]; Immunodeficiency 95 [MIM: 619773]; Singleton-Merten syndrome 1 [MIM: 182250]",
          "OMIM Entry": "606951",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "IFT140",
          "Phenotype MIM Number": "{Polycystic kidney disease 9, susceptibility to} [MIM: 621164]; Cranioectodermal dysplasia 5 [MIM: 621180]; Retinitis pigmentosa 80 [MIM: 617781]; Short-rib thoracic dysplasia 9 with or without polydactyly [MIM: 266920]",
          "OMIM Entry": "614620",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "IFT172",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 20 [MIM: 619471]; Retinitis pigmentosa 71 [MIM: 616394]; Short-rib thoracic dysplasia 10 with or without polydactyly [MIM: 615630]",
          "OMIM Entry": "607386",
          "Inheritance": "AR"
        },
        {
          "Gene": "IFT27",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 19 [MIM: 615996]",
          "OMIM Entry": "615870",
          "Inheritance": "AR"
        },
        {
          "Gene": "IGHMBP2",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2S [MIM: 616155]; Neuronopathy, distal hereditary motor, autosomal recessive 1 [MIM: 604320]",
          "OMIM Entry": "600502",
          "Inheritance": "AR"
        },
        {
          "Gene": "INPP5E",
          "Phenotype MIM Number": "Impaired intellectual development, truncal obesity, retinal dystrophy, and micropenis syndrome [MIM: 610156]; Joubert syndrome 1 [MIM: 213300]",
          "OMIM Entry": "613037",
          "Inheritance": "AR"
        },
        {
          "Gene": "INPP5K",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, with cataracts and intellectual disability [MIM: 617404]",
          "OMIM Entry": "607875",
          "Inheritance": "AR"
        },
        {
          "Gene": "INTS8",
          "Phenotype MIM Number": "Neurodevelopmental disorder with cerebellar hypoplasia and spasticity [MIM: 618572]",
          "OMIM Entry": "611351",
          "Inheritance": "AR"
        },
        {
          "Gene": "IRF2BPL",
          "Phenotype MIM Number": "Neurodevelopmental disorder with regression, abnormal movements, loss of speech, and seizures [MIM: 618088]",
          "OMIM Entry": "611720",
          "Inheritance": "AD"
        },
        {
          "Gene": "ISCA2",
          "Phenotype MIM Number": "Multiple mitochondrial dysfunctions syndrome 4 [MIM: 616370]",
          "OMIM Entry": "615317",
          "Inheritance": "AR"
        },
        {
          "Gene": "ISCU",
          "Phenotype MIM Number": "Myopathy with lactic acidosis, hereditary [MIM: 255125]",
          "OMIM Entry": "611911",
          "Inheritance": "AR"
        },
        {
          "Gene": "ITGA7",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, due to ITGA7 deficiency [MIM: 613204]",
          "OMIM Entry": "600536",
          "Inheritance": "AR"
        },
        {
          "Gene": "ITM2B",
          "Phenotype MIM Number": "Retinal dystrophy with inner retinal dysfunction and ganglion cell abnormalities  [MIM: 616079]; Dementia, familial British [MIM: 176500]; Dementia, familial Danish [MIM: 117300]",
          "OMIM Entry": "603904",
          "Inheritance": "AD"
        },
        {
          "Gene": "ITPR1",
          "Phenotype MIM Number": "Gillespie syndrome [MIM: 206700]; Spinocerebellar ataxia 15 [MIM: 606658];  Spinocerebellar ataxia 29, congenital nonprogressive [MIM: 117360]",
          "OMIM Entry": "147265",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "JAG2",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 27 [MIM: 619566]",
          "OMIM Entry": "602570",
          "Inheritance": "AR"
        },
        {
          "Gene": "JAM3",
          "Phenotype MIM Number": "Hemorrhagic destruction of the brain, subependymal calcification, and cataracts [MIM: 613730]",
          "OMIM Entry": "606871",
          "Inheritance": "AR"
        },
        {
          "Gene": "JPH3",
          "Phenotype MIM Number": "Huntington disease-like 2 [MIM: 606438]",
          "OMIM Entry": "605268",
          "Inheritance": "AD"
        },
        {
          "Gene": "KANK1",
          "Phenotype MIM Number": "Cerebral palsy, spastic quadriplegic, 2 [MIM: 612900]",
          "OMIM Entry": "607704",
          "Inheritance": NaN
        },
        {
          "Gene": "KARS1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, recessive intermediate, B [MIM: 613641]; Deafness, autosomal recessive 89 [MIM: 613916]; Deafness, congenital, and adult-onset progressive leukoencephalopathy [MIM: 619196]; Leukoencephalopathy, progressive, infantile-onset, with or without deafness [MIM: 619147]",
          "OMIM Entry": "601421",
          "Inheritance": "AR"
        },
        {
          "Gene": "KATNIP",
          "Phenotype MIM Number": "Joubert syndrome 26 [MIM: 616784]",
          "OMIM Entry": "616650",
          "Inheritance": "AR"
        },
        {
          "Gene": "KBTBD13",
          "Phenotype MIM Number": "Nemaline myopathy 6, autosomal dominant [MIM: 609273]",
          "OMIM Entry": "613727",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNA1",
          "Phenotype MIM Number": "Episodic ataxia/myokymia syndrome [MIM: 160120]",
          "OMIM Entry": "176260",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNA2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 32 [MIM: 616366]",
          "OMIM Entry": "176262",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNA4",
          "Phenotype MIM Number": "Microcephaly, cataracts, impaired intellectual development, and dystonia with abnormal striatum [MIM: 618284]",
          "OMIM Entry": "176266",
          "Inheritance": "AR"
        },
        {
          "Gene": "KCNC1",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 7 [MIM: 616187]",
          "OMIM Entry": "176258",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNC3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 13 [MIM: 605259]",
          "OMIM Entry": "176264",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCND3",
          "Phenotype MIM Number": "Brugada syndrome 9 [MIM: 616399]; Spinocerebellar ataxia 19 [MIM: 607346]",
          "OMIM Entry": "605411",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNJ10",
          "Phenotype MIM Number": "Enlarged vestibular aqueduct, digenic [MIM: 600791]; SESAME syndrome [MIM: 612780]",
          "OMIM Entry": "602208",
          "Inheritance": "AR"
        },
        {
          "Gene": "KCNJ6",
          "Phenotype MIM Number": "Keppen-Lubinsky syndrome [MIM: 614098]",
          "OMIM Entry": "600877",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNMA1",
          "Phenotype MIM Number": "{Epilepsy, idiopathic generalized, susceptibility to, 16} [MIM: 618596]; Cerebellar atrophy, developmental delay, and seizures [MIM: 617643]; Liang-Wang syndrome [MIM: 618729]; Paroxysmal nonkinesigenic dyskinesia, 3, with or without generalized epilepsy [MIM: 609446]",
          "OMIM Entry": "600150",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "KCNQ2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 7 [MIM:  613720]; Myokymia [MIM: 121200]; Seizures, benign neonatal, 1 [MIM: 121200]",
          "OMIM Entry": "602235",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNT1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 14 [MIM: 614959]; Epilepsy nocturnal frontal lobe, 5 [MIM: 615005]",
          "OMIM Entry": "608167",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCTD17",
          "Phenotype MIM Number": "Dystonia 26, myoclonic [MIM: 616398]",
          "OMIM Entry": "616386",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCTD7",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 3, with or without intracellular inclusions [MIM: 611726]",
          "OMIM Entry": "611725",
          "Inheritance": "AR"
        },
        {
          "Gene": "KDM5C",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Claes-Jensen type [MIM: 300534]",
          "OMIM Entry": "314690",
          "Inheritance": "XLR"
        },
        {
          "Gene": "KIAA0586",
          "Phenotype MIM Number": "Joubert syndrome 23 [MIM: 616490]; Short-rib thoracic dysplasia 14 with polydactyly [MIM: 616546]",
          "OMIM Entry": "610178",
          "Inheritance": "AR"
        },
        {
          "Gene": "KIDINS220",
          "Phenotype MIM Number": "Spastic paraplegia, intellectual disability, nystagmus, and obesity [MIM: 617296]; Ventriculomegaly and arthrogryposis [MIM: 619501]",
          "OMIM Entry": "615759",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "KIF1A",
          "Phenotype MIM Number": "NESCAV syndrome [MIM: 614255]; Neuropathy, hereditary sensory, type IIC [MIM: 614213]; Spastic paraplegia 30, autosomal dominant [MIM: 610357]; Spastic paraplegia 30, autosomal recessive [MIM: 620607]",
          "OMIM Entry": "601255",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "KIF1B",
          "Phenotype MIM Number": "{Neuroblastoma, susceptibility to, 1} [MIM: 256700]; Charcot-Marie-Tooth disease, type 2A1 [MIM: 118210]",
          "OMIM Entry": "605995",
          "Inheritance": "AD, SMu"
        },
        {
          "Gene": "KIF1C",
          "Phenotype MIM Number": "Spastic ataxia 2, autosomal recessive [MIM: 611302]",
          "OMIM Entry": "603060",
          "Inheritance": "AR"
        },
        {
          "Gene": "KIF2A",
          "Phenotype MIM Number": "Cortical dysplasia, complex, with other brain malformations 3 [MIM: 615411]",
          "OMIM Entry": "602591",
          "Inheritance": "AD"
        },
        {
          "Gene": "KIF5A",
          "Phenotype MIM Number": "{Amyotrophic lateral sclerosis, susceptibility to, 25} [MIM: 617921]; Myoclonus, intractable, neonatal [MIM: 617235]; Spastic paraplegia 10, autosomal dominant [MIM: 604187]",
          "OMIM Entry": "602821",
          "Inheritance": "AD"
        },
        {
          "Gene": "KIF5C",
          "Phenotype MIM Number": "Cortical dysplasia, complex, with other brain malformations 2 [MIM: 615282]",
          "OMIM Entry": "604593",
          "Inheritance": "AD"
        },
        {
          "Gene": "KIF7",
          "Phenotype MIM Number": "Al-Gazali-Bakalinova syndrome [MIM: 607131]; Hydrolethalus syndrome 2 [MIM:  614120]; Acrocallosal syndrome [MIM: 200990]; Joubert syndrome 12 [MIM: 200990]",
          "OMIM Entry": "611254",
          "Inheritance": "AR"
        },
        {
          "Gene": "KLC2",
          "Phenotype MIM Number": "Spastic paraplegia, optic atrophy, and neuropathy [MIM: 609541]",
          "OMIM Entry": "611729",
          "Inheritance": "AR"
        },
        {
          "Gene": "KLHL40",
          "Phenotype MIM Number": "Nemaline myopathy 8, autosomal recessive [MIM: 615348]",
          "OMIM Entry": "615340",
          "Inheritance": "AR"
        },
        {
          "Gene": "KLHL41",
          "Phenotype MIM Number": "Nemaline myopathy 9 [MIM: 615731]",
          "OMIM Entry": "607701",
          "Inheritance": "AR"
        },
        {
          "Gene": "KMT2B",
          "Phenotype MIM Number": "Dystonia 28, childhood-onset [MIM: 617284]; Intellectual developmental disorder, autosomal dominant 68 [MIM: 619934]",
          "OMIM Entry": "606834",
          "Inheritance": "AD"
        },
        {
          "Gene": "KY",
          "Phenotype MIM Number": "Myopathy, myofibrillar, 7 [MIM: 617114]",
          "OMIM Entry": "605739",
          "Inheritance": "AR"
        },
        {
          "Gene": "L1CAM",
          "Phenotype MIM Number": "Corpus callosum, partial agenesis of [MIM: 304100]; Hydrocephalus, congenital, X-linked [MIM: 307000]; MASA syndrome [MIM: 303350]",
          "OMIM Entry": "308840",
          "Inheritance": "XLR"
        },
        {
          "Gene": "L2HGDH",
          "Phenotype MIM Number": "L-2-hydroxyglutaric aciduria [MIM: 236792]",
          "OMIM Entry": "609584",
          "Inheritance": "AR"
        },
        {
          "Gene": "LAGE3",
          "Phenotype MIM Number": "Galloway-Mowat syndrome 2, X-linked [MIM: 301006]",
          "OMIM Entry": "300060",
          "Inheritance": "XLR"
        },
        {
          "Gene": "LAMA2",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, merosin deficient or partially deficient [MIM: 607855]; Muscular dystrophy, limb-girdle, autosomal recessive 23 [MIM: 618138]",
          "OMIM Entry": "156225",
          "Inheritance": "AR"
        },
        {
          "Gene": "LAMB2",
          "Phenotype MIM Number": "Nephrotic syndrome, type 5, with or without ocular abnormalities [MIM: 614199]; Pierson syndrome [MIM: 609049]",
          "OMIM Entry": "150325",
          "Inheritance": "AR"
        },
        {
          "Gene": "LAMP2",
          "Phenotype MIM Number": "Danon disease [MIM: 300257]",
          "OMIM Entry": "309060",
          "Inheritance": "XLD"
        },
        {
          "Gene": "LARGE1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 6 [MIM: 613154]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 6 [MIM: 608840]",
          "OMIM Entry": "603590",
          "Inheritance": "AR"
        },
        {
          "Gene": "LDB3",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1C, with or without LVNC [MIM: 601493]; Cardiomyopathy, dilated, 2L [MIM: 621237]; Cardiomyopathy, hypertrophic, 24 [MIM: 601493]; Left ventricular noncompaction 3 [MIM: 601493]; Myopathy, myofibrillar, 4 [MIM: 609452]",
          "OMIM Entry": "605906",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "LDHA",
          "Phenotype MIM Number": "Glycogen storage disease XI [MIM: 612933]",
          "OMIM Entry": "150000",
          "Inheritance": "AR"
        },
        {
          "Gene": "LETM1",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with multisystem involvement due to mitochondrial dysfunction [MIM: 620089]",
          "OMIM Entry": "604407",
          "Inheritance": "AR"
        },
        {
          "Gene": "LGI4",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 1, neurogenic, with myelin defect [MIM: 617468]",
          "OMIM Entry": "608303",
          "Inheritance": "AR"
        },
        {
          "Gene": "LIAS",
          "Phenotype MIM Number": "Hyperglycinemia, lactic acidosis, and seizures [MIM: 614462]",
          "OMIM Entry": "607031",
          "Inheritance": "AR"
        },
        {
          "Gene": "LIMS2",
          "Phenotype MIM Number": "Muscular dystrophy, autosomal recessive, with cardiomyopathy and triangular tongue [MIM: 616827]",
          "OMIM Entry": "607908",
          "Inheritance": "AR"
        },
        {
          "Gene": "LIPT1",
          "Phenotype MIM Number": "Lipoyltransferase 1 deficiency [MIM: 616299]",
          "OMIM Entry": "610284",
          "Inheritance": "AR"
        },
        {
          "Gene": "LIPT2",
          "Phenotype MIM Number": "Encephalopathy, neonatal severe, with lactic acidosis and brain abnormalities [MIM: 617668]",
          "OMIM Entry": "617659",
          "Inheritance": "AR"
        },
        {
          "Gene": "LMNA",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1A [MIM: 115200]; Charcot-Marie-Tooth disease, type 2B1 [MIM: 605588]; Emery-Dreifuss muscular dystrophy 2, autosomal dominant [ MIM: 181350]; Emery-Dreifuss muscular dystrophy 3, autosomal recessive [MIM: 616516]; Heart-hand syndrome, Slovenian type [MIM: 610140]; Hutchinson-Gilford progeria [MIM: 176670]; Lipodystrophy, familial partial, type 2 [MIM: 151600]; Malouf syndrome [MIM: 212112]; Mandibuloacral dysplasia [MIM: 248370]; Muscular dystrophy, congenital [MIM: 613205]; Restrictive dermopathy 2 [MIM: 619793]",
          "OMIM Entry": "150330",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "LMNB1",
          "Phenotype MIM Number": "icrocephaly 26, primary, autosomal dominant [MIM: 619179]",
          "OMIM Entry": "150340",
          "Inheritance": "AD"
        },
        {
          "Gene": "LMNB2",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic, 9 [MIM: 616540]; {Lipodystrophy, partial, acquired, susceptibility to} [MIM: 608709]; Microcephaly 27, primary, autosomal dominant [MIM: 619180]",
          "OMIM Entry": "150341",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "LMOD3",
          "Phenotype MIM Number": "Nemaline myopathy 10 [MIM: 616165]",
          "OMIM Entry": "616112",
          "Inheritance": "AR"
        },
        {
          "Gene": "LPIN1",
          "Phenotype MIM Number": "Myoglobinuria, acute recurrent, autosomal recessive [MIM: 268200]",
          "OMIM Entry": "605518",
          "Inheritance": "AR"
        },
        {
          "Gene": "LRP12",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 28 [MIM: 620452]; Oculopharyngodistal myopathy 1 [MIM: 164310]",
          "OMIM Entry": "618299",
          "Inheritance": "AD"
        },
        {
          "Gene": "LRP4",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 17 [MIM: 616304]; Cenani-Lenz syndactyly syndrome [MIM: 212780]; Sclerosteosis 2 [MIM: 614305]",
          "OMIM Entry": "604270",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "LRPPRC",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 5, (French-Canadian) [MIM: 220111]",
          "OMIM Entry": "607544",
          "Inheritance": "AR"
        },
        {
          "Gene": "LRRK2",
          "Phenotype MIM Number": "{Parkinson disease 8} [MIM: 607060]",
          "OMIM Entry": "609007",
          "Inheritance": "AD"
        },
        {
          "Gene": "LRSAM1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2P [MIM: 614436]",
          "OMIM Entry": "610933",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "LYRM7",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 8 [MIM: 615838]",
          "OMIM Entry": "615831",
          "Inheritance": "AR"
        },
        {
          "Gene": "LYST",
          "Phenotype MIM Number": "Chediak-Higashi syndrome [MIM: 214500]",
          "OMIM Entry": "606897",
          "Inheritance": "AR"
        },
        {
          "Gene": "MAG",
          "Phenotype MIM Number": "Spastic paraplegia 75, autosomal recessive [MIM: 616680]",
          "OMIM Entry": "159460",
          "Inheritance": "AR"
        },
        {
          "Gene": "MAN2B1",
          "Phenotype MIM Number": "Mannosidosis, alpha-, types I and II [MIM: 248500]",
          "OMIM Entry": "609458",
          "Inheritance": "AR"
        },
        {
          "Gene": "MAP3K20",
          "Phenotype MIM Number": "Centronuclear myopathy 6 with fiber-type disproportion [MIM: 617760]; Split-foot malformation with mesoaxial polydactyly [MIM: 616890]",
          "OMIM Entry": "609479",
          "Inheritance": "AR"
        },
        {
          "Gene": "MAPT",
          "Phenotype MIM Number": "{Parkinson disease, susceptibility to} [MIM: 168600]; Frontotemporal dementia 1, with or without parkinsonism [MIM: 600274]; Pick disease [MIM: 172700]; Supranuclear palsy, progressive [MIM: 601104]; Supranuclear palsy, progressive atypical [MIM: 260540]",
          "OMIM Entry": "157140",
          "Inheritance": "AD, AR, Mu"
        },
        {
          "Gene": "MARS1",
          "Phenotype MIM Number": "Trichothiodystrophy 9, nonphotosensitive [MIM: 619692]; Charcot-Marie-Tooth disease, axonal, type 2U [MIM: 616280]; Interstitial lung and liver disease [MIM: 615486]; Spastic paraplegia 70, autosomal recessive [MIM: 620323]",
          "OMIM Entry": "156560",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 25 [MIM: 616430]; Spastic ataxia 3, autosomal recessive [MIM: 611390]",
          "OMIM Entry": "609728",
          "Inheritance": "AR"
        },
        {
          "Gene": "MAT1A",
          "Phenotype MIM Number": "Hypermethioninemia, persistent, autosomal dominant, due to methionine adenosyltransferase I/III deficiency [MIM: 250850]; Methionine adenosyltransferase deficiency, autosomal recessive [MIM: 250850]",
          "OMIM Entry": "610550",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MATR3",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 21 [MIM: 606070]",
          "OMIM Entry": "164015",
          "Inheritance": "AD"
        },
        {
          "Gene": "MB",
          "Phenotype MIM Number": "Myopathy, sarcoplasmic body [MIM: 620286]",
          "OMIM Entry": "160000",
          "Inheritance": "AD"
        },
        {
          "Gene": "MBD5",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal dominant 1 [MIM: 156200]",
          "OMIM Entry": "611472",
          "Inheritance": "AD"
        },
        {
          "Gene": "MCCC2",
          "Phenotype MIM Number": "3-Methylcrotonyl-CoA carboxylase 2 deficiency [MIM: 210210]",
          "OMIM Entry": "609014",
          "Inheritance": "AR"
        },
        {
          "Gene": "MCOLN1",
          "Phenotype MIM Number": "Lisch epithelial corneal dystrophy [MIM: 620763]; Mucolipidosis IV [MIM: 252650]",
          "OMIM Entry": "605248",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MDH2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 51 [MIM: 617339]",
          "OMIM Entry": "154100",
          "Inheritance": "AR"
        },
        {
          "Gene": "MECP2",
          "Phenotype MIM Number": "{Autism susceptibility, X-linked 3} [MIM: 300496]; Encephalopathy, neonatal severe [MIM: 300673];",
          "OMIM Entry": "300005",
          "Inheritance": "XL, XLR, XLD"
        },
        {
          "Gene": NaN,
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic 13 [MIM: 300055]; Intellectual developmental disorder, X-linked syndromic, Lubs type [MIM: 300260]; Rett syndrome [MIM: 312750]; Rett syndrome, atypical [MIM: 312750];Rett syndrome, preserved speech variant [MIM: 312750]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "MECR",
          "Phenotype MIM Number": "Dystonia, childhood-onset, with optic atrophy and basal ganglia abnormalities [MIM: 617282]; Optic atrophy 16 [MIM: 620629]",
          "OMIM Entry": "608205",
          "Inheritance": "AR"
        },
        {
          "Gene": "MED13L",
          "Phenotype MIM Number": "Impaired intellectual development and distinctive facial features with or without cardiac defects [MIM: 616789]",
          "OMIM Entry": "608771",
          "Inheritance": "AD"
        },
        {
          "Gene": "MED17",
          "Phenotype MIM Number": "Microcephaly, postnatal progressive, with seizures and brain atrophy [MIM: 613668]",
          "OMIM Entry": "603810",
          "Inheritance": "AR"
        },
        {
          "Gene": "MED25",
          "Phenotype MIM Number": "Basel-Vanagaite-Smirin-Yosef syndrome [MIM: 616449]",
          "OMIM Entry": "610197",
          "Inheritance": "AR"
        },
        {
          "Gene": "MEGF10",
          "Phenotype MIM Number": "Congenital myopathy 10A, severe variant [MIM: 614399]; Congenital myopathy 10B, mild variant [MIM: 620249]",
          "OMIM Entry": "612453",
          "Inheritance": "AR"
        },
        {
          "Gene": "MFF",
          "Phenotype MIM Number": "Encephalopathy due to defective mitochondrial and peroxisomal fission 2 [MIM: 617086]",
          "OMIM Entry": "614785",
          "Inheritance": "AR"
        },
        {
          "Gene": "MFN2",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2A2A [MIM: 609260]; Charcot-Marie-Tooth disease, axonal, type 2A2B [MIM: 617087]; Hereditary motor and sensory neuropathy VIA [MIM: 601152]; Lipomatosis, multiple symmetric, with or without peripheral neuropathy [MIM: 151800]",
          "OMIM Entry": "608507",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MFSD2A",
          "Phenotype MIM Number": "Neurodevelopmental disorder with progressive microcephaly, spasticity, and brain abnormalities [MIM: 616486]",
          "OMIM Entry": "614397",
          "Inheritance": "AR"
        },
        {
          "Gene": "MFSD8",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 7 [MIM: 610951]; Macular dystrophy with central cone involvement [MIM: 616170]",
          "OMIM Entry": "611124",
          "Inheritance": "AR"
        },
        {
          "Gene": "MGME1",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 11 [MIM: 615084]",
          "OMIM Entry": "615076",
          "Inheritance": "AR"
        },
        {
          "Gene": "MICU1",
          "Phenotype MIM Number": "Myopathy with extrapyramidal signs [MIM: 615673]",
          "OMIM Entry": "605084",
          "Inheritance": "AR"
        },
        {
          "Gene": "MIPEP",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 31 [MIM: 617228]",
          "OMIM Entry": "602241",
          "Inheritance": "AR"
        },
        {
          "Gene": "MKS1",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 13 [MIM: 615990]; Joubert syndrome 28 [MIM: 617121]; Meckel syndrome 1 [MIM: 249000]",
          "OMIM Entry": "609883",
          "Inheritance": "AR"
        },
        {
          "Gene": "MLC1",
          "Phenotype MIM Number": "Megalencephalic leukoencephalopathy with subcortical cysts 1 [MIM: 604004]",
          "OMIM Entry": "605908",
          "Inheritance": "AR"
        },
        {
          "Gene": "MLIP",
          "Phenotype MIM Number": "Myopathy with myalgia, increased serum creatine kinase, and with or without episodic rhabdomyolysis [MIM: 620138]",
          "OMIM Entry": "614106",
          "Inheritance": "AR"
        },
        {
          "Gene": "MMACHC",
          "Phenotype MIM Number": "Methylmalonic aciduria and homocystinuria, cblC type [MIM: 277400]",
          "OMIM Entry": "609831",
          "Inheritance": "AR"
        },
        {
          "Gene": "MMADHC",
          "Phenotype MIM Number": "Homocystinuria-megaloblastic anemia, cblD type [MIM: 620952]; Methylmalonic aciduria and homocystinuria, cblD type [MIM: 277410]; Methylmalonic aciduria, cblD type [MIM: 620953]",
          "OMIM Entry": "611935",
          "Inheritance": "AR"
        },
        {
          "Gene": "MME",
          "Phenotype MIM Number": "Spinocerebellar ataxia 43 [MIM: 617018]; Charcot-Marie-Tooth disease, axonal, type 2T [MIM: 617017]",
          "OMIM Entry": "120520",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MOCS1",
          "Phenotype MIM Number": "Molybdenum cofactor deficiency A [MIM: 252150]",
          "OMIM Entry": "603707",
          "Inheritance": "AR"
        },
        {
          "Gene": "MOCS2",
          "Phenotype MIM Number": "Molybdenum cofactor deficiency B1 [MIM: 252160]",
          "OMIM Entry": "603708",
          "Inheritance": "AR"
        },
        {
          "Gene": "MORC2",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2Z [MIM: 616688]; Developmental delay, impaired growth, dysmorphic facies, and axonal neuropathy [MIM: 619090]",
          "OMIM Entry": "616661",
          "Inheritance": "AD"
        },
        {
          "Gene": "MPDU1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type If [MIM: 609180]",
          "OMIM Entry": "604041",
          "Inheritance": "AR"
        },
        {
          "Gene": "MPV17",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2EE [MIM: 618400]; Mitochondrial DNA depletion syndrome 6 (hepatocerebral type) [MIM: 256810]",
          "OMIM Entry": "137960",
          "Inheritance": "AR"
        },
        {
          "Gene": "MPZ",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, dominant intermediate D [MIM: 607791]; Charcot-Marie-Tooth disease, type 1B [MIM: 118200]; Charcot-Marie-Tooth disease, type 2I [MIM: 607677]; Charcot-Marie-Tooth disease, type 2J [MIM: 607736]; Dejerine-Sottas disease [MIM: 145900]; Hypomyelinating neuropathy, congenital, 2 [MIM: 618184]; Roussy-Levy syndrome [MIM: 180800]",
          "OMIM Entry": "159440",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MRE11",
          "Phenotype MIM Number": "Ataxia-telangiectasia-like disorder 1 [MIM: 604391]",
          "OMIM Entry": "600814",
          "Inheritance": "AR"
        },
        {
          "Gene": "MRPS22",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 5 [MIM: 611719]; Ovarian dysgenesis 7 [MIM: 618117]",
          "OMIM Entry": "605810",
          "Inheritance": "AR"
        },
        {
          "Gene": "MRPS34",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 32 [MIM: 617664]",
          "OMIM Entry": "611994",
          "Inheritance": "AR"
        },
        {
          "Gene": "MTM1",
          "Phenotype MIM Number": "Myopathy, centronuclear, X-linked [MIM: 310400]",
          "OMIM Entry": "300415",
          "Inheritance": "XLR"
        },
        {
          "Gene": "MTMR14",
          "Phenotype MIM Number": "{Centronuclear myopathy, autosomal, modifier of} [MIM: 160150]",
          "OMIM Entry": "611089",
          "Inheritance": "AD"
        },
        {
          "Gene": "MTO1",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 10 [MIM: 614702]",
          "OMIM Entry": "614667",
          "Inheritance": "AR"
        },
        {
          "Gene": "MTPAP",
          "Phenotype MIM Number": "Spastic ataxia 4, autosomal recessive [MIM: 613672]",
          "OMIM Entry": "613669",
          "Inheritance": "AR"
        },
        {
          "Gene": "MTRFR",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 7 [MIM: 613559]; Spastic paraplegia 55, autosomal recessive [MIM: 615035]",
          "OMIM Entry": "613541",
          "Inheritance": "AR"
        },
        {
          "Gene": "MTTP",
          "Phenotype MIM Number": "Abetalipoproteinemia [MIM: 200100]",
          "OMIM Entry": "157147",
          "Inheritance": "AR"
        },
        {
          "Gene": "MUSK",
          "Phenotype MIM Number": "Fetal akinesia deformation sequence 1 [MIM: 208150]; Myasthenic syndrome, congenital, 9, associated with acetylcholine receptor deficiency [MIM: 616325]",
          "OMIM Entry": "601296",
          "Inheritance": "AR"
        },
        {
          "Gene": "MVK",
          "Phenotype MIM Number": "Hyper-IgD syndrome [MIM: 260920]; Mevalonic aciduria [MIM: 610377]; Porokeratosis 3, multiple types [MIM: 175900]",
          "OMIM Entry": "251170",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYBPC1",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 1B [MIM: 614335]; Congenital myopathy 16 [MIM; 618524]; Lethal congenital contracture syndrome 4 [MIM: 614915]",
          "OMIM Entry": "160794",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYH14",
          "Phenotype MIM Number": "Peripheral neuropathy, myopathy, hoarseness, and hearing loss [MIM: 614369]; Deafness, autosomal dominant 4A [MIM: 600652]",
          "OMIM Entry": "608568",
          "Inheritance": "AD"
        },
        {
          "Gene": "MYH2",
          "Phenotype MIM Number": "Congenital myopathy 6 with ophthalmoplegia [MIM: 605637]",
          "OMIM Entry": "160740",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYH3",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 2A (Freeman-Sheldon) [MIM: 193700]; Arthrogryposis, distal, type 2B3 (Sheldon-Hall) [MIM: 618436]; Contractures, pterygia, and spondylocarpostarsal fusion syndrome 1A [MIM: 178110]; Contractures, pterygia, and spondylocarpotarsal fusion syndrome 1B [MIM: 618469] ",
          "OMIM Entry": "160720",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYH7",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1S [MIM: 613426]; Cardiomyopathy, hypertrophic, 1 [MIM: 192600]; Congenital myopathy 7A, myosin storage, autosomal dominant [MIM: 608358]; Congenital myopathy 7B, myosin storage, autosomal recessive [MIM: 255160]; Laing distal myopathy [MIM: 160500]; Left ventricular noncompaction 5 [MIM: 613426]",
          "OMIM Entry": "160760",
          "Inheritance": "AD, AR, DD"
        },
        {
          "Gene": "MYL1",
          "Phenotype MIM Number": "Congenital myopathy 14 [MIM: 618414]",
          "OMIM Entry": "160780",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYL2",
          "Phenotype MIM Number": "Cardiomyopathy, hypertrophic, 10 [MIM: 608758]; Myopathy, myofibrillar, 12, infantile-onset, with cardiomyopathy [MIM: 619424]",
          "OMIM Entry": "160781",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYMK",
          "Phenotype MIM Number": "Carey-Fineman-Ziter syndrome [MIM: 254940]",
          "OMIM Entry": "615345",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYO18B",
          "Phenotype MIM Number": "Klippel-Feil syndrome 4, autosomal recessive, with myopathy and facial dysmorphism [MIM: 616549]",
          "OMIM Entry": "607295",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYO7A",
          "Phenotype MIM Number": "Deafness, autosomal dominant 11; 601317; Deafness, autosomal recessive 2 [MIM: 600060]; Usher syndrome, type 1B [MIM: 276900]",
          "OMIM Entry": "276903",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYO9A",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 24, presynaptic [MIM: 618198]",
          "OMIM Entry": "604875",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYOD1",
          "Phenotype MIM Number": "Congenital myopathy 17 [MIM: 618975]",
          "OMIM Entry": "159970",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYOT",
          "Phenotype MIM Number": "Myopathy, myofibrillar, 3 [MIM: 609200]",
          "OMIM Entry": "604103",
          "Inheritance": "AD"
        },
        {
          "Gene": "MYPN",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1KK [MIM: 615248]; Cardiomyopathy, familial restrictive, 4 [MIM: 615248]; Cardiomyopathy, hypertrophic, 22 [MIM: 615248]; Congenital myopathy 24 [MIM: 617336]",
          "OMIM Entry": "608517",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NADK2",
          "Phenotype MIM Number": "2,4-dienoyl-CoA reductase deficiency [MIM: 616034]",
          "OMIM Entry": "615787",
          "Inheritance": "AR"
        },
        {
          "Gene": "NAGA",
          "Phenotype MIM Number": "Kanzaki disease [MIM: 609242]; Schindler disease, type I [MIM: 609241]; Schindler disease, type III [MIM: 609241]",
          "OMIM Entry": "104170",
          "Inheritance": "AR"
        },
        {
          "Gene": "NAGLU",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2V [MIM: 616491]; Mucopolysaccharidosis type IIIB (Sanfilippo B) [MIM: 252920]",
          "OMIM Entry": "609701",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "NALCN",
          "Phenotype MIM Number": "Congenital contractures of the limbs and face, hypotonia, and developmental delay [MIM: 616266]; Hypotonia, infantile, with psychomotor retardation and characteristic facies 1 [MIM: 615419]",
          "OMIM Entry": "611549",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NANS",
          "Phenotype MIM Number": "Spondyloepimetaphyseal dysplasia, Genevieve type [MIM: 610442]",
          "OMIM Entry": "605202",
          "Inheritance": "AR"
        },
        {
          "Gene": "NAT8L",
          "Phenotype MIM Number": "N-acetylaspartate deficiency [MIM: 614063]",
          "OMIM Entry": "610647",
          "Inheritance": "AR"
        },
        {
          "Gene": "NAXE",
          "Phenotype MIM Number": "Encephalopathy, progressive, early-onset, with brain edema and/or leukoencephalopathy [MIM: 617186]",
          "OMIM Entry": "608862",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDE1",
          "Phenotype MIM Number": "Lissencephaly 4 (with microcephaly) [MIM: 614019]; Microhydranencephaly [MIM: 605013]",
          "OMIM Entry": "609449",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDRG1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 4D [MIM: 601455]",
          "OMIM Entry": "605262",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFA1",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 12 [MIM: 301020]",
          "OMIM Entry": "300078",
          "Inheritance": "XLR"
        },
        {
          "Gene": "NDUFA10",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 22 [MIM: 618243]",
          "OMIM Entry": "603835",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFA11",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 14 [MIM: 618236]",
          "OMIM Entry": "612638",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFA12",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 23 [MIM: 618244]",
          "OMIM Entry": "614530",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFA13",
          "Phenotype MIM Number": "{Thyroid carcinoma, Hurthle cell} [MIM: 607464]; Mitochondrial complex I deficiency, nuclear type 28 [MIM: 618249]",
          "OMIM Entry": "609435",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFA2",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 13 [MIM: 618235]",
          "OMIM Entry": "602137",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFA9",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 26 [MIM: 618247]",
          "OMIM Entry": "603834",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFAF1",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 11 [MIM: 618234]",
          "OMIM Entry": "606934",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFAF2",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 10 [MIM: 618233]",
          "OMIM Entry": "609653",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFAF3",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 18 [MIM: 618240]",
          "OMIM Entry": "612911",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFAF4",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 15 [MIM: 618237]",
          "OMIM Entry": "611776",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFAF5",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 16 [MIM: 618238]",
          "OMIM Entry": "612360",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFAF6",
          "Phenotype MIM Number": "Fanconi renotubular syndrome 5 [MIM: 618913]; Mitochondrial complex I deficiency, nuclear type 17 [MIM: 618239]",
          "OMIM Entry": "612392",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFB3",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 25 [MIM: 618246]",
          "OMIM Entry": "603839",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFB9",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 24 [MIM: 618245]",
          "OMIM Entry": "601445",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS1",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 5 [MIM: 618226]",
          "OMIM Entry": "157655",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS2",
          "Phenotype MIM Number": "Leber-like hereditary optic neuropathy, autosomal recessive 2 [MIM: 620569]; Mitochondrial complex I deficiency, nuclear type 6 [MIM: 618228]",
          "OMIM Entry": "602985",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS3",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 8 [MIM: 618230]",
          "OMIM Entry": "603846",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS4",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 1 [MIM: 252010]",
          "OMIM Entry": "602694",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS6",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 9 [MIM: 618232]",
          "OMIM Entry": "603848",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS7",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 3 [MIM: 618224]",
          "OMIM Entry": "601825",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFS8",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 2 [MIM: 618222]",
          "OMIM Entry": "602141",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFV1",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 4 [MIM: 618225]",
          "OMIM Entry": "161015",
          "Inheritance": "AR"
        },
        {
          "Gene": "NDUFV2",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 7 [MIM: 618229]",
          "OMIM Entry": "600532",
          "Inheritance": "AR"
        },
        {
          "Gene": "NEB",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 6 [MIM: 619334]; Nemaline myopathy 2, autosomal recessive [MIM: 256030]",
          "OMIM Entry": "161650",
          "Inheritance": "AR"
        },
        {
          "Gene": "NECAP1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 21 [MIM: 615833]",
          "OMIM Entry": "611623",
          "Inheritance": "AR"
        },
        {
          "Gene": "NEFH",
          "Phenotype MIM Number": "{Amyotrophic lateral sclerosis, susceptibility to} [MIM: 105400]; Charcot-Marie-Tooth disease, axonal, type 2CC [MIM: 616924]",
          "OMIM Entry": "162230",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NEFL",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, dominant intermediate G [MIM: 617882]; Charcot-Marie-Tooth disease, type 1F [MIM: 607734]; Charcot-Marie-Tooth disease, type 2E [MIM: 607684]",
          "OMIM Entry": "162280",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NEU1",
          "Phenotype MIM Number": "Sialidosis, type I [MIM: 256550]; Sialidosis, type II [MIM: 256550]",
          "OMIM Entry": "608272",
          "Inheritance": "AR"
        },
        {
          "Gene": "NEXMIF",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked 98 [MIM: 300912]",
          "OMIM Entry": "300524",
          "Inheritance": "XLD"
        },
        {
          "Gene": "NF1",
          "Phenotype MIM Number": "Leukemia, juvenile myelomonocytic [MIM: 607785]; Neurofibromatosis-Noonan syndrome [MIM: 601321]; Neurofibromatosis, familial spinal [MIM: 162210]; Neurofibromatosis, type 1 [MIM: 162200]; Watson syndrome [MIM: 193520]",
          "OMIM Entry": "613113",
          "Inheritance": "AD, SMu"
        },
        {
          "Gene": "NF2",
          "Phenotype MIM Number": "Meningioma, NF2-related, somatic [MIM: 607174]; Schwannomatosis, somatic [MIM: 101000]; Schwannomatosis, vestibular [MIM: 101000]",
          "OMIM Entry": "607379",
          "Inheritance": "AD"
        },
        {
          "Gene": "NFASC",
          "Phenotype MIM Number": "Neurodevelopmental disorder with central and peripheral motor dysfunction [MIM: 618356]",
          "OMIM Entry": "609145",
          "Inheritance": "AR"
        },
        {
          "Gene": "NGLY1",
          "Phenotype MIM Number": "Congenital disorder of deglycosylation 1 [MIM: 615273]",
          "OMIM Entry": "610661",
          "Inheritance": "AR"
        },
        {
          "Gene": "NHLRC1",
          "Phenotype MIM Number": "Myoclonic epilepsy of Lafora 2 [MIM: 620681]",
          "OMIM Entry": "608072",
          "Inheritance": "AR"
        },
        {
          "Gene": "NIPA1",
          "Phenotype MIM Number": "Spastic paraplegia 6, autosomal dominant [MIM: 600363]",
          "OMIM Entry": "608145",
          "Inheritance": "AD"
        },
        {
          "Gene": "NKX2-1",
          "Phenotype MIM Number": "{Thyroid cancer, nonmedullary, 1} [MIM: 188550]; Chorea, hereditary benign [MIM: 118700]; Choreoathetosis, hypothyroidism, and neonatal respiratory distress [MIM: 610978]",
          "OMIM Entry": "600635",
          "Inheritance": "AD"
        },
        {
          "Gene": "NKX6-2",
          "Phenotype MIM Number": "Spastic ataxia 8, autosomal recessive, with hypomyelinating leukodystrophy [MIM: 617560]",
          "OMIM Entry": "605955",
          "Inheritance": "AR"
        },
        {
          "Gene": "NMNAT1",
          "Phenotype MIM Number": "Leber congenital amaurosis 9 [MIM: 608553]; Spondyloepiphyseal dysplasia, sensorineural hearing loss, intellectual developmental disorder, and Leber congenital amaurosis [MIM: 619260]",
          "OMIM Entry": "608700",
          "Inheritance": "AR"
        },
        {
          "Gene": "NOL3",
          "Phenotype MIM Number": "Myoclonus, familial, 1 [MIM: 614937]",
          "OMIM Entry": "605235",
          "Inheritance": "AD"
        },
        {
          "Gene": "NOP56",
          "Phenotype MIM Number": "Spinocerebellar ataxia 36 [MIM: 614153]",
          "OMIM Entry": "614154",
          "Inheritance": "AD"
        },
        {
          "Gene": "NOTCH2NLC",
          "Phenotype MIM Number": "Neuronal Intranuclear Inclusion Disease [MIM: 603472]; Oculopharyngodistal Myopathy 3 [MIM: 619473]; Tremor Hereditary Essential 6 [MIM: 618866]",
          "OMIM Entry": "618025",
          "Inheritance": "AD"
        },
        {
          "Gene": "NOTCH3",
          "Phenotype MIM Number": "Myofibromatosis, infantile 2 [MIM: 615293]; Cerebral arteriopathy, autosomal dominant, with subcortical infarcts and leukoencephalopathy 1 [MIM: 125310]; Cerebral arteriopathy, autosomal recessive, with subcortical infarcts and leukoencephalopathy 1 [MIM: 621295]; Lateral meningocele syndrome [MIM: 130720]; Lipodystrophy, familial partial, type 1 [MIM: 608600]",
          "OMIM Entry": "600276",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NPC1",
          "Phenotype MIM Number": "Niemann-Pick disease, type C1 [MIM: 257220]; Niemann-Pick disease, type D [MIM: 257220]",
          "OMIM Entry": "607623",
          "Inheritance": "AR"
        },
        {
          "Gene": "NPC2",
          "Phenotype MIM Number": "Niemann-pick disease, type C2 [MIM: 607625]",
          "OMIM Entry": "601015",
          "Inheritance": "AR"
        },
        {
          "Gene": "NPHP1",
          "Phenotype MIM Number": "Joubert syndrome 4 [MIM: 609583]; Nephronophthisis 1, juvenile [MIM: 256100]; Senior-Loken syndrome-1 [MIM: 266900]",
          "OMIM Entry": "607100",
          "Inheritance": "AR"
        },
        {
          "Gene": "NR4A2",
          "Phenotype MIM Number": "Intellectual developmental disorder with language impairment and early-onset DOPA-responsive dystonia-parkinsonism [MIM: 619911]",
          "OMIM Entry": "601828",
          "Inheritance": "AD"
        },
        {
          "Gene": "NSUN2",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 5 [MIM: 611091]",
          "OMIM Entry": "610916",
          "Inheritance": "AR"
        },
        {
          "Gene": "NT5C2",
          "Phenotype MIM Number": "Spastic paraplegia 45, autosomal recessive [MIM: 613162]",
          "OMIM Entry": "600417",
          "Inheritance": "AR"
        },
        {
          "Gene": "NUBPL",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 21 [MIM: 618242]",
          "OMIM Entry": "613621",
          "Inheritance": "AR"
        },
        {
          "Gene": "NUP62",
          "Phenotype MIM Number": "Striatonigral degeneration, infantile [MIM: 271930]",
          "OMIM Entry": "605815",
          "Inheritance": "AR"
        },
        {
          "Gene": "NUTM2B-AS1",
          "Phenotype MIM Number": "Oculopharyngeal myopathy with leukoencephalopathy 1 [MIM: 618637]",
          "OMIM Entry": "618639",
          "Inheritance": "AD"
        },
        {
          "Gene": "OCLN",
          "Phenotype MIM Number": "Pseudo-TORCH syndrome 1 [MIM: 251290]",
          "OMIM Entry": "602876",
          "Inheritance": "AR"
        },
        {
          "Gene": "OFD1",
          "Phenotype MIM Number": "Retinitis pigmentosa 23 [MIM: 300424]; Joubert syndrome 10 [MIM: 300804]; Orofaciodigital syndrome I [MIM: 311200]; Simpson-Golabi-Behmel syndrome, type 2 [MIM: 300209]",
          "OMIM Entry": "300170",
          "Inheritance": "XLR, XLD"
        },
        {
          "Gene": "OPA1",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 14 (encephalocardiomyopathic type) [MIM: 616896]; {Glaucoma, normal tension, susceptibility to} [MIM: 606657]; Behr syndrome [MIM: 210000]; Optic atrophy 1 [MIM: 165500]; Optic atrophy plus syndrome [MIM: 125250]",
          "OMIM Entry": "605290",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "OPA3",
          "Phenotype MIM Number": "3-methylglutaconic aciduria, type III [MIM: 258501]; Optic atrophy 3 with cataract [MIM: 165300]",
          "OMIM Entry": "606580",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "OPHN1",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Billuart type [MIM: 300486]",
          "OMIM Entry": "300127",
          "Inheritance": "XLR"
        },
        {
          "Gene": "OPTN",
          "Phenotype MIM Number": "{Glaucoma, normal tension, susceptibility to} [MIM: 606657]; Amyotrophic lateral sclerosis 12 with or without frontotemporal dementia [MIM: 613435]; Glaucoma 1, open angle, E [MIM: 137760]",
          "OMIM Entry": "602432",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ORAI1",
          "Phenotype MIM Number": "Immunodeficiency 9 [MIM: 612782]; Myopathy, tubular aggregate, 2 [MIM: 615883]",
          "OMIM Entry": "610277",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "OSGEP",
          "Phenotype MIM Number": "Galloway-Mowat syndrome 3 [MIM: 617729]",
          "OMIM Entry": "610107",
          "Inheritance": "AR"
        },
        {
          "Gene": "OTC",
          "Phenotype MIM Number": "Ornithine transcarbamylase deficiency [MIM: 311250]",
          "OMIM Entry": "300461",
          "Inheritance": "XL"
        },
        {
          "Gene": "PABPN1",
          "Phenotype MIM Number": "Oculopharyngeal muscular dystrophy [MIM: 164300]",
          "OMIM Entry": "602279",
          "Inheritance": "AD"
        },
        {
          "Gene": "PAFAH1B1",
          "Phenotype MIM Number": "Lissencephaly 1 [MIM: 607432]; Subcortical laminar heterotopia [MIM: 607432]",
          "OMIM Entry": "601545",
          "Inheritance": "AD"
        },
        {
          "Gene": "PANK2",
          "Phenotype MIM Number": "Neurodegeneration with brain iron accumulation 1 [MIM: 234200]",
          "OMIM Entry": "606157",
          "Inheritance": "AR"
        },
        {
          "Gene": "PARK7",
          "Phenotype MIM Number": "Parkinson disease 7, autosomal recessive early-onset [MIM: 606324]",
          "OMIM Entry": "606324",
          "Inheritance": "AR"
        },
        {
          "Gene": "PARN",
          "Phenotype MIM Number": "Dyskeratosis congenita, autosomal recessive 6 [MIM: 616353]; Pulmonary fibrosis and/or bone marrow failure syndrome, telomere-related, 4 [MIM: 616371]",
          "OMIM Entry": "604212",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PARS2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 75 [MIM: 618437]",
          "OMIM Entry": "612036",
          "Inheritance": "AR"
        },
        {
          "Gene": "PAX7",
          "Phenotype MIM Number": "Congenital myopathy 19 [MIM: 618578]; Rhabdomyosarcoma 2, alveolar [MIM: 268220]",
          "OMIM Entry": "167410",
          "Inheritance": "AR, Smu"
        },
        {
          "Gene": "PC",
          "Phenotype MIM Number": "Pyruvate carboxylase deficiency [MIM: 266150]",
          "OMIM Entry": "608786",
          "Inheritance": "AR"
        },
        {
          "Gene": "PCCA",
          "Phenotype MIM Number": "Propionicacidemia [MIM: 606054]",
          "OMIM Entry": "232000",
          "Inheritance": "AR"
        },
        {
          "Gene": "PCCB",
          "Phenotype MIM Number": "Propionicacidemia [MIM: 606054]",
          "OMIM Entry": "232050",
          "Inheritance": "AR"
        },
        {
          "Gene": "PCDH12",
          "Phenotype MIM Number": "Diencephalic-mesencephalic junction dysplasia syndrome 1 [MIM: 251280]",
          "OMIM Entry": "605622",
          "Inheritance": "AR"
        },
        {
          "Gene": "PCDH19",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 9 [MIM: 300088]",
          "OMIM Entry": "300460",
          "Inheritance": "XL"
        },
        {
          "Gene": "PCLO",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 3 [MIM: 608027]",
          "OMIM Entry": "604918",
          "Inheritance": "AR"
        },
        {
          "Gene": "PCNA",
          "Phenotype MIM Number": "Ataxia-telangiectasia-like disorder 2 [MIM: 615919]",
          "OMIM Entry": "176740",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDE10A",
          "Phenotype MIM Number": "Dyskinesia, limb and orofacial, infantile-onset [MIM: 616921]; Striatal degeneration, autosomal dominant [MIM: 616922]",
          "OMIM Entry": "610652",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PDE6D",
          "Phenotype MIM Number": "Joubert syndrome 22 [MIM: 615665]",
          "OMIM Entry": "602676",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDE8B",
          "Phenotype MIM Number": "Pigmented nodular adrenocortical disease, primary, 3 [MIM: 614190]; Striatal degeneration, autosomal dominant [MIM: 609161]",
          "OMIM Entry": "603390",
          "Inheritance": "AD"
        },
        {
          "Gene": "PDGFB",
          "Phenotype MIM Number": "Basal ganglia calcification, idiopathic, 5 [MIM: 615483]; Meningioma, SIS-related [MIM: 607174]",
          "OMIM Entry": "190040",
          "Inheritance": "AD"
        },
        {
          "Gene": "PDGFRB",
          "Phenotype MIM Number": "Ocular pterygium-digital keloid dysplasia syndrome [MIM: 621091]; Basal ganglia calcification, idiopathic, 4 [MIM: 615007]; Kosaki overgrowth syndrome [MIM: 616592]; Myofibromatosis, infantile, 1 [MIM: 228550]; Premature aging syndrome, Penttinen type [MIM: 601812]",
          "OMIM Entry": "173410",
          "Inheritance": "AD"
        },
        {
          "Gene": "PDHA1",
          "Phenotype MIM Number": "Pyruvate dehydrogenase E1-alpha deficiency [MIM: 312170]",
          "OMIM Entry": "300502",
          "Inheritance": "XLD"
        },
        {
          "Gene": "PDHB",
          "Phenotype MIM Number": "Pyruvate dehydrogenase E1-beta deficiency [MIM: 614111]",
          "OMIM Entry": "179060",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDHX",
          "Phenotype MIM Number": "Lacticacidemia due to PDX1 deficiency [MIM: 245349]",
          "OMIM Entry": "608769",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDP1",
          "Phenotype MIM Number": "Pyruvate dehydrogenase phosphatase deficiency [MIM: 608782]",
          "OMIM Entry": "605993",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDSS1",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 2 [MIM: 614651]",
          "OMIM Entry": "607429",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDSS2",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 3 [MIM: 614652]",
          "OMIM Entry": "610564",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDYN",
          "Phenotype MIM Number": "Spinocerebellar ataxia 23 [MIM: 610245]",
          "OMIM Entry": "131340",
          "Inheritance": "AD"
        },
        {
          "Gene": "PET100",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 12 [MIM: 619055]",
          "OMIM Entry": "614770",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX1",
          "Phenotype MIM Number": "Heimler syndrome 1 [MIM: 234580]; Peroxisome biogenesis disorder 1A (Zellweger) [MIM: 214100]; Peroxisome biogenesis disorder 1B (NALD/IRD) [MIM: 601539]",
          "OMIM Entry": "602136",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX10",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 6A (Zellweger) [MIM: 614870]; Peroxisome biogenesis disorder 6B [MIM: 614871]",
          "OMIM Entry": "602859",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX11B",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 14B [MIM: 614920]",
          "OMIM Entry": "603867",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX12",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 3A (Zellweger) [MIM: 614859]; Peroxisome biogenesis disorder 3B [MIM: 266510]",
          "OMIM Entry": "601758",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX13",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 11A (Zellweger) [MIM: 614883]; Peroxisome biogenesis disorder 11B [MIM: 614885]",
          "OMIM Entry": "601789",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX14",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 13A (Zellweger) [MIM: 614887]",
          "OMIM Entry": "601791",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX16",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 8A (Zellweger) [MIM: 614876]; Peroxisome biogenesis disorder 8B [MIM: 614877]",
          "OMIM Entry": "603360",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX19",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 12A (Zellweger) [MIM: 614886]",
          "OMIM Entry": "600279",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX2",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 5A (Zellweger) [MIM: 614866]; Peroxisome biogenesis disorder 5B [MIM: 614867]",
          "OMIM Entry": "170993",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX26",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 7A (Zellweger) [MIM: 614872]; Peroxisome biogenesis disorder 7B [MIM: 614873]",
          "OMIM Entry": "608666",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX3",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 10B [MIM: 617370]; Peroxisome biogenesis disorder 10A (Zellweger) [MIM: 614882]",
          "OMIM Entry": "603164",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX5",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 2A (Zellweger) [MIM: 214110]; Peroxisome biogenesis disorder 2B [MIM: 202370]; Rhizomelic chondrodysplasia punctata, type 5 [MIM: 616716]",
          "OMIM Entry": "600414",
          "Inheritance": "AR"
        },
        {
          "Gene": "PEX6",
          "Phenotype MIM Number": "Heimler syndrome 2 [MIM: 616617]; Peroxisome biogenesis disorder 4A (Zellweger) [MIM: 614862]; Peroxisome biogenesis disorder 4B [MIM: 614863]",
          "OMIM Entry": "601498",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PEX7",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 9B [MIM: 614879]; Rhizomelic chondrodysplasia punctata, type 1 [MIM: 215100]",
          "OMIM Entry": "601757",
          "Inheritance": "AR"
        },
        {
          "Gene": "PFKM",
          "Phenotype MIM Number": "Glycogen storage disease VII [MIM: 232800]",
          "OMIM Entry": "610681",
          "Inheritance": "AR"
        },
        {
          "Gene": "PFN1",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 18 [MIM: 614808]",
          "OMIM Entry": "176610",
          "Inheritance": NaN
        },
        {
          "Gene": "PGAM2",
          "Phenotype MIM Number": "Glycogen storage disease X [MIM: 261670]",
          "OMIM Entry": "612931",
          "Inheritance": "AR"
        },
        {
          "Gene": "PGAP1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with dysmorphic features, spasticity, and brain abnormalities [MIM: 615802]",
          "OMIM Entry": "611655",
          "Inheritance": "AR"
        },
        {
          "Gene": "PGK1",
          "Phenotype MIM Number": "Phosphoglycerate kinase 1 deficiency [MIM: 300653]",
          "OMIM Entry": "311800",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PGM1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type It [MIM: 614921]",
          "OMIM Entry": "171900",
          "Inheritance": "AR"
        },
        {
          "Gene": "PGM3",
          "Phenotype MIM Number": "Immunodeficiency 23 [MIM: 615816]",
          "OMIM Entry": "172100",
          "Inheritance": "AR"
        },
        {
          "Gene": "PHGDH",
          "Phenotype MIM Number": "Neu-Laxova syndrome 1 [MIM: 256520]; Phosphoglycerate dehydrogenase deficiency [MIM: 601815]",
          "OMIM Entry": "606879",
          "Inheritance": "AR"
        },
        {
          "Gene": "PHKA1",
          "Phenotype MIM Number": "Muscle glycogenosis [MIM: 300559]",
          "OMIM Entry": "311870",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PHKB",
          "Phenotype MIM Number": "Phosphorylase kinase deficiency of liver and muscle, autosomal recessive [MIM: 261750]",
          "OMIM Entry": "172490",
          "Inheritance": "AR"
        },
        {
          "Gene": "PHYH",
          "Phenotype MIM Number": "Refsum disease [MIM: 266500]",
          "OMIM Entry": "602026",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIBF1",
          "Phenotype MIM Number": "Joubert syndrome 33 [MIM: 617767]",
          "OMIM Entry": "607532",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIEZO2",
          "Phenotype MIM Number": "Marden-Walker syndrome [MIM: 248700]; Arthrogryposis, distal, type 3 [MIM: 114300]; Arthrogryposis, distal, type 5 [MIM: 108145]; Arthrogryposis, distal, with impaired proprioception and touch [MIM: 617146]",
          "OMIM Entry": "613629",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PIGA",
          "Phenotype MIM Number": "Multiple congenital anomalies-hypotonia-seizures syndrome 2 [MIM: 300868]; Neurodevelopmental disorder with epilepsy and hemochromatosis [MIM: 301072]; Paroxysmal nocturnal hemoglobinuria, somatic [MIM: 300818]",
          "OMIM Entry": "311770",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PIGG",
          "Phenotype MIM Number": "[Blood group, EMM system] [MIM: 619812]; Neurodevelopmental disorder with or without hypotonia, seizures, and cerebellar atrophy [MIM: 616917]",
          "OMIM Entry": "616918",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIGN",
          "Phenotype MIM Number": "Multiple congenital anomalies-hypotonia-seizures syndrome 1 [MIM: 614080]",
          "OMIM Entry": "606097",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIGQ",
          "Phenotype MIM Number": "Multiple congenital anomalies-hypotonia-seizures syndrome 4 [MIM: 618548]",
          "OMIM Entry": "605754",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIGS",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 95 [MIM: 618143]",
          "OMIM Entry": "610271",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIK3R5",
          "Phenotype MIM Number": "Ataxia-oculomotor apraxia 3 [MIM: 615217]",
          "OMIM Entry": "611317",
          "Inheritance": "AR"
        },
        {
          "Gene": "PINK1",
          "Phenotype MIM Number": "Parkinson disease 6, early onset [MIM: 605909]",
          "OMIM Entry": "608309",
          "Inheritance": "AR"
        },
        {
          "Gene": "PITRM1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 30 [MIM: 619405]",
          "OMIM Entry": "618211",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLA2G6",
          "Phenotype MIM Number": "Infantile neuroaxonal dystrophy 1 [MIM: 256600]; Neurodegeneration with brain iron accumulation 2B [MIM: 610217]; Parkinson disease 14, autosomal recessive [MIM: 612953]",
          "OMIM Entry": "603604",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLAA",
          "Phenotype MIM Number": "Neurodevelopmental disorder with progressive microcephaly, spasticity, and brain anomalies [MIM: 617527]",
          "OMIM Entry": "603873",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLCB1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 12 [MIM: 613722]",
          "OMIM Entry": "607120",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLD3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 46 [MIM: 617770]",
          "OMIM Entry": "615698",
          "Inheritance": "AD"
        },
        {
          "Gene": "PLEC",
          "Phenotype MIM Number": "Epidermolysis bullosa simplex 5D, generalized intermediate, autosomal recessive [MIM: 616487]; Epidermolysis bullosa simplex 5A, Ogna type [MIM: 131950]; Epidermolysis bullosa simplex 5B, with muscular dystrophy [MIM: 226670]; Epidermolysis bullosa simplex 5C, with pyloric atresia [MIM: 612138]; Muscular dystrophy, limb-girdle, autosomal recessive 17 [MIM: 613723]",
          "OMIM Entry": "601282",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PLEKHG2",
          "Phenotype MIM Number": "Leukodystrophy and acquired microcephaly with or without dystonia [MIM: 616673]",
          "OMIM Entry": "611893",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLEKHG5",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, recessive intermediate C [MIM: 615376]; Neuronopathy, distal hereditary motor, autosomal recessive 4 [MIM: 611067] ",
          "OMIM Entry": "611101",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLP1",
          "Phenotype MIM Number": "Pelizaeus-Merzbacher disease [MIM: 312080]; Spastic paraplegia 2, X-linked [MIM: 312920]",
          "OMIM Entry": "300401",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PLXND1",
          "Phenotype MIM Number": "Congenital heart defects, multiple types, 9 [MIM: 620294]",
          "OMIM Entry": "604282",
          "Inheritance": "AR"
        },
        {
          "Gene": "PMM2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ia [MIM: 212605]",
          "OMIM Entry": "601785",
          "Inheritance": "AR"
        },
        {
          "Gene": "PMP22",
          "Phenotype MIM Number": "Neuropathy, inflammatory demyelinating [MIM: 139393]; Charcot-Marie-Tooth disease, type 1A [MIM: 118220'; Charcot-Marie-Tooth disease, type 1E [MIM: 118300]; Dejerine-Sottas disease [MIM: 145900]; Neuropathy, recurrent, with pressure palsies [MIM: 162500]; Roussy-Levy syndrome [MIM: 180800]",
          "OMIM Entry": "601097",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PMPCA",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 2 [MIM: 213200]",
          "OMIM Entry": "613036",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNKD",
          "Phenotype MIM Number": "Paroxysmal nonkinesigenic dyskinesia 1 [MIM: 118800]",
          "OMIM Entry": "609023",
          "Inheritance": "AD"
        },
        {
          "Gene": "PNKP",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 2B2 [MIM: 605589]; Ataxia-oculomotor apraxia 4 [MIM: 616267]; Microcephaly, seizures, and developmental delay [MIM: 613402]",
          "OMIM Entry": "605610",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNP",
          "Phenotype MIM Number": "Immunodeficiency due to purine nucleoside phosphorylase deficiency [MIM: 613179]",
          "OMIM Entry": "164050",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPLA2",
          "Phenotype MIM Number": "Neutral lipid storage disease with myopathy {MIM: 610717]",
          "OMIM Entry": "609059",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPLA6",
          "Phenotype MIM Number": "Laurence-Moon syndrome [MIM: 245800]; Boucher-Neuhauser syndrome [MIM: 215470]; Oliver-McFarlane syndrome [MIM: 275400]; Spastic paraplegia 39, autosomal recessive [MIM: 612020];",
          "OMIM Entry": "603197",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPLA8",
          "Phenotype MIM Number": "Mitochondrial myopathy with lactic acidosis [MIM: 251950]",
          "OMIM Entry": "612123",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPT1",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 13 [MIM: 614932]; Deafness, autosomal recessive 70, with or without adult-onset neurodegeneration [MIM: 614934]; Spinocerebellar ataxia 25 [MIM: 608703]",
          "OMIM Entry": "610316",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POGLUT1",
          "Phenotype MIM Number": "Dowling-Degos disease 4 [MIM: 615696]; Muscular dystrophy, limb-girdle, autosomal recessive 21 [MIM: 617232]",
          "OMIM Entry": "615618",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLG",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 4A (Alpers type) [MIM: 203700]; Mitochondrial DNA depletion syndrome 4B (MNGIE type) [MIM: 613662]; Mitochondrial recessive ataxia syndrome (includes SANDO and SCAE) [MIM: 607459]; Progressive external ophthalmoplegia, autosomal dominant 1 [mim: 157640]; Progressive external ophthalmoplegia, autosomal recessive 1 [MIM: 258450]",
          "OMIM Entry": "174763",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLG2",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 16 (hepatic type [MIM: 618258]; Mitochondrial DNA depletion syndrome 16B (neuroophthalmic type) [MIM: 619425]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 4 [MIM: 610131]",
          "OMIM Entry": "604983",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLR1C",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 11 [MIM: 616494]; Treacher Collins syndrome 3 [MIM: 248390]",
          "OMIM Entry": "610060",
          "Inheritance": "AR"
        },
        {
          "Gene": "POLR3A",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 7, with or without oligodontia and/or hypogonadotropic hypogonadism [MIM: 607694]; Wiedemann-Rautenstrauch syndrome [MIM: 264090]",
          "OMIM Entry": "614258",
          "Inheritance": "AR"
        },
        {
          "Gene": "POLR3B",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, demyelinating, type 1I [MIM: 619742]; Leukodystrophy, hypomyelinating, 8, with or without oligodontia and/or hypogonadotropic hypogonadism [MIM: 614381]",
          "OMIM Entry": "614366",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POMGNT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 3 [MIM: 253280]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 3 [MIM: 613151]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 3 [MIM: 613157]; Retinitis pigmentosa 76 [MIM: 617123]",
          "OMIM Entry": "606822",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMGNT2",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 8 [MIM: 614830]; Muscular dystrophy-dystroglycanopathy (limb-girdle) type C, 8 [MIM: 618135]",
          "OMIM Entry": "614828",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMK",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 12 [MIM: 616094]; Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 12 [MIM: 615249]",
          "OMIM Entry": "615247",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 1 [MIM: 236670]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 1 [MIM: 613155]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 1 [MIM: 609308]",
          "OMIM Entry": "607423",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMT2",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 2 [MIM: 613150]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 2 [MIM: 613156]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 2 [MIM: 613158]",
          "OMIM Entry": "607439",
          "Inheritance": "AR"
        },
        {
          "Gene": "POPDC1",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 25 [MIM: 616812]",
          "OMIM Entry": "604577",
          "Inheritance": "AR"
        },
        {
          "Gene": "POPDC3",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 26 [MIM: 618848]",
          "OMIM Entry": "605824",
          "Inheritance": "AR"
        },
        {
          "Gene": "PPP1R15B",
          "Phenotype MIM Number": "Microcephaly, short stature, and impaired glucose metabolism 2 [MIM: 616817]",
          "OMIM Entry": "613257",
          "Inheritance": "AR"
        },
        {
          "Gene": "PPP2R2B",
          "Phenotype MIM Number": "Spinocerebellar ataxia 12 [MIM: 604326]",
          "OMIM Entry": "604325",
          "Inheritance": "AD"
        },
        {
          "Gene": "PPP3CA",
          "Phenotype MIM Number": "Arthrogryposis, cleft palate, craniosynostosis, and impaired intellectual development [MIM: 618265]; Developmental and epileptic encephalopathy 91 [MIM: 617711]",
          "OMIM Entry": "114105",
          "Inheritance": "AD"
        },
        {
          "Gene": "PPT1",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 1 [MIM: 256730]",
          "OMIM Entry": "600722",
          "Inheritance": "AR"
        },
        {
          "Gene": "PQBP1",
          "Phenotype MIM Number": "Renpenning syndrome [MIM: 309500]",
          "OMIM Entry": "300463",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PRDM8",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic, 10 [MIM: 616640]",
          "OMIM Entry": "616639",
          "Inheritance": "AR"
        },
        {
          "Gene": "PREPL",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 22 [MIM: 616224]",
          "OMIM Entry": "609557",
          "Inheritance": "AR"
        },
        {
          "Gene": "PRF1",
          "Phenotype MIM Number": "Aplastic anemia [MIM: 609135]; Hemophagocytic lymphohistiocytosis, familial, 2 [MIM: 603553]; Lymphoma, non-Hodgkin [MIM: 605027]",
          "OMIM Entry": "170280",
          "Inheritance": "AR"
        },
        {
          "Gene": "PRICKLE1",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 1B [MIM: 612437]",
          "OMIM Entry": "608500",
          "Inheritance": "AR"
        },
        {
          "Gene": "PRKCG",
          "Phenotype MIM Number": "Spinocerebellar ataxia 14 [MIM: 605361]",
          "OMIM Entry": "176980",
          "Inheritance": "AD"
        },
        {
          "Gene": "PRKN",
          "Phenotype MIM Number": "Adenocarcinoma of lung, somatic [MIM: 211980]; Ovarian cancer, somatic [MIM: 167000]; Parkinson disease, juvenile, type 2 [MIM: 600116]",
          "OMIM Entry": "602544",
          "Inheritance": "AR"
        },
        {
          "Gene": "PRKRA",
          "Phenotype MIM Number": "Dystonia 16 [MIM: 612067]",
          "OMIM Entry": "603424",
          "Inheritance": "AR"
        },
        {
          "Gene": "PROK2",
          "Phenotype MIM Number": "Hypogonadotropic hypogonadism 4 with or without anosmia [MIM: 610628]",
          "OMIM Entry": "607002",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PROKR2",
          "Phenotype MIM Number": "Hypogonadotropic hypogonadism 3 with or without anosmia [MIM: 244200]",
          "OMIM Entry": "607123",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PRPH",
          "Phenotype MIM Number": "{Amyotrophic lateral sclerosis, susceptibility to} [MIM: 105400]",
          "OMIM Entry": "170710",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PRPS1",
          "Phenotype MIM Number": "Arts syndrome [MIM: 301835]; Charcot-Marie-Tooth disease, X-linked recessive, 5 [MIM: 311070];",
          "OMIM Entry": "311850",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": NaN,
          "Phenotype MIM Number": "Deafness, X-linked 1 [MIM: 304500]; Gout, PRPS-related [MIM: 300661]; Phosphoribosylpyrophosphate synthetase superactivity [MIM: 300661]",
          "OMIM Entry": NaN,
          "Inheritance": NaN
        },
        {
          "Gene": "PRRT2",
          "Phenotype MIM Number": "Convulsions, familial infantile, with paroxysmal choreoathetosis [MIM: 602066]; Episodic kinesigenic dyskinesia 1 [MIM: 128200]; Seizures, benign familial infantile, 2 [MIM: 605751]",
          "OMIM Entry": "614386",
          "Inheritance": "AD"
        },
        {
          "Gene": "PRX",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 4F [MIM: 614895]; Dejerine-Sottas disease [MIM: 145900]",
          "OMIM Entry": "605725",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PSAP",
          "Phenotype MIM Number": "{Parkinson disease 24, autosomal dominant, susceptibility to} [MIM: 619491]; Combined SAP deficiency [MIM: 611721]; Gaucher disease, atypical [MIM: 610539]; Krabbe disease, atypical [MIM: 611722]; Metachromatic leukodystrophy due to SAP-b deficiency [MIM: 249900]",
          "OMIM Entry": "176801",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PSAT1",
          "Phenotype MIM Number": "Neu-Laxova syndrome 2 [MIM: 616038]; Phosphoserine aminotransferase deficiency [MIM: 610992]",
          "OMIM Entry": "610936",
          "Inheritance": "AR"
        },
        {
          "Gene": "PSEN1",
          "Phenotype MIM Number": "Acne inversa, familial, 3 [MIM: 613737]; Cardiomyopathy, dilated, 1U [MIM: 613694]; Alzheimer disease, type 3, with or without spastic paraparesis [MIM: 607822]; Dementia, frontotemporal [MIM: 600274]; Pick disease [MIM: 172700]",
          "OMIM Entry": "104311",
          "Inheritance": "AD"
        },
        {
          "Gene": "PSEN2",
          "Phenotype MIM Number": "Alzheimer disease-4 [606889]; Cardiomyopathy, dilated, 1V [MIM: 613697]",
          "OMIM Entry": "600759",
          "Inheritance": "AD"
        },
        {
          "Gene": "PSMB8",
          "Phenotype MIM Number": "Proteasome-associated autoinflammatory syndrome 1 and digenic forms [MIM:256040]",
          "OMIM Entry": "177046",
          "Inheritance": "AR"
        },
        {
          "Gene": "PTEN",
          "Phenotype MIM Number": "{Glioma susceptibility 2} [MIM: 613028]; {Meningioma} [MIM: 607174]; Cowden syndrome 1 [MIM: 158350]; Lhermitte-Duclos disease [MIM: 158350]; Macrocephaly/autism syndrome [MIM: 605309]; Prostate cancer, somatic [MIM: 176807]",
          "OMIM Entry": "601728",
          "Inheritance": "AD"
        },
        {
          "Gene": "PTF1A",
          "Phenotype MIM Number": "Pancreatic agenesis 2 [MIM: 615935]; Pancreatic and cerebellar agenesis [MIM: 609069]",
          "OMIM Entry": "607194",
          "Inheritance": "AR"
        },
        {
          "Gene": "PTPN23",
          "Phenotype MIM Number": "Neurodevelopmental disorder and structural brain anomalies with or without seizures and spasticity [MIM: 618890]",
          "OMIM Entry": "606584",
          "Inheritance": "AR"
        },
        {
          "Gene": "PTRH2",
          "Phenotype MIM Number": "Infantile-onset multisystem neurologic, endocrine, and pancreatic disease [MIM: 616263]",
          "OMIM Entry": "608625",
          "Inheritance": "AR"
        },
        {
          "Gene": "PTRHD1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with early-onset parkinsonism and behavioral abnormalities [MIM: 620747]",
          "OMIM Entry": "617342",
          "Inheritance": "AR"
        },
        {
          "Gene": "PTS",
          "Phenotype MIM Number": "Hyperphenylalaninemia, BH4-deficient, A [MIM: 261640]",
          "OMIM Entry": "612719",
          "Inheritance": "AR"
        },
        {
          "Gene": "PUM1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with motor abnormalities, and facial dysmorphism [MIM: 620719]",
          "OMIM Entry": "607204",
          "Inheritance": "AD"
        },
        {
          "Gene": "PURA",
          "Phenotype MIM Number": "Neurodevelopmental disorder with neonatal respiratory insufficiency, hypotonia, and feeding difficulties [MIM: 616158]",
          "OMIM Entry": "600473",
          "Inheritance": "AD"
        },
        {
          "Gene": "PUS1",
          "Phenotype MIM Number": "Myopathy, lactic acidosis, and sideroblastic anemia 1 [MIM: 600462]",
          "OMIM Entry": "608109",
          "Inheritance": "AR"
        },
        {
          "Gene": "PYCR2",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 10 [MIM: 616420]",
          "OMIM Entry": "616406",
          "Inheritance": "AR"
        },
        {
          "Gene": "PYGM",
          "Phenotype MIM Number": "McArdle disease [MIM: 232600]",
          "OMIM Entry": "608455",
          "Inheritance": "AR"
        },
        {
          "Gene": "PYROXD1",
          "Phenotype MIM Number": "Myopathy, myofibrillar, 8 [MIM: 617258]",
          "OMIM Entry": "617220",
          "Inheritance": "AR"
        },
        {
          "Gene": "QARS1",
          "Phenotype MIM Number": "Microcephaly, progressive, seizures, and cerebral and cerebellar atrophy [MIM: 615760]",
          "OMIM Entry": "603727",
          "Inheritance": "AR"
        },
        {
          "Gene": "QDPR",
          "Phenotype MIM Number": "Hyperphenylalaninemia, BH4-deficient, C [MIM: 261630]",
          "OMIM Entry": "612676",
          "Inheritance": "AR"
        },
        {
          "Gene": "RAB18",
          "Phenotype MIM Number": "Warburg micro syndrome 3 [MIM: 614222]",
          "OMIM Entry": "602207",
          "Inheritance": "AR"
        },
        {
          "Gene": "RAB27A",
          "Phenotype MIM Number": "Griscelli syndrome, type 2 [MIM: 607624]",
          "OMIM Entry": "603868",
          "Inheritance": "AR"
        },
        {
          "Gene": "RAB39B",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked 72 [MIM: 300271]; Waisman syndrome [MIM: 311510]",
          "OMIM Entry": "300774",
          "Inheritance": "XLR"
        },
        {
          "Gene": "RAB3GAP1",
          "Phenotype MIM Number": "Martsolf syndrome 2 [MIM: 619420]; Warburg micro syndrome 1 [MIM: 600118]",
          "OMIM Entry": "602536",
          "Inheritance": "AR"
        },
        {
          "Gene": "RAD50",
          "Phenotype MIM Number": "Nijmegen breakage syndrome-like disorder [MIM: 613078]",
          "OMIM Entry": "604040",
          "Inheritance": "AR"
        },
        {
          "Gene": "RAPGEF2",
          "Phenotype MIM Number": "Familial Adult Myoclonic Epilepsy 7 [MIM: 618075]",
          "OMIM Entry": "609530",
          "Inheritance": "AD"
        },
        {
          "Gene": "RAPSN",
          "Phenotype MIM Number": "Fetal akinesia deformation sequence 2 [MIM: 618388]; Myasthenic syndrome, congenital, 11, associated with acetylcholine receptor deficiency [MIM: 616236]",
          "OMIM Entry": "601592",
          "Inheritance": "AR"
        },
        {
          "Gene": "RARS1",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 9 [MIM: 616140]",
          "OMIM Entry": "107820",
          "Inheritance": "AR"
        },
        {
          "Gene": "RARS2",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 6 [MIM: 611523]",
          "OMIM Entry": "611524",
          "Inheritance": "AR"
        },
        {
          "Gene": "RBCK1",
          "Phenotype MIM Number": "Polyglucosan body myopathy 1 with or without immunodeficiency [MIM: 615895]",
          "OMIM Entry": "610924",
          "Inheritance": "AR"
        },
        {
          "Gene": "REEP1",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal dominant 12 [MIM: 614751]; Neuronopathy, distal hereditary motor, autosomal recessive 6 [MIM: 620011]; Spastic paraplegia 31, autosomal dominant [MIM: 610250]",
          "OMIM Entry": "609139",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "REEP2",
          "Phenotype MIM Number": "Spastic paraplegia 72B, autosomal recessive [MIM: 620606]; Spastic paraplegia 72A, autosomal dominant [MIM: 615625]",
          "OMIM Entry": "609347",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RETREG1",
          "Phenotype MIM Number": "Neuropathy, hereditary sensory and autonomic, type IIB [MIM: 613115]",
          "OMIM Entry": "613114",
          "Inheritance": "AR"
        },
        {
          "Gene": "RFC1",
          "Phenotype MIM Number": "Cerebellar ataxia neuropathy and vestibular areflexia syndrome [MIM: 614575]",
          "OMIM Entry": "102579",
          "Inheritance": "AR"
        },
        {
          "Gene": "RFT1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type In [MIM: 612015]",
          "OMIM Entry": "611908",
          "Inheritance": "AR"
        },
        {
          "Gene": "RHOBTB2",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 64 [MIM: 618004]",
          "OMIM Entry": "607352",
          "Inheritance": "AD"
        },
        {
          "Gene": "RLIM",
          "Phenotype MIM Number": "Tonne-Kalscheuer syndrome [MIM: 300978]",
          "OMIM Entry": "300379",
          "Inheritance": "XL"
        },
        {
          "Gene": "RNASEH1",
          "Phenotype MIM Number": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal recessive 2 [MIM: 616479]",
          "OMIM Entry": "604123",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNASEH2A",
          "Phenotype MIM Number": "Aicardi-Goutieres syndrome 4 [MIM: 610333]",
          "OMIM Entry": "606034",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNASEH2B",
          "Phenotype MIM Number": "Aicardi-Goutieres syndrome 2 [MIM: 610181]",
          "OMIM Entry": "610326",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNASEH2C",
          "Phenotype MIM Number": "Aicardi-Goutieres syndrome 3 [MIM: 610329]",
          "OMIM Entry": "610330",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNASET2",
          "Phenotype MIM Number": "Leukoencephalopathy, cystic, without megalencephaly [MIM: 612951]",
          "OMIM Entry": "612944",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNF113A",
          "Phenotype MIM Number": "Trichothiodystrophy 5, nonphotosensitive [MIM: 300953]",
          "OMIM Entry": "300951",
          "Inheritance": "XL"
        },
        {
          "Gene": "RNF125",
          "Phenotype MIM Number": "Tenorio syndrome [MIM: 616260]",
          "OMIM Entry": "610432",
          "Inheritance": "AD"
        },
        {
          "Gene": "RNF168",
          "Phenotype MIM Number": "RIDDLE syndrome [MIM: 611943]",
          "OMIM Entry": "612688",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNF170",
          "Phenotype MIM Number": "Ataxia, sensory, 1, autosomal dominant [MIM: 608984]; Spastic paraplegia 85, autosomal recessive [MIM: 619686]",
          "OMIM Entry": "614649",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RNF216",
          "Phenotype MIM Number": "Cerebellar ataxia and hypogonadotropic hypogonadism [MIM: 212840]",
          "OMIM Entry": "609948",
          "Inheritance": "AR"
        },
        {
          "Gene": "ROGDI",
          "Phenotype MIM Number": "Kohlschutter-Tonz syndrome [MIM: 226750]",
          "OMIM Entry": "614574",
          "Inheritance": "AR"
        },
        {
          "Gene": "RORA",
          "Phenotype MIM Number": "Intellectual developmental disorder with or without epilepsy or cerebellar ataxia [MIM: 618060]",
          "OMIM Entry": "600825",
          "Inheritance": "AD"
        },
        {
          "Gene": "RPGRIP1L",
          "Phenotype MIM Number": "COACH syndrome 3  [MIM: 619113]; Joubert syndrome 7 [MIM: 611560]; Meckel syndrome 5 [MIM: 611561]",
          "OMIM Entry": "610937",
          "Inheritance": "AR"
        },
        {
          "Gene": "RPIA",
          "Phenotype MIM Number": "Ribose 5-phosphate isomerase deficiency [MIM: 608611]",
          "OMIM Entry": "180430",
          "Inheritance": "AR"
        },
        {
          "Gene": "RPL10",
          "Phenotype MIM Number": "{Autism, susceptibility to, X-linked 5} [MIM: 300847]; Intellectual developmental disorder, X-linked syndromic 35 [MIM: 300998]",
          "OMIM Entry": "312173",
          "Inheritance": "XLR"
        },
        {
          "Gene": "RRM2B",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 8A (encephalomyopathic type with renal tubulopathy) [MIM: 612075]; Mitochondrial DNA depletion syndrome 8B (MNGIE type) [MIM: 612075]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 5 [MIM: 613077]; Rod-cone dystrophy, sensorineural deafness, and Fanconi-type renal dysfunction [MIM: 268315]",
          "OMIM Entry": "604712",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RTN2",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal recessive 11, with spasticity [MIM: 620854]; Spastic paraplegia 12, autosomal dominant [MIM: 604805]",
          "OMIM Entry": "603183",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RTN4IP1",
          "Phenotype MIM Number": "Optic atrophy 10 with or without ataxia, impaired intellectual development and seizures [MIM: 616732]",
          "OMIM Entry": "610502",
          "Inheritance": "AR"
        },
        {
          "Gene": "RTTN",
          "Phenotype MIM Number": "Microcephaly, short stature, and polymicrogyria with seizures [MIM: 614833]",
          "OMIM Entry": "610436",
          "Inheritance": "AR"
        },
        {
          "Gene": "RUBCN",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 15 [MIM: 615705]",
          "OMIM Entry": "613516",
          "Inheritance": "AR"
        },
        {
          "Gene": "RXYLT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 10 [MIM: 615041]",
          "OMIM Entry": "605862",
          "Inheritance": "AR"
        },
        {
          "Gene": "RYR1",
          "Phenotype MIM Number": "{Malignant hyperthermia susceptibility 1} [MIM: 145600]; Congenital myopathy 1A, autosomal dominant, with susceptibility to malignant hyperthermia [MIM: 117000]; Congenital myopathy 1B, autosomal recessive [MIM: 255320]; King-Denborough syndrome [MIM: 619542]",
          "OMIM Entry": "180901",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RYR3",
          "Phenotype MIM Number": "Congenital myopathy 20 [MIM: 620310]",
          "OMIM Entry": "180903",
          "Inheritance": "AR"
        },
        {
          "Gene": "SACS",
          "Phenotype MIM Number": "Spastic ataxia, Charlevoix-Saguenay type [MIM: 270550]",
          "OMIM Entry": "604490",
          "Inheritance": "AR"
        },
        {
          "Gene": "SAMD12",
          "Phenotype MIM Number": "Familial Adult Myoclonic Epilepsy 1 [MIM: 601068]",
          "OMIM Entry": "618073",
          "Inheritance": "AD"
        },
        {
          "Gene": "SAMD9L",
          "Phenotype MIM Number": "Spinocerebellar ataxia 49 [MIM: 619806]; Ataxia-pancytopenia syndrome [MIM: 159550]; Monosomy 7 myelodysplasia and leukemia syndrome 1 [MIM: 252270]",
          "OMIM Entry": "611170",
          "Inheritance": "AD"
        },
        {
          "Gene": "SAMHD1",
          "Phenotype MIM Number": "Chilblain lupus 2  [MIM: 614415]; Aicardi-Goutieres syndrome 5 [MIM: 612952]",
          "OMIM Entry": "606754",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SARS1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with microcephaly, ataxia, and seizures [MIM: 617709]",
          "OMIM Entry": "607529",
          "Inheritance": "AR"
        },
        {
          "Gene": "SCARB2",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 4, with or without renal failure [MIM: 254900]",
          "OMIM Entry": "602257",
          "Inheritance": "AR"
        },
        {
          "Gene": "SCN1A",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 6B, non-Dravet [MIM: 619317]; Dravet syndrome [MIM: 607208]; Febrile seizures, familial, 3A [MIM: 604403]; Generalized epilepsy with febrile seizures plus, type 2 [MIM: 604403]; Migraine, familial hemiplegic, 3 [MIM: 609634]",
          "OMIM Entry": "182389",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCN1B",
          "Phenotype MIM Number": "Atrial fibrillation, familial, 13 [MIM: 615377]; Brugada syndrome 5 [MIM: 612838]; Cardiac conduction defect, nonspecific [MIM: 612838]; Developmental and epileptic encephalopathy 52 [MIM: 617350]; Generalized epilepsy with febrile seizures plus, type 1 [MIM: 604233]",
          "OMIM Entry": "600235",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SCN2A",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 11 [MIM: 613721]; Episodic ataxia, type 9 [MIM: 618924]; Seizures, benign familial infantile, 3 [MIM: 607745]",
          "OMIM Entry": "182390",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCN4A",
          "Phenotype MIM Number": "Congenital myopathy 22A, classic [MIM: 620351]; Congenital myopathy 22B, severe fetal [MIM: 620369]; Hyperkalemic periodic paralysis [MIM: 170500]; Hypokalemic periodic paralysis, type 2 [MIM: 613345]; Myasthenic syndrome, congenital, 16 [MIM: 614198]; Myotonia congenita, atypical, acetazolamide-responsive [MIM: 608390]; Paramyotonia congenita [MIM: 168300]  ",
          "OMIM Entry": "603967",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SCN8A",
          "Phenotype MIM Number": "Myoclonus, familial, 2 [MIM: 618364]; Cognitive impairment with or without cerebellar ataxia [MIM: 614306]; Developmental and epileptic encephalopathy 13 [MIM: 614558]; Seizures, benign familial infantile, 5 [MIM: 617080]",
          "OMIM Entry": "600702",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCN9A",
          "Phenotype MIM Number": "Erythermalgia, primary [MIM: 133020]; Insensitivity to pain, congenital [MIM: 243000]; Neuropathy, hereditary sensory and autonomic, type IID [MIM: 243000]; Paroxysmal extreme pain disorder [MIM: 167400]; Small fiber neuropathy [MIM: 133020]",
          "OMIM Entry": "603415",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SCO1",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 4 [MIM: 619048]",
          "OMIM Entry": "603644",
          "Inheritance": "AR"
        },
        {
          "Gene": "SCO2",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 2 [MIM: 604377]; Myopia 6 [MIM: 608908]",
          "OMIM Entry": "604272",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "SCP2",
          "Phenotype MIM Number": "Leukoencephalopathy with dystonia and motor neuropathy [MIM: 613724]",
          "OMIM Entry": "184755",
          "Inheritance": "AR"
        },
        {
          "Gene": "SCYL1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 21 [MIM: 616719]",
          "OMIM Entry": "607982",
          "Inheritance": "AR"
        },
        {
          "Gene": "SDHA",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1GG [MIM: 613642]; Mitochondrial complex II deficiency, nuclear type 1 [MIM: 252011]; Neurodegeneration with ataxia and late-onset optic atrophy [MIM: 619259]; Pheochromocytoma/paraganglioma syndrome 5 [MIM: 614165]",
          "OMIM Entry": "600857",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SDHAF1",
          "Phenotype MIM Number": "Mitochondrial complex II deficiency, nuclear type 2 [MIM: 619166]",
          "OMIM Entry": "612848",
          "Inheritance": "AR"
        },
        {
          "Gene": "SDHB",
          "Phenotype MIM Number": "Gastrointestinal stromal tumor [MIM: 606764]; Mitochondrial complex II deficiency, nuclear type 4 [MIM: 619224];  Paraganglioma and gastric stromal sarcoma [MIM: 606864]; Pheochromocytoma/paraganglioma syndrome 4 [MIM: 115310]",
          "OMIM Entry": "185470",
          "Inheritance": "AD, AR, IC"
        },
        {
          "Gene": "SDHD",
          "Phenotype MIM Number": "Mitochondrial complex II deficiency, nuclear type 3 [MIM: 619167]; Paraganglioma and gastric stromal sarcoma [MIM: 606864]; Pheochromocytoma/paraganglioma syndrome 1 [MIM: 168000]",
          "OMIM Entry": "602690",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SELENOI",
          "Phenotype MIM Number": "Spastic paraplegia 81, autosomal recessive [MIM: 618768]",
          "OMIM Entry": "607915",
          "Inheritance": "AR"
        },
        {
          "Gene": "SELENON",
          "Phenotype MIM Number": "Congenital myopathy 3 with rigid spine [MIM: 602771]",
          "OMIM Entry": "606210",
          "Inheritance": "AR"
        },
        {
          "Gene": "SEPSECS",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia type 2D [MIM: 613811]",
          "OMIM Entry": "613009",
          "Inheritance": "AR"
        },
        {
          "Gene": "SERAC1",
          "Phenotype MIM Number": "3-methylglutaconic aciduria with deafness, encephalopathy, and Leigh-like syndrome [MIM: 614739]",
          "OMIM Entry": "614725",
          "Inheritance": "AR"
        },
        {
          "Gene": "SETX",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 4, juvenile [MIM: 602433]; Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 2 [MIM: 606002]",
          "OMIM Entry": "608465",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SFXN4",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 18 [MIM: 615578]",
          "OMIM Entry": "615564",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCA",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 3 [MIM: 608099]",
          "OMIM Entry": "600119",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCB",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 4 [MIM: 604286]",
          "OMIM Entry": "600900",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCD",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1L [MIM: 606685]; Muscular dystrophy, limb-girdle, autosomal recessive 6 [MIM: 601287]",
          "OMIM Entry": "601411",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCE",
          "Phenotype MIM Number": "Dystonia-11, myoclonic [MIM: 159900]",
          "OMIM Entry": "604149",
          "Inheritance": "AD"
        },
        {
          "Gene": "SGCG",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 5 [MIM: 253700]",
          "OMIM Entry": "608896",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGPL1",
          "Phenotype MIM Number": "RENI syndrome [MIM: 617575]",
          "OMIM Entry": "603729",
          "Inheritance": "AR"
        },
        {
          "Gene": "SH3TC2",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 4C [MIM: 601596]; Mononeuropathy of the median nerve, mild [MIM: 613353]",
          "OMIM Entry": "608206",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SHMT2",
          "Phenotype MIM Number": "Neurodevelopmental disorder with cardiomyopathy, spasticity, and brain abnormalities [MIM: 619121]",
          "OMIM Entry": "138450",
          "Inheritance": "AR"
        },
        {
          "Gene": "SIGMAR1",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 16, juvenile [MIM: 614373]; Neuronopathy, distal hereditary motor, autosomal recessive 2 [MIM: 605726]",
          "OMIM Entry": "601978",
          "Inheritance": "AR"
        },
        {
          "Gene": "SIL1",
          "Phenotype MIM Number": "Marinesco-Sjogren syndrome [MIM: 248800]",
          "OMIM Entry": "608005",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC12A6",
          "Phenotype MIM Number": "Agenesis of the corpus callosum with peripheral neuropathy [MIM: 218000]; Charcot-Marie-Tooth disease, axonal, type 2II [MIM: 620068]",
          "OMIM Entry": "604878",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC13A5",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 25, with amelogenesis imperfecta [MIM: 615905]",
          "OMIM Entry": "608305",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC16A2",
          "Phenotype MIM Number": "Allan-Herndon-Dudley syndrome [MIM: 300523]",
          "OMIM Entry": "300095",
          "Inheritance": "XL"
        },
        {
          "Gene": "SLC17A5",
          "Phenotype MIM Number": "Salla disease [MIM: 604369]; Sialic acid storage disorder, infantile [MIM: 269920]",
          "OMIM Entry": "604322",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC18A2",
          "Phenotype MIM Number": "Parkinsonism-dystonia, infantile, 2 [MIM: 618049]",
          "OMIM Entry": "193001",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC18A3",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 21, presynaptic [MIM: 617239]",
          "OMIM Entry": "600336",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC19A2",
          "Phenotype MIM Number": "Thiamine-responsive megaloblastic anemia syndrome [MIM: 249270]",
          "OMIM Entry": "603941",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC19A3",
          "Phenotype MIM Number": "Thiamine metabolism dysfunction syndrome 2 (biotin/thiamine-responsive basal ganglia disease type) [MIM: 607483]",
          "OMIM Entry": "606152",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC1A3",
          "Phenotype MIM Number": "Episodic ataxia, type 6 [MIM: 612656]",
          "OMIM Entry": "600111",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC1A4",
          "Phenotype MIM Number": "Spastic tetraplegia, thin corpus callosum, and progressive microcephaly [MIM: 616657]",
          "OMIM Entry": "600229",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC20A2",
          "Phenotype MIM Number": "Basal ganglia calcification, idiopathic, 1 [MIM: 213600]",
          "OMIM Entry": "158378",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC22A5",
          "Phenotype MIM Number": "Carnitine deficiency, systemic primary [MIM: 212140]",
          "OMIM Entry": "603377",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A1",
          "Phenotype MIM Number": "Combined D-2- and L-2-hydroxyglutaric aciduria [MIM: 615182]; Myasthenic syndrome, congenital, 23, presynaptic [MIM: 618197]",
          "OMIM Entry": "190315",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A12",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 39 [MIM: 612949]",
          "OMIM Entry": "603667",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A15",
          "Phenotype MIM Number": "Hyperornithinemia-hyperammonemia-homocitrullinemia syndrome [MIM: 238970]",
          "OMIM Entry": "603861",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A20",
          "Phenotype MIM Number": "Carnitine-acylcarnitine translocase deficiency [MIM: 212138]",
          "OMIM Entry": "613698",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A22",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 3 [MIM: 609304]",
          "OMIM Entry": "609302",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A3",
          "Phenotype MIM Number": "Mitochondrial phosphate carrier deficiency [MIM: 610773]",
          "OMIM Entry": "600370",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A4",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 12A (cardiomyopathic type) AD [MIM: 617184]; Mitochondrial DNA depletion syndrome 12B (cardiomyopathic type) AR [MIM: 615418]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 2 [MIM: 609283]",
          "OMIM Entry": "103220",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC25A42",
          "Phenotype MIM Number": "Metabolic crises, recurrent, with variable encephalomyopathic features and neurologic regression [MIM: 618416]",
          "OMIM Entry": "610823",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A46",
          "Phenotype MIM Number": "Neuropathy, hereditary motor and sensory, type VIB [MIM: 616505]; Pontocerebellar hypoplasia, type 1E [MIM: 619303]",
          "OMIM Entry": "610826",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC2A1",
          "Phenotype MIM Number": "{Epilepsy, idiopathic generalized, susceptibility to, 12} [MIM: 614847]; Dystonia 9 [MIM: 601042]; GLUT1 deficiency syndrome 1, infantile onset, severe [MIM: 606777]; GLUT1 deficiency syndrome 2, childhood onset [MIM: 612126]; Stomatin-deficient cryohydrocytosis with neurologic defects [MIM: 608885]",
          "OMIM Entry": "138140",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC30A10",
          "Phenotype MIM Number": "Hypermanganesemia with dystonia 1 [MIM: 613280]",
          "OMIM Entry": "611146",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC30A9",
          "Phenotype MIM Number": "Birk-Landau-Perez syndrome [MIM: 617595]",
          "OMIM Entry": "604604",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC33A1",
          "Phenotype MIM Number": "Huppke-Brendel syndrome [MIM: 614482]; Spastic paraplegia 42, autosomal dominant [MIM: 612539]",
          "OMIM Entry": "603690",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC39A14",
          "Phenotype MIM Number": "Hyperostosis cranalis interna [MIM: 144755]; Hypermanganesemia with dystonia 2 [MIM: 617013]",
          "OMIM Entry": "608736",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC39A4",
          "Phenotype MIM Number": "Acrodermatitis enteropathica [MIM: 201100]",
          "OMIM Entry": "607059",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC44A1",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with ataxia, tremor, optic atrophy, and cognitive decline [MIM: 618868]",
          "OMIM Entry": "606105",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC46A1",
          "Phenotype MIM Number": "Folate malabsorption, hereditary [MIM: 229050]",
          "OMIM Entry": "611672",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC52A2",
          "Phenotype MIM Number": "Brown-Vialetto-Van Laere syndrome 2 [MIM: 614707]",
          "OMIM Entry": "607882",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC52A3",
          "Phenotype MIM Number": "Fazio-Londe disease [MIM: 211500]; Brown-Vialetto-Van Laere syndrome 1 [MIM: 211530]",
          "OMIM Entry": "613350",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC5A7",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 20, presynaptic [MIM: 617143]; Neuronopathy, distal hereditary motor, autosomal dominant 7 [MIM: 158580]",
          "OMIM Entry": "608761",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC6A1",
          "Phenotype MIM Number": "Myoclonic-atonic epilepsy [MIM: 616421]",
          "OMIM Entry": "137165",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC6A17",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 48 [MIM: 616269]",
          "OMIM Entry": "610299",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC6A19",
          "Phenotype MIM Number": "Hartnup disorder [MIM: 234500]",
          "OMIM Entry": "608893",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC6A3",
          "Phenotype MIM Number": "{Nicotine dependence, protection against} [MIM: 188890]; Parkinsonism-dystonia, infantile, 1 [MIM: 613135]",
          "OMIM Entry": "126455",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC6A8",
          "Phenotype MIM Number": "Cerebral creatine deficiency syndrome 1 [MIM: 300352]",
          "OMIM Entry": "300036",
          "Inheritance": "XLR"
        },
        {
          "Gene": "SLC9A1",
          "Phenotype MIM Number": "Lichtenstein-Knorr syndrome [MIM: 616291]",
          "OMIM Entry": "107310",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC9A6",
          "Phenotype MIM Number": "Intellectual developmental disorder, X-linked syndromic, Christianson type [MIM: 300243]; Neurodegenerative disorder, X-linked, female-restricted, with parkinsonism and cognitive impairment [MIM: 301142]",
          "OMIM Entry": "300231",
          "Inheritance": "XL, XLD"
        },
        {
          "Gene": "SMAD4",
          "Phenotype MIM Number": "Juvenile polyposis/hereditary hemorrhagic telangiectasia syndrome [MIM: 175050]; Myhre syndrome [MIM: 139210]; Pancreatic cancer, somatic [MIM: 260350]; Polyposis, juvenile intestinal [MIM: 174900];",
          "OMIM Entry": "600993",
          "Inheritance": "AD"
        },
        {
          "Gene": "SMC1A",
          "Phenotype MIM Number": "Cornelia de Lange syndrome 2 [MIM: 300590]; Developmental and epileptic encephalopathy 85, with or without midline brain defects [MIM: 301044]",
          "OMIM Entry": "300040",
          "Inheritance": "XLD "
        },
        {
          "Gene": "SMCHD1",
          "Phenotype MIM Number": "Bosma arhinia microphthalmia syndrome [MIM: 603457]; Facioscapulohumeral muscular dystrophy 2, digenic [MIM: 158901]",
          "OMIM Entry": "614982",
          "Inheritance": "AD, DD"
        },
        {
          "Gene": "SMG9",
          "Phenotype MIM Number": "Heart and brain malformation syndrome [MIM: 616920]; Neurodevelopmental disorder with intention tremor, pyramidal signs, dyspraxia, and ocular anomalies [MIM: 619995]",
          "OMIM Entry": "613176",
          "Inheritance": "AR"
        },
        {
          "Gene": "SMPD1",
          "Phenotype MIM Number": "Niemann-Pick disease, type A [MIM: 257200]; Niemann-Pick disease, type B [MIM: 607616]",
          "OMIM Entry": "607608",
          "Inheritance": "AR"
        },
        {
          "Gene": "SMPX",
          "Phenotype MIM Number": "Deafness, X-linked 4 [MIM: 300066]; Myopathy, distal, 7, adult-onset, X-linked [MIM: 301075]",
          "OMIM Entry": "300226",
          "Inheritance": "XLD, XLR"
        },
        {
          "Gene": "SNAP25",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 117 [MIM: 616330]",
          "OMIM Entry": "600322",
          "Inheritance": "AD"
        },
        {
          "Gene": "SNCA",
          "Phenotype MIM Number": "Dementia, Lewy body [MIM: 127750]; Parkinson disease 1 [MIM: 168601]; Parkinson disease 4 [MIM: 605543]",
          "OMIM Entry": "163890",
          "Inheritance": "AD"
        },
        {
          "Gene": "SNORD118",
          "Phenotype MIM Number": "Leukoencephalopathy, brain calcifications, and cysts [MIM: 614561]",
          "OMIM Entry": "616663",
          "Inheritance": "AR"
        },
        {
          "Gene": "SNX14",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 20 [MIM: 616354]",
          "OMIM Entry": "616105",
          "Inheritance": "AR"
        },
        {
          "Gene": "SOD1",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 1 [MIM: 105400]; Spastic tetraplegia and axial hypotonia, progressive [MIM: 618598]",
          "OMIM Entry": "147450",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SOX10",
          "Phenotype MIM Number": "PCWH syndrome [MIM: 609136]; Waardenburg syndrome, type 2E, with or without neurologic involvement [MIM: 611584]; Waardenburg syndrome, type 4C [MIM: 613266]",
          "OMIM Entry": "602229",
          "Inheritance": "AD"
        },
        {
          "Gene": "SOX2",
          "Phenotype MIM Number": "Microphthalmia, syndromic 3 [MIM: 206900]; Optic nerve hypoplasia and abnormalities of the central nervous system [MIM: 206900]",
          "OMIM Entry": "184429",
          "Inheritance": "AD"
        },
        {
          "Gene": "SOX6",
          "Phenotype MIM Number": "Tolchin-Le Caignec syndrome [MIM: 618971]",
          "OMIM Entry": "607257",
          "Inheritance": "AD"
        },
        {
          "Gene": "SPART",
          "Phenotype MIM Number": "Troyer syndrome [MIM: 275900]",
          "OMIM Entry": "607111",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPAST",
          "Phenotype MIM Number": "Spastic paraplegia 4, autosomal dominant [MIM: 182601]",
          "OMIM Entry": "604277",
          "Inheritance": "AD"
        },
        {
          "Gene": "SPEG",
          "Phenotype MIM Number": "Centronuclear myopathy 5 [MIM: 615959]",
          "OMIM Entry": "615950",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPG11",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 5, juvenile [MIM: 602099]; Charcot-Marie-Tooth disease, axonal, type 2X [MIM: 616668]; Spastic paraplegia 11, autosomal recessive [MIM: 604360]",
          "OMIM Entry": "610844",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPG21",
          "Phenotype MIM Number": "Mast syndrome [MIM: 248900]",
          "OMIM Entry": "608181",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPG7",
          "Phenotype MIM Number": "Spastic paraplegia 7, autosomal recessive [MIM: 607259]",
          "OMIM Entry": "602783",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPR",
          "Phenotype MIM Number": "Dystonia, dopa-responsive, due to sepiapterin reductase deficiency [MIM: 612716]",
          "OMIM Entry": "182125",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SPTAN1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 5 [MIM: 613477]; Developmental delay with or without epilepsy [MIM: 620540]; Neuronopathy, distal hereditary motor, autosomal dominant 11 [MIM: 620528]; Spastic paraplegia 91, autosomal dominant, with or without cerebellar ataxia [MIM: 620538]",
          "OMIM Entry": "182810",
          "Inheritance": "AD"
        },
        {
          "Gene": "SPTBN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 5 [MIM: 600224]; Spinocerebellar ataxia, autosomal recessive 14 [MIM: 615386]",
          "OMIM Entry": "604985",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SPTBN4",
          "Phenotype MIM Number": "Neurodevelopmental disorder with hypotonia, neuropathy, and deafness [MIM: 617519]",
          "OMIM Entry": "606214",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPTLC2",
          "Phenotype MIM Number": "Neuropathy, hereditary sensory and autonomic, type IC [MIM: 613640]",
          "OMIM Entry": "605713",
          "Inheritance": "AD"
        },
        {
          "Gene": "SQSTM1",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 3 [MIM: 616437]; Myopathy, distal, with rimmed vacuoles [MIM: 617158]; Neurodegeneration with ataxia, dystonia, and gaze palsy, childhood-onset [MIM: 617145]; Paget disease of bone 3 [MIM: 167250]",
          "OMIM Entry": "601530",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "STAC3",
          "Phenotype MIM Number": "Congenital myopathy 13 [MIM: 255995]",
          "OMIM Entry": "615521",
          "Inheritance": "AR"
        },
        {
          "Gene": "STAMBP",
          "Phenotype MIM Number": "Microcephaly-capillary malformation syndrome [MIM: 614261]",
          "OMIM Entry": "606247",
          "Inheritance": "AR"
        },
        {
          "Gene": "STIM1",
          "Phenotype MIM Number": "Immunodeficiency 10 [MIM: 612783]; Myopathy, tubular aggregate, 1 [MIM: 160565]; Stormorken syndrome [MIM: 185070]",
          "OMIM Entry": "605921",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "STN1",
          "Phenotype MIM Number": "Cerebroretinal microangiopathy with calcifications and cysts 2 [MIM: 617341]",
          "OMIM Entry": "613128",
          "Inheritance": "AR"
        },
        {
          "Gene": "STUB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 48 [MIM: 618093]; Spinocerebellar ataxia, autosomal recessive 16 [MIM: 615768]",
          "OMIM Entry": "607207",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "STXBP1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 4 [MIM: 612164]",
          "OMIM Entry": "602926",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SUCLA2",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 5 (encephalomyopathic with or without methylmalonic aciduria) [MIM: 612073]",
          "OMIM Entry": "603921",
          "Inheritance": "AR"
        },
        {
          "Gene": "SUCLG1",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 9 (encephalomyopathic type with methylmalonic aciduria) [MIM: 245400]",
          "OMIM Entry": "611224",
          "Inheritance": "AR"
        },
        {
          "Gene": "SUFU",
          "Phenotype MIM Number": "{Medulloblastoma} [MIM: 155255]; {Meningioma, familial, susceptibility to} [MIM: 607174]; Basal cell nevus syndrome 2 [MIM: 620343]; Joubert syndrome 32 [MIM: 617757]",
          "OMIM Entry": "607035",
          "Inheritance": "AD, AR, Smu"
        },
        {
          "Gene": "SUMF1",
          "Phenotype MIM Number": "Multiple sulfatase deficiency [MIM: 272200]",
          "OMIM Entry": "607939",
          "Inheritance": "AR"
        },
        {
          "Gene": "SUOX",
          "Phenotype MIM Number": "Sulfite oxidase deficiency [MIM: 272300]",
          "OMIM Entry": "606887",
          "Inheritance": "AR"
        },
        {
          "Gene": "SURF1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 4K [MIM: 616684]; Mitochondrial complex IV deficiency, nuclear type 1 [MIM: 220110]",
          "OMIM Entry": "185620",
          "Inheritance": "AR"
        },
        {
          "Gene": "SVBP",
          "Phenotype MIM Number": "Neurodevelopmental disorder with ataxia, hypotonia, and microcephaly [MIM: 618569]",
          "OMIM Entry": "617853",
          "Inheritance": "AR"
        },
        {
          "Gene": "SYNE1",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 3, myogenic type [MIM: 618484]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 612998]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 610743]",
          "OMIM Entry": "608441",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SYNE2",
          "Phenotype MIM Number": "Emery-Dreifuss muscular dystrophy 5, autosomal dominant [MIM: 612999]",
          "OMIM Entry": "608442",
          "Inheritance": "AD"
        },
        {
          "Gene": "SYNJ1",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 53 [MIM: 617389]; Parkinson disease 20, early-onset [MIM: 615530]",
          "OMIM Entry": "604297",
          "Inheritance": "AR"
        },
        {
          "Gene": "SYT14",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 11 [MIM: 614229]",
          "OMIM Entry": "610949",
          "Inheritance": "AR"
        },
        {
          "Gene": "SYT2",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 7A, presynaptic, and distal motor neuropathy, autosomal dominant [MIM: 616040]; Myasthenic syndrome, congenital, 7B, presynaptic, autosomal recessive [MIM: 619461]",
          "OMIM Entry": "600104",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TACO1",
          "Phenotype MIM Number": "Mitochondrial complex IV deficiency, nuclear type 8 [MIM: 619052]",
          "OMIM Entry": "612958",
          "Inheritance": "AR"
        },
        {
          "Gene": "TAF1",
          "Phenotype MIM Number": "Dystonia-Parkinsonism, X-linked [MIM: 314250]; Intellectual developmental disorder, X-linked syndromic 33 [MIM: 300966]",
          "OMIM Entry": "313650",
          "Inheritance": "XLR"
        },
        {
          "Gene": "TAF2",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 40 [MIM: 615599]",
          "OMIM Entry": "604912",
          "Inheritance": "AR"
        },
        {
          "Gene": "TAFAZZIN",
          "Phenotype MIM Number": "Barth syndrome [MIM: 302060]",
          "OMIM Entry": "300394",
          "Inheritance": "XLR"
        },
        {
          "Gene": "TAMM41",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 56 [MIM: 620139]",
          "OMIM Entry": "614948",
          "Inheritance": "AR"
        },
        {
          "Gene": "TANGO2",
          "Phenotype MIM Number": "Metabolic encephalomyopathic crises, recurrent, with rhabdomyolysis, cardiac arrhythmias, and neurodegeneration [MIM: 616878]",
          "OMIM Entry": "616830",
          "Inheritance": "AR"
        },
        {
          "Gene": "TARDBP",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 10, with or without FTD [MIM: 612069]; Frontotemporal lobar degeneration, TARDBP-related [MIM: 612069]",
          "OMIM Entry": "605078",
          "Inheritance": "AD"
        },
        {
          "Gene": "TBC1D20",
          "Phenotype MIM Number": "Warburg micro syndrome 4 [MIM: 615663]",
          "OMIM Entry": "611663",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBC1D23",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 11 [MIM: 617695]",
          "OMIM Entry": "617687",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBC1D24",
          "Phenotype MIM Number": "Deafness, autosomal dominant 65 [MIM: 616044]; Deafness, autosomal recessive 86 [MIM: 614617]; Developmental and epileptic encephalopathy 16 [MIM: 615338]; DOORS syndrome [MIM: 220500]; Epilepsy, rolandic, with paroxysmal exercise-induce dystonia and writer's cramp [MIM: 608105]; Myoclonic epilepsy, infantile, familial [MIM: 605021]",
          "OMIM Entry": "613577",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TBCD",
          "Phenotype MIM Number": "Encephalopathy, progressive, early-onset, with brain atrophy and thin corpus callosum [MIM: 617193]",
          "OMIM Entry": "604649",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBCE",
          "Phenotype MIM Number": "Encephalopathy, progressive, with amyotrophy and optic atrophy [MIM: 617207]; Hypoparathyroidism-retardation-dysmorphism syndrome [MIM: 241410]; Kenny-Caffey syndrome, type 1 [MIM: 244460]",
          "OMIM Entry": "604934",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBCK",
          "Phenotype MIM Number": "Hypotonia, infantile, with psychomotor retardation and characteristic facies 3 [MIM: 616900]",
          "OMIM Entry": "616899",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBK1",
          "Phenotype MIM Number": "{Encephalopathy, acute, infection-induced (herpes-specific), susceptibility to, 8} [MIM: 617900]; Autoinflammation with arthritis and vasculitis [MIM: 620880]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 4 [MIM: 616439]",
          "OMIM Entry": "604834",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TBP  ",
          "Phenotype MIM Number": "{Parkinson disease susceptibility to} [MIM: 168600]; Spinocerebellar ataxia 17 [MIM: 607136]",
          "OMIM Entry": "600075",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "TCAP",
          "Phenotype MIM Number": "Cardiomyopathy, hypertrophic, 25 [MIM: 607487]; Muscular dystrophy, limb-girdle, autosomal recessive 7 [MIM: 601954]",
          "OMIM Entry": "604488",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "TCF4",
          "Phenotype MIM Number": "Corneal dystrophy, Fuchs endothelial, 3 [MIM: 613267]; Pitt-Hopkins syndrome [MIM: 610954]",
          "OMIM Entry": "602272",
          "Inheritance": "AD"
        },
        {
          "Gene": "TCN2",
          "Phenotype MIM Number": "Transcobalamin II deficiency [MIM: 275350]",
          "OMIM Entry": "613441",
          "Inheritance": "AR"
        },
        {
          "Gene": "TCTN1",
          "Phenotype MIM Number": "Joubert syndrome 13 [MIM: 614173]",
          "OMIM Entry": "609863",
          "Inheritance": "AR"
        },
        {
          "Gene": "TCTN2",
          "Phenotype MIM Number": "Meckel syndrome 8  [MIM: 613885]; Joubert syndrome 24 [MIM: 616654]",
          "OMIM Entry": "613846",
          "Inheritance": "AR"
        },
        {
          "Gene": "TCTN3",
          "Phenotype MIM Number": "Joubert syndrome 18 [MIM: 614815]; Orofaciodigital syndrome IV [MIM: 258860]",
          "OMIM Entry": "613847",
          "Inheritance": "AR"
        },
        {
          "Gene": "TDP1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 1 [MIM: 607250]",
          "OMIM Entry": "607198",
          "Inheritance": "AR"
        },
        {
          "Gene": "TDP2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 23 [MIM: 616949]",
          "OMIM Entry": "605764",
          "Inheritance": "AR"
        },
        {
          "Gene": "TECPR2",
          "Phenotype MIM Number": "Neuropathy, hereditary sensory and autonomic, type IX, with developmental delay [MIM: 615031]",
          "OMIM Entry": "615000",
          "Inheritance": "AR"
        },
        {
          "Gene": "TELO2",
          "Phenotype MIM Number": "You-Hoover-Fong syndrome [MIM: 616954]",
          "OMIM Entry": "611140",
          "Inheritance": "AR"
        },
        {
          "Gene": "TENM4",
          "Phenotype MIM Number": "Essential tremor, hereditary, 5 [MIM: 616736]",
          "OMIM Entry": "610084",
          "Inheritance": "AD"
        },
        {
          "Gene": "TFG",
          "Phenotype MIM Number": "Spastic paraplegia 57, autosomal recessive [MIM: 615658]; Hereditary motor and sensory neuropathy, Okinawa type [MIM: 604484]",
          "OMIM Entry": "602498",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TGM6",
          "Phenotype MIM Number": "Spinocerebellar ataxia 35 [MIM: 613908]",
          "OMIM Entry": "613900",
          "Inheritance": "AD"
        },
        {
          "Gene": "TH",
          "Phenotype MIM Number": "Segawa syndrome, recessive [MIM: 605407]",
          "OMIM Entry": "191290",
          "Inheritance": "AR"
        },
        {
          "Gene": "THAP1",
          "Phenotype MIM Number": "Dystonia 6, torsion [MIM: 602629]",
          "OMIM Entry": "609520",
          "Inheritance": "AD"
        },
        {
          "Gene": "THAP11",
          "Phenotype MIM Number": "Spinocerebellar Ataxia 51 [MIM: 620947]",
          "OMIM Entry": "609119",
          "Inheritance": "AD"
        },
        {
          "Gene": "THG1L",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 28 [MIM: 618800]",
          "OMIM Entry": "618802",
          "Inheritance": "AR"
        },
        {
          "Gene": "THOC2",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 7, X-linked [MIM: 301127]; Intellectual developmental disorder, X-linked syndromic, Kumar type [MIM: 300957]",
          "OMIM Entry": "300395",
          "Inheritance": "XL"
        },
        {
          "Gene": "TIA1",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 26 with or without frontotemporal dementia [MIM: 619133]; Welander distal myopathy [MIM: 604454]",
          "OMIM Entry": "603518",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TIMM8A",
          "Phenotype MIM Number": "Mohr-Tranebjaerg syndrome [MIM: 304700]",
          "OMIM Entry": "300356",
          "Inheritance": "XLR"
        },
        {
          "Gene": "TIMMDC1",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 31 [MIM: 618251]",
          "OMIM Entry": "615534",
          "Inheritance": "AR"
        },
        {
          "Gene": "TINF2",
          "Phenotype MIM Number": "Dyskeratosis congenita, autosomal dominant 3 [MIM: 613990]; Revesz syndrome [MIM: 268130]",
          "OMIM Entry": "604319",
          "Inheritance": "AD"
        },
        {
          "Gene": "TK2",
          "Phenotype MIM Number": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal recessive 3 [MIM: 617069]; Mitochondrial DNA depletion syndrome 2 (myopathic type) [MIM: 609560]",
          "OMIM Entry": "188250",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM107",
          "Phenotype MIM Number": "Joubert syndrome 29 [MIM: 617562]; Meckel syndrome 13 [MIM: 617562]; Orofaciodigital syndrome XVI [MIM: 617563]",
          "OMIM Entry": "616183",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM126B",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 29 [MIM: 618250]",
          "OMIM Entry": "615533",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM138",
          "Phenotype MIM Number": "Joubert syndrome 16 [MIM: 614465]",
          "OMIM Entry": "614459",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM216",
          "Phenotype MIM Number": "Joubert syndrome 2 [MIM: 608091]; Meckel syndrome 2 [MIM: 603194]; Retinitis pigmentosa 98 [MIM: 620996]",
          "OMIM Entry": "613277",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM231",
          "Phenotype MIM Number": "Joubert syndrome 20 [MIM: 614970]; Meckel syndrome 11 [MIM: 615397]",
          "OMIM Entry": "614949",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM237",
          "Phenotype MIM Number": "Joubert syndrome 14 [MIM: 614424]",
          "OMIM Entry": "614423",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM240",
          "Phenotype MIM Number": "Spinocerebellar ataxia 21 [MIM: 607454]",
          "OMIM Entry": "616101",
          "Inheritance": "AD"
        },
        {
          "Gene": "TMEM43",
          "Phenotype MIM Number": "Arrhythmogenic right ventricular dysplasia 5 [MIM: 604400]; Auditory neuropathy, autosomal dominant 3 [MIM: 619832]; Emery-Dreifuss muscular dystrophy 7, AD [MIM: 614302]",
          "OMIM Entry": "612048",
          "Inheritance": "AD"
        },
        {
          "Gene": "TMEM67",
          "Phenotype MIM Number": "RHYNS syndrome [MIM: 602152]; {Bardet-Biedl syndrome 14, modifier of} [MIM: 615991]; COACH syndrome 1 [MIM: 216360]; Joubert syndrome 6 [MIM: 610688]; Meckel syndrome 3 [MIM: 607361]; Nephronophthisis 11 [MIM: 613550]",
          "OMIM Entry": "609884",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM70",
          "Phenotype MIM Number": "Mitochondrial complex V (ATP synthase) deficiency, nuclear type 2 [MIM: 614052]",
          "OMIM Entry": "612418",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMX2",
          "Phenotype MIM Number": "Neurodevelopmental disorder with microcephaly, cortical malformations, and spasticity [MIM: 618730]",
          "OMIM Entry": "616715",
          "Inheritance": "AR"
        },
        {
          "Gene": "TNNC2",
          "Phenotype MIM Number": "Congenital myopathy 15 [MIM: 620161]",
          "OMIM Entry": "191039",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNI2",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 2B1 [MIM: 601680]",
          "OMIM Entry": "191043",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNT1",
          "Phenotype MIM Number": "Nemaline myopathy 5A, autosomal recessive, severe infantile [MIM: 605355]; Nemaline myopathy 5B, autosomal recessive, childhood-onset [MIM: 620386]; Nemaline myopathy 5C, autosomal dominant [MIM: 620389]",
          "OMIM Entry": "191041",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNT3",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 2B2 [MIM: 618435]",
          "OMIM Entry": "600692",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNPO3",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 2 [MIM: 608423]",
          "OMIM Entry": "610032",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNRC6A",
          "Phenotype MIM Number": "Epilepsy, familial adult myoclonic, 6 [MIM: 618074]",
          "OMIM Entry": "610739",
          "Inheritance": "AD"
        },
        {
          "Gene": "TOR1A",
          "Phenotype MIM Number": "{Dystonia-1, modifier of}; Arthrogryposis multiplex congenita 5 [MIM: 618947]; Dystonia-1, torsion [MIM: 128100]",
          "OMIM Entry": "605204",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TOR1AIP1",
          "Phenotype MIM Number": "Muscular dystrophy, autosomal recessive, with rigid spine and distal joint contractures [MIM: 617072]",
          "OMIM Entry": "614512",
          "Inheritance": "AR"
        },
        {
          "Gene": "TP53RK",
          "Phenotype MIM Number": "Galloway-Mowat syndrome 4 [MIM: 617730]",
          "OMIM Entry": "608679",
          "Inheritance": "AR"
        },
        {
          "Gene": "TPI1",
          "Phenotype MIM Number": "Hemolytic anemia due to triosephosphate isomerase deficiency [MIM: 615512]",
          "OMIM Entry": "190450",
          "Inheritance": "AR"
        },
        {
          "Gene": "TPK1",
          "Phenotype MIM Number": "Thiamine metabolism dysfunction syndrome 5 (episodic encephalopathy type) [MIM: 614458]",
          "OMIM Entry": "606370",
          "Inheritance": "AR"
        },
        {
          "Gene": "TPM2",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 1A [MIM: 108120]; Arthrogryposis, distal, type 2B4 [MIM: 108120]; Congenital myopathy 23 [MIM: 609285]",
          "OMIM Entry": "190990",
          "Inheritance": "AD"
        },
        {
          "Gene": "TPM3",
          "Phenotype MIM Number": "Congenital myopathy 4A, autosomal dominant [MIM: 255310]; Congenital myopathy 4B, autosomal recessive [MIM: 609284]",
          "OMIM Entry": "191030",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TPP1",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 2 [MIM: 204500]; Spinocerebellar ataxia, autosomal recessive 7 [MIM: 609270]",
          "OMIM Entry": "607998",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRAPPC11",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 18 [MIM: 615356]",
          "OMIM Entry": "614138",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRAPPC12",
          "Phenotype MIM Number": "Encephalopathy, progressive, early-onset, with brain atrophy and spasticity [MIM: 617669]",
          "OMIM Entry": "614139",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRAPPC4",
          "Phenotype MIM Number": "Neurodevelopmental disorder with epilepsy, spasticity, and brain atrophy [MIM: 618741]",
          "OMIM Entry": "610971",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRDN",
          "Phenotype MIM Number": "Cardiac arrhythmia syndrome, with or without skeletal muscle weakness [MIM: 615441]",
          "OMIM Entry": "603283",
          "Inheritance": "AR"
        },
        {
          "Gene": "TREM2",
          "Phenotype MIM Number": "{Alzheimer disease 17, susceptibility to} [MIM: 615080]; Polycystic lipomembranous osteodysplasia with sclerosing leukoencephalopathy 2 [MIM: 618193]",
          "OMIM Entry": "605086",
          "Inheritance": "AR"
        },
        {
          "Gene": "TREX1",
          "Phenotype MIM Number": "{Systemic lupus erythematosus, susceptibility to} [MIM: 152700]; Aicardi-Goutieres syndrome 1, dominant and recessive [MIM: 225750]; Chilblain lupus [MIM: 610448]; Vasculopathy, retinal, with cerebral leukoencephalopathy and systemic manifestations [MIM: 192315]",
          "OMIM Entry": "606609",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TRIM32",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 11 [MIM: 615988]; Muscular dystrophy, limb-girdle, autosomal recessive 8 [MIM: 254110]",
          "OMIM Entry": "602290",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRIP4",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, Davignon-Chauveau type [MIM: 617066]; Spinal muscular atrophy with congenital bone fractures 1 [MIM: 616866]",
          "OMIM Entry": "604501",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRMT5",
          "Phenotype MIM Number": "Peripheral neuropathy with variable spasticity, exercise intolerance, and developmental delay [616539]",
          "OMIM Entry": "611023",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRNT1",
          "Phenotype MIM Number": "Retinitis pigmentosa and erythrocytic microcytosis [MIM: 616959]; Sideroblastic anemia with B-cell immunodeficiency, periodic fevers, and developmental delay [MIM: 616084]",
          "OMIM Entry": "612907",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRPC3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 41  [MIM: 616410]",
          "OMIM Entry": "602345",
          "Inheritance": "AD"
        },
        {
          "Gene": "TRPM7",
          "Phenotype MIM Number": "{Amyotrophic lateral sclerosis-parkinsonism/dementia complex, susceptibility to} [MIM: 105500]",
          "OMIM Entry": "605692",
          "Inheritance": "AD"
        },
        {
          "Gene": "TRPV4",
          "Phenotype MIM Number": "Avascular necrosis of femoral head, primary, 2 [MIM: 617383]; [Sodium serum level QTL 1] [MIM: 613508]; Brachyolmia type 3 [MIM: 113500]; Digital arthropathy-brachydactyly, familial [MIM: 606835]; Hereditary motor and sensory neuropathy, type Iic [MIM: 606071]; Metatropic dysplasia [MIM: 156530]; Neuronopathy, distal hereditary motor, autosomal dominant 8 [MIM: 600175]; Parastremmatic dwarfism [MIM: 168400]; Scapuloperoneal spinal muscular atrophy [MIM: 181405]; SED, Maroteaux type [MIM: 184095]; Spondylometaphyseal dysplasia, Kozlowski type [MIM: 184252] ",
          "OMIM Entry": "605427",
          "Inheritance": "AD"
        },
        {
          "Gene": "TSEN15",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 2F [MIM: 617026]",
          "OMIM Entry": "608756",
          "Inheritance": "AR"
        },
        {
          "Gene": "TSEN2",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia type 2B [MIM: 612389]",
          "OMIM Entry": "608753",
          "Inheritance": "AR"
        },
        {
          "Gene": "TSEN54",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia type 5  [MIM: 610204]; Pontocerebellar hypoplasia type 2A [MIM: 277470]; Pontocerebellar hypoplasia type 4 [MIM: 225753]",
          "OMIM Entry": "608755",
          "Inheritance": "AR"
        },
        {
          "Gene": "TSFM",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 3 [MIM: 610505]",
          "OMIM Entry": "604723",
          "Inheritance": "AR"
        },
        {
          "Gene": "TTBK2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 11 [MIM: 604432]",
          "OMIM Entry": "611695",
          "Inheritance": "AD"
        },
        {
          "Gene": "TTC19",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 2 [MIM: 615157]",
          "OMIM Entry": "613814",
          "Inheritance": "AR"
        },
        {
          "Gene": "TTC21B",
          "Phenotype MIM Number": "Nephronophthisis 12 [MIM: 613820]; Short-rib thoracic dysplasia 4 with or without polydactyly [MIM: 613819]",
          "OMIM Entry": "612014",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TTN",
          "Phenotype MIM Number": "Cardiomyopathy, familial hypertrophic, 9 [MIM: 613765]; Cardiomyopathy, dilated, 1G [MIM: 604145]; Congenital myopathy 5 with cardiomyopathy [MIM: 611705]; Muscular dystrophy, limb-girdle, autosomal recessive 10 [MIM: 608807]; Myopathy myofibrillar, 9, with early respiratory failure [MIM: 603689]; Tibial muscular dystrophy, tardive [MIM: 600334]",
          "OMIM Entry": "188840",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TTPA",
          "Phenotype MIM Number": "Ataxia with isolated vitamin E deficiency [MIM: 277460]",
          "OMIM Entry": "600415",
          "Inheritance": "AR"
        },
        {
          "Gene": "TTR",
          "Phenotype MIM Number": "[Dystransthyretinemic hyperthyroxinemia] [MIM: 145680]; Amyloidosis, hereditary systemic 1 [MIM: 105210]; Carpal tunnel syndrome, familial [MIM: 115430]",
          "OMIM Entry": "176300",
          "Inheritance": "AD"
        },
        {
          "Gene": "TUBA4A",
          "Phenotype MIM Number": "Congenital myopathy 26 [MIM: 621225]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 9 [MIM: 616208]; Oocyte/zygote/embryo maturation arrest 23 [MIM: 621231]; Spastic ataxia 11, autosomal dominant [MIM: 621226]",
          "OMIM Entry": "191110",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TUBB",
          "Phenotype MIM Number": "Cortical dysplasia, complex, with other brain malformations 6 [MIM:615771]; Symmetric circumferential skin creases, congenital, 1 [MIM: 156610]",
          "OMIM Entry": "191130",
          "Inheritance": "AD"
        },
        {
          "Gene": "TUBB3",
          "Phenotype MIM Number": "Cortical dysplasia, complex, with other brain malformations 1 [MIM: 614039]; Fibrosis of extraocular muscles, congenital, 3A [MIM: 600638]",
          "OMIM Entry": "602661",
          "Inheritance": "AD"
        },
        {
          "Gene": "TUBB4A",
          "Phenotype MIM Number": "Dystonia 4, torsion, autosomal dominant [MIM: 128101]; Leukodystrophy, hypomyelinating, 6 [MIM: 612438]",
          "OMIM Entry": "602662",
          "Inheritance": "AD"
        },
        {
          "Gene": "TUBG1",
          "Phenotype MIM Number": "Cortical dysplasia, complex, with other brain malformations 4 [MIM: 615412]",
          "OMIM Entry": "191135",
          "Inheritance": "AD"
        },
        {
          "Gene": "TWNK",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 7 (hepatocerebral type) [MIM: 271245]; Perrault syndrome 5 [MIM: 616138]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 3 [MIM: 609286]",
          "OMIM Entry": "606075",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TXN2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 29 [MIM: 616811]",
          "OMIM Entry": "609063",
          "Inheritance": "AR"
        },
        {
          "Gene": "TYMP",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 1 (MNGIE type) [MIM: 603041]",
          "OMIM Entry": "131222",
          "Inheritance": "AR"
        },
        {
          "Gene": "TYROBP",
          "Phenotype MIM Number": "Polycystic lipomembranous osteodysplasia with sclerosing leukoencephalopathy 1 [MIM: 221770]",
          "OMIM Entry": "604142",
          "Inheritance": "AR"
        },
        {
          "Gene": "UBA1",
          "Phenotype MIM Number": "Spinal muscular atrophy, X-linked 2, infantile [MIM: 301830]; VEXAS syndrome, somatic [MIM: 301054]",
          "OMIM Entry": "314370",
          "Inheritance": "XLR"
        },
        {
          "Gene": "UBA5",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 24[ MIM: 617133]; Developmental and epileptic encephalopathy 44 [MIM: 617132]",
          "OMIM Entry": "610552",
          "Inheritance": "AR"
        },
        {
          "Gene": "UBE3A",
          "Phenotype MIM Number": "Angelman syndrome [MIM: 105830]",
          "OMIM Entry": "601623",
          "Inheritance": "AD"
        },
        {
          "Gene": "UBQLN2",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 15, with or without frontotemporal dementia [MIM: 300857]",
          "OMIM Entry": "300264",
          "Inheritance": "XLD"
        },
        {
          "Gene": "UBTF",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with brain atrophy [MIM: 617672]",
          "OMIM Entry": "600673",
          "Inheritance": "AD"
        },
        {
          "Gene": "UCHL1",
          "Phenotype MIM Number": "{Parkinson disease 5, susceptibility to} [MIM: 613643]; Spastic paraplegia 79A, autosomal dominant [MIM: 620221]; Spastic paraplegia 79B, autosomal recessive [MIM: 615491]",
          "OMIM Entry": "191342",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "UFC1",
          "Phenotype MIM Number": "Neurodevelopmental disorder with spasticity and poor growth [MIM: 618076]",
          "OMIM Entry": "610554",
          "Inheritance": "AR"
        },
        {
          "Gene": "UNC45B",
          "Phenotype MIM Number": "Cataract 43 [MIM: 616279]; Myofibrillar myopathy 11 [MIM: 619178]",
          "OMIM Entry": "611220",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "UNC80",
          "Phenotype MIM Number": "Hypotonia, infantile, with psychomotor retardation and characteristic facies 2 [MIM: 616801]",
          "OMIM Entry": "612636",
          "Inheritance": "AR"
        },
        {
          "Gene": "UPB1",
          "Phenotype MIM Number": "Beta-ureidopropionase deficiency [MIM: 613161]",
          "OMIM Entry": "606673",
          "Inheritance": "AR"
        },
        {
          "Gene": "UQCC2",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 7 [MIM: 615824]",
          "OMIM Entry": "614461",
          "Inheritance": "AR"
        },
        {
          "Gene": "UQCC3",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 9 [MIM: 616111]",
          "OMIM Entry": "616097",
          "Inheritance": "AR"
        },
        {
          "Gene": "UQCRB",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 3 [MIM: 615158]",
          "OMIM Entry": "191330",
          "Inheritance": "AR"
        },
        {
          "Gene": "UQCRC2",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 5 [MIM: 615160]",
          "OMIM Entry": "191329",
          "Inheritance": "AR"
        },
        {
          "Gene": "UQCRFS1",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 10 [MIM: 618775]",
          "OMIM Entry": "191327",
          "Inheritance": "AR"
        },
        {
          "Gene": "UQCRQ",
          "Phenotype MIM Number": "Mitochondrial complex III deficiency, nuclear type 4 [MIM: 615159]",
          "OMIM Entry": "612080",
          "Inheritance": "AR"
        },
        {
          "Gene": "UROC1",
          "Phenotype MIM Number": "Urocanase deficiency [MIM: 276880]",
          "OMIM Entry": "613012",
          "Inheritance": "AR"
        },
        {
          "Gene": "USP18",
          "Phenotype MIM Number": "Pseudo-TORCH syndrome 2 [MIM: 617397]",
          "OMIM Entry": "607057",
          "Inheritance": "AR"
        },
        {
          "Gene": "VAC14",
          "Phenotype MIM Number": "Striatonigral degeneration, childhood-onset [MIM: 617054]",
          "OMIM Entry": "604632",
          "Inheritance": "AR"
        },
        {
          "Gene": "VAMP1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 25 [MIM: 618323]; Spastic ataxia 1, autosomal dominant [MIM: 108600]",
          "OMIM Entry": "185880",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "VAPB",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 8 [MIM: 608627]; Spinal muscular atrophy, late-onset, Finkel type [MIM: 182980]",
          "OMIM Entry": "605704",
          "Inheritance": "AD"
        },
        {
          "Gene": "VARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 20 [MIM: 615917]",
          "OMIM Entry": "612802",
          "Inheritance": "AR"
        },
        {
          "Gene": "VCP",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 2Y [MIM: 616687]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 6 [MIM: 613954]; Inclusion body myopathy with early-onset Paget disease and frontotemporal dementia 1 [MIM: 167320]",
          "OMIM Entry": "601023",
          "Inheritance": "AD"
        },
        {
          "Gene": "VLDLR",
          "Phenotype MIM Number": "Cerebellar hypoplasia, impaired intellectual development, and dysequilibrium syndrome 1 [MIM: 224050]",
          "OMIM Entry": "192977",
          "Inheritance": "AR"
        },
        {
          "Gene": "VMA21",
          "Phenotype MIM Number": "Myopathy, X-linked, with excessive autophagy [MIM: 310440]",
          "OMIM Entry": "300913",
          "Inheritance": "XLR"
        },
        {
          "Gene": "VPS11",
          "Phenotype MIM Number": "Dystonia 32 [MIM: 619637]; Leukodystrophy, hypomyelinating, 12 [MIM: 616683]",
          "OMIM Entry": "608549",
          "Inheritance": "AR"
        },
        {
          "Gene": "VPS13A",
          "Phenotype MIM Number": "Choreoacanthocytosis [MIM: 200150]",
          "OMIM Entry": "605978",
          "Inheritance": "AR"
        },
        {
          "Gene": "VPS13C",
          "Phenotype MIM Number": "Parkinson disease 23, autosomal recessive, early onset [MIM: 616840]",
          "OMIM Entry": "608879",
          "Inheritance": "AR"
        },
        {
          "Gene": "VPS13D",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 4 [MIM: 607317]",
          "OMIM Entry": "608877",
          "Inheritance": "AR"
        },
        {
          "Gene": "VPS16",
          "Phenotype MIM Number": "Dystonia 30 [MIM: 619291]",
          "OMIM Entry": "608550",
          "Inheritance": "AD"
        },
        {
          "Gene": "VPS35",
          "Phenotype MIM Number": "{Parkinson disease 17} [MIM: 614203]",
          "OMIM Entry": "601501",
          "Inheritance": "AD"
        },
        {
          "Gene": "VPS37A",
          "Phenotype MIM Number": "Spastic paraplegia 53, autosomal recessive [MIM: 614898]",
          "OMIM Entry": "609927",
          "Inheritance": "AR"
        },
        {
          "Gene": "VPS51",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 13 [MIM: 618606]",
          "OMIM Entry": "615738",
          "Inheritance": "AR"
        },
        {
          "Gene": "VPS53",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 2E [MIM: 615851]",
          "OMIM Entry": "615850",
          "Inheritance": "AR"
        },
        {
          "Gene": "VRK1",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal recessive 10 [MIM: 620542]; Pontocerebellar hypoplasia type 1A [MIM: 607596]",
          "OMIM Entry": "602168",
          "Inheritance": "AR"
        },
        {
          "Gene": "VWA1",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal recessive 7 [MIM: 619216]",
          "OMIM Entry": "611901",
          "Inheritance": "AR"
        },
        {
          "Gene": "VWA3B",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 22 [MIM: 616948]",
          "OMIM Entry": "614884",
          "Inheritance": "AR"
        },
        {
          "Gene": "WARS2",
          "Phenotype MIM Number": "Neurodevelopmental disorder, miochondrial, with abnormal movements and lactic acidosis, with or without seizures [MIM: 617710]; Parkinsonism-dystonia 3, childhood-onset [MIM: 619738]",
          "OMIM Entry": "604733",
          "Inheritance": "AR"
        },
        {
          "Gene": "WASHC5",
          "Phenotype MIM Number": "Ritscher-Schinzel syndrome 1 [MIM: 220210]; Spastic paraplegia 8, autosomal dominant [MIM: 603563]",
          "OMIM Entry": "610657",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "WDR26",
          "Phenotype MIM Number": "Skraban-Deardorff syndrome [MIM: 617616]",
          "OMIM Entry": "617424",
          "Inheritance": "AD"
        },
        {
          "Gene": "WDR45",
          "Phenotype MIM Number": "Neurodegeneration with brain iron accumulation 5 [MIM: 300894]",
          "OMIM Entry": "300526",
          "Inheritance": "XLD"
        },
        {
          "Gene": "WDR62",
          "Phenotype MIM Number": "Microcephaly 2, primary, autosomal recessive, with or without cortical malformations [MIM: 604317]",
          "OMIM Entry": "613583",
          "Inheritance": "AR"
        },
        {
          "Gene": "WDR73",
          "Phenotype MIM Number": "Galloway-Mowat syndrome 1 [MIM: 251300]",
          "OMIM Entry": "616144",
          "Inheritance": "AR"
        },
        {
          "Gene": "WDR81",
          "Phenotype MIM Number": "Cerebellar ataxia, impaired intellectual development, and dysquilibrium syndrome 2 [MIM: 610185]; Hydrocephalus, congenital, 3, with brain anomalies [MIM: 617967]",
          "OMIM Entry": "614218",
          "Inheritance": "AR"
        },
        {
          "Gene": "WFS1",
          "Phenotype MIM Number": "Cataract 41 [MIM: 116400]; {Diabetes mellitus, noninsulin-dependent, association with} [MIM: 125853]; Deafness, autosomal dominant 6/14/38 [MIM: 600965]; Wolfram syndrome 1 [MIM: 222300]; Wolfram-like syndrome, autosomal dominant [MIM: 614296]",
          "OMIM Entry": "606201",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "WNK1",
          "Phenotype MIM Number": "Neuropathy, hereditary sensory and autonomic, type II [MIM: 201300]; Pseudohypoaldosteronism, type IIC [MIM: 614492]",
          "OMIM Entry": "605232",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "WWOX",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 28 [MIM: 616211]; Esophageal squamous cell carcinoma, somatic [MIM: 133233]; Spinocerebellar ataxia, autosomal recessive 12 [MIM: 614322]",
          "OMIM Entry": "605131",
          "Inheritance": "AR"
        },
        {
          "Gene": "XK",
          "Phenotype MIM Number": "McLeod syndrome [MIM: 300842]",
          "OMIM Entry": "314850",
          "Inheritance": "XL"
        },
        {
          "Gene": "XPA",
          "Phenotype MIM Number": "Xeroderma pigmentosum, group A [MIM: 278700]",
          "OMIM Entry": "611153",
          "Inheritance": "AR"
        },
        {
          "Gene": "XPNPEP3",
          "Phenotype MIM Number": "Nephronophthisis-like nephropathy 1 [MIM: 613159]",
          "OMIM Entry": "613553",
          "Inheritance": "AR"
        },
        {
          "Gene": "XPR1",
          "Phenotype MIM Number": "Basal ganglia calcification, idiopathic, 6 [MIM: 616413]",
          "OMIM Entry": "605237",
          "Inheritance": "AD"
        },
        {
          "Gene": "XRCC1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 26 [MIM: 617633]",
          "OMIM Entry": "194360",
          "Inheritance": "AR"
        },
        {
          "Gene": "XRCC4",
          "Phenotype MIM Number": "Short stature, microcephaly, and endocrine dysfunction [MIM: 616541]",
          "OMIM Entry": "194363",
          "Inheritance": "AR"
        },
        {
          "Gene": "YARS2",
          "Phenotype MIM Number": "Myopathy, lactic acidosis, and sideroblastic anemia 2 [MIM: 613561]",
          "OMIM Entry": "610957",
          "Inheritance": "AR"
        },
        {
          "Gene": "YME1L1",
          "Phenotype MIM Number": "Optic atrophy 11 [MIM: 617302]",
          "OMIM Entry": "607472",
          "Inheritance": "AR"
        },
        {
          "Gene": "ZC4H2",
          "Phenotype MIM Number": "Wieacker-Wolff syndrome [MIM: 314580]; Wieacker-Wolff syndrome, female-restricted [MIM: 301041]",
          "OMIM Entry": "300897",
          "Inheritance": "XLR, XLD"
        },
        {
          "Gene": "ZFHX3 ",
          "Phenotype MIM Number": "Spinocerebellar ataxia 4 [MIM: 600223]",
          "OMIM Entry": "104155",
          "Inheritance": "AD"
        },
        {
          "Gene": "ZFYVE26",
          "Phenotype MIM Number": "Spastic paraplegia 15, autosomal recessive [MIM: 270700]",
          "OMIM Entry": "612012",
          "Inheritance": "AR"
        },
        {
          "Gene": "ZNF142",
          "Phenotype MIM Number": "Neurodevelopmental disorder with impaired speech and hyperkinetic movements [MIM: 618425]",
          "OMIM Entry": "604083",
          "Inheritance": "AR"
        },
        {
          "Gene": "ZNF335",
          "Phenotype MIM Number": "Microcephaly 10, primary, autosomal recessive [MIM: 615095]",
          "OMIM Entry": "610827",
          "Inheritance": "AR"
        },
        {
          "Gene": "ZNF423",
          "Phenotype MIM Number": "Joubert syndrome 19 [MIM: 614844]; Nephronophthisis 14 [MIM: 614844]",
          "OMIM Entry": "604557",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ZNHIT3",
          "Phenotype MIM Number": "PEHO syndrome [MIM: 260565]",
          "OMIM Entry": "604500",
          "Inheritance": "AR"
        }
      ],
      Table3: [
        {
          "Gene": "AARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 8 [MIM: 614096]; Leukoencephalopathy, progressive, with ovarian failure [MIM: 615889]",
          "OMIM Entry": "612035",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABCD1",
          "Phenotype MIM Number": "Adrenoleukodystrophy [MIM: 300100]; Adrenomyeloneuropathy, adult [MIM: 300100]",
          "OMIM Entry": "300371",
          "Inheritance": "XLR"
        },
        {
          "Gene": "AFG3L2",
          "Phenotype MIM Number": "Optic atrophy 12 [MIM: 618977]; Spastic ataxia 5, autosomal recessive [MIM: 614487]; Spinocerebellar ataxia 28 [MIM: 610246]",
          "OMIM Entry": "604581",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ANO10",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 10 [MIM: 613728]",
          "OMIM Entry": "613726",
          "Inheritance": "AR"
        },
        {
          "Gene": "APTX",
          "Phenotype MIM Number": "Ataxia, early-onset, with oculomotor apraxia and hypoalbuminemia [MIM: 208920]",
          "OMIM Entry": "606350",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATCAY",
          "Phenotype MIM Number": "Ataxia, cerebellar, Cayman type [MIM: 601238]",
          "OMIM Entry": "608179",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATG5",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 25 [MIM: 617584]",
          "OMIM Entry": "604261",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATM",
          "Phenotype MIM Number": "{Breast cancer, susceptibility to} [MIM: 114480]; Ataxia-telangiectasia [MIM: 208900]; Lymphoma, B-cell non-Hodgkin, somatic; Lymphoma, mantle cell, somatic; T-cell prolymphocytic leukemia, somatic",
          "OMIM Entry": "607585",
          "Inheritance": "AD, AR, SMu"
        },
        {
          "Gene": "ATP2B3",
          "Phenotype MIM Number": "Spinocerebellar ataxia, X-linked 1 [MIM: 302500]",
          "OMIM Entry": "300014",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ATP8A2",
          "Phenotype MIM Number": "Cerebellar ataxia, impaired intellectual development, and dysequilibrium syndrome 4 [MIM: 615268]",
          "OMIM Entry": "605870",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATXN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 1 [MIM: 164400]",
          "OMIM Entry": "601556",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN10",
          "Phenotype MIM Number": "Spinocerebellar ataxia 10 [MIM: 603516]",
          "OMIM Entry": "611150",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 2 [MIM: 183090]; {Amyotrophic lateral sclerosis susceptibility to 13} [MIM: 183090]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "601517",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN3",
          "Phenotype MIM Number": "Machado-Joseph disease [MIM: 109150]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "607047",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN7",
          "Phenotype MIM Number": "Spinocerebellar ataxia 7 [MIM: 164500]",
          "OMIM Entry": "607640",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN8/ATXN8OS",
          "Phenotype MIM Number": "Spinocerebellar ataxia 8 [MIM: 608768]; {Parkinson disease susceptibility to} [MIM: 168600]",
          "OMIM Entry": "613289; 603680",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "BEAN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 31 [MIM: 117210]",
          "OMIM Entry": "612051",
          "Inheritance": "AD"
        },
        {
          "Gene": "CA8",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 34 [MIM: 613227]",
          "OMIM Entry": "114815",
          "Inheritance": "AR"
        },
        {
          "Gene": "CACNA1A",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 42 [MIM: 617106]; Episodic ataxia, type 2 [MIM: 108500]; Migraine, familial hemiplegic, 1 [MIM: 141500]; Migraine, familial hemiplegic, 1, with progressive cerebellar ataxia [MIM: 141500]; Spinocerebellar ataxia 6 [MIM: 183086]",
          "OMIM Entry": "601011",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNA1G",
          "Phenotype MIM Number": "Spinocerebellar ataxia 42 [MIM: 616795]; Spinocerebellar ataxia 42, early-onset, severe, with neurodevelopmental deficits [MIM: 618087]",
          "OMIM Entry": "604065",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNB4",
          "Phenotype MIM Number": "Episodic ataxia, type 5 [MIM: 613855]; {Epilepsy, idiopathic generalized, susceptibility to, 9}  [MIM: 607682]; {Epilepsy, juvenile myoclonic, susceptibility to, 6} [MIM: 607682]",
          "OMIM Entry": "601949",
          "Inheritance": "AD"
        },
        {
          "Gene": "CCDC88C",
          "Phenotype MIM Number": "Spinocerebellar ataxia 40 [MIM: 616053]; Hydrocephalus, congenital, 1 [MIM: 236600]",
          "OMIM Entry": "611204",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHP1",
          "Phenotype MIM Number": "Spastic ataxia 9, autosomal recessive [MIM: 618438]",
          "OMIM Entry": "606988",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLN5",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 5 [MIM: 256731]",
          "OMIM Entry": "608102",
          "Inheritance": "AR"
        },
        {
          "Gene": "COA7",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 3 [MIM: 618387]",
          "OMIM Entry": "615623",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ4",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 7 [MIM: 616276]; Spastic ataxia 10, autosomal recessive [MIM: 620666]",
          "OMIM Entry": "612898",
          "Inheritance": "AR"
        },
        {
          "Gene": "CTBP1",
          "Phenotype MIM Number": "Hypotonia, ataxia, developmental delay, and tooth enamel defect syndrome [MIM: 617915]",
          "OMIM Entry": "602618",
          "Inheritance": "AD"
        },
        {
          "Gene": "CWF19L1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 17 [MIM: 616127]",
          "OMIM Entry": "616120",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYP27A1",
          "Phenotype MIM Number": "Cerebrotendinous xanthomatosis [MIM: 213700]",
          "OMIM Entry": "606530",
          "Inheritance": "AR"
        },
        {
          "Gene": "CYP7B1",
          "Phenotype MIM Number": "ile acid synthesis defect, congenital, 3 [MIM: 613812]; Spastic paraplegia 5A, autosomal recessive [MIM: 270800]",
          "OMIM Entry": "603711",
          "Inheritance": "AR"
        },
        {
          "Gene": "DAB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 37 [MIM: 615945]",
          "OMIM Entry": "603448",
          "Inheritance": "AD"
        },
        {
          "Gene": "DNAJC3",
          "Phenotype MIM Number": "Ataxia, combined cerebellar and peripheral, with hearing loss and diabetes mellitus [MIM: 616192]",
          "OMIM Entry": "601184",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNMT1",
          "Phenotype MIM Number": "Cerebellar ataxia, deafness, and narcolepsy, autosomal dominant [MIM: 604121]; Neuropathy, hereditary sensory, type IE [MIM: 614116]",
          "OMIM Entry": "126375",
          "Inheritance": "AD"
        },
        {
          "Gene": "EBF3",
          "Phenotype MIM Number": "Hypotonia, ataxia, and delayed development syndrome [MIM: 617330]",
          "OMIM Entry": "607407",
          "Inheritance": "AD"
        },
        {
          "Gene": "EEF2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 26 [MIM: 609306]",
          "OMIM Entry": "130610",
          "Inheritance": "AD"
        },
        {
          "Gene": "ELOVL4",
          "Phenotype MIM Number": "Ichthyosis, spastic quadriplegia, and impaired intellectual development [MIM: 614457]; Spinocerebellar ataxia 34 [MIM: 133190]; Stargardt disease 3 [MIM: 600110]",
          "OMIM Entry": "605512",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ELOVL5",
          "Phenotype MIM Number": "Spinocerebellar ataxia 38 [MIM: 615957]",
          "OMIM Entry": "611805",
          "Inheritance": "AD"
        },
        {
          "Gene": "FAT2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 45 [MIM: 617769]",
          "OMIM Entry": "604269",
          "Inheritance": "AD"
        },
        {
          "Gene": "FGF14",
          "Phenotype MIM Number": "Spinocerebellar ataxia 27A [MIM: 193003]; Spinocerebellar ataxia 27B, late-onset [MIM: 620174]",
          "OMIM Entry": "601515",
          "Inheritance": "AD"
        },

        {
          "Gene": "FMR1",
          "Phenotype MIM Number": "Fragile X syndrome [MIM: 300624]; Fragile X tremor/ataxia syndrome [MIM 300623]; Premature ovarian failure 1 [MIM: 311360]",
          "OMIM Entry": "309550",
          "Inheritance": "XLD, XL"
        },
        {
          "Gene": "FXN",
          "Phenotype MIM Number": "Friedreich ataxia [MIM: 229300]; Friedreich ataxia with retained reflexes [MIM: 229300]",
          "OMIM Entry": "606829",
          "Inheritance": "AR"
        },
        {
          "Gene": "GDAP2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 27 [MIM: 618369]",
          "OMIM Entry": "618128",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLS",
          "Phenotype MIM Number": "Global developmental delay progressive ataxia and elevated glutamine [MIM: 618412]",
          "OMIM Entry": "138280",
          "Inheritance": "AR"
        },
        {
          "Gene": "GNB4",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, dominant intermediate F [MIM: 615185]",
          "OMIM Entry": "610863",
          "Inheritance": "AD"
        },
        {
          "Gene": "GRID2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 18 [MIM: 616204]",
          "OMIM Entry": "602368",
          "Inheritance": "AR"
        },
        {
          "Gene": "GRM1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 44 [MIM: 617691]; Spinocerebellar ataxia, autosomal recessive 13 [MIM: 614831]",
          "OMIM Entry": "604473",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "HEXA",
          "Phenotype MIM Number": "[Hex A pseudodeficiency] [MIM: 272800]; GM2-gangliosidosis, several forms [MIM: 272800]; Tay-Sachs disease [MIM: 272800]",
          "OMIM Entry": "606869",
          "Inheritance": "AR"
        },
        {
          "Gene": "HEXB",
          "Phenotype MIM Number": "Sandhoff disease, infantile, juvenile, and adult forms [MIM: 268800]",
          "OMIM Entry": "606873",
          "Inheritance": "AR"
        },
        {
          "Gene": "ITPR1",
          "Phenotype MIM Number": "Gillespie syndrome [MIM: 206700]; Spinocerebellar ataxia 15 [MIM: 606658]; Spinocerebellar ataxia 29, congenital nonprogressive [MIM: 117360] ",
          "OMIM Entry": "147265",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "KCNA1",
          "Phenotype MIM Number": "Episodic ataxia/myokymia syndrome [MIM: 160120]",
          "OMIM Entry": "176260",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNC3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 13 [MIM: 605259]",
          "OMIM Entry": "176264",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCND3",
          "Phenotype MIM Number": "Brugada syndrome 9 [MIM: 616399]; Spinocerebellar ataxia 19 [MIM: 607346]",
          "OMIM Entry": "605411",
          "Inheritance": "AD"
        },
        {
          "Gene": "KIF1C",
          "Phenotype MIM Number": "Spastic ataxia 2, autosomal recessive [MIM: 611302]",
          "OMIM Entry": "603060",
          "Inheritance": "AR"
        },
        {
          "Gene": "KIF5A",
          "Phenotype MIM Number": "{Amyotrophic lateral sclerosis, susceptibility to, 25} [617921]; Myoclonus, intractable, neonatal [617235]; Spastic paraplegia 10, autosomal dominant [MIM: 604187] ",
          "OMIM Entry": "602821",
          "Inheritance": "AD"
        },
        {
          "Gene": "MARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 25 [MIM: 616430]; Spastic ataxia 3, autosomal recessive [MIM: 611390]",
          "OMIM Entry": "609728",
          "Inheritance": "AR"
        },
        {
          "Gene": "MME",
          "Phenotype MIM Number": "Spinocerebellar ataxia 43 [MIM: 617018]; Charcot-Marie-Tooth disease, axonal, type 2T [MIM: 617017]",
          "OMIM Entry": "120520",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MRE11",
          "Phenotype MIM Number": "Ataxia-telangiectasia-like disorder 1 [MIM: 604391]",
          "OMIM Entry": "600814",
          "Inheritance": "AR"
        },
        {
          "Gene": "MTPAP",
          "Phenotype MIM Number": "Spastic ataxia 4, autosomal recessive [MIM: 613672]",
          "OMIM Entry": "613669",
          "Inheritance": "AR"
        },
        {
          "Gene": "NKX6-2",
          "Phenotype MIM Number": "Spastic ataxia 8, autosomal recessive, with hypomyelinating leukodystrophy [MIM: 617560]",
          "OMIM Entry": "605955",
          "Inheritance": "AR"
        },
        {
          "Gene": "NOP56",
          "Phenotype MIM Number": "Spinocerebellar ataxia 36 [MIM: 614153]",
          "OMIM Entry": "614154",
          "Inheritance": "AD"
        },
        {
          "Gene": "NOTCH3",
          "Phenotype MIM Number": "Myofibromatosis, infantile 2 [MIM: 615293]; Cerebral arteriopathy, autosomal dominant, with subcortical infarcts and leukoencephalopathy 1 [MIM: 125310]; Cerebral arteriopathy, autosomal recessive, with subcortical infarcts and leukoencephalopathy 1 [MIM: 621295]; Lateral meningocele syndrome [MIM: 130720]; Lipodystrophy, familial partial, type 1 [MIM: 608600]",
          "OMIM Entry": "600276",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PCNA",
          "Phenotype MIM Number": "Ataxia-telangiectasia-like disorder 2 [MIM: 615919]",
          "OMIM Entry": "176740",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDYN",
          "Phenotype MIM Number": "Spinocerebellar ataxia 23 [MIM: 610245]",
          "OMIM Entry": "131340",
          "Inheritance": "AD"
        },
        {
          "Gene": "PEX7",
          "Phenotype MIM Number": "Peroxisome biogenesis disorder 9B [614879]; Rhizomelic chondrodysplasia punctata, type 1 [MIM: 215100]",
          "OMIM Entry": "601757",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIK3R5",
          "Phenotype MIM Number": "Ataxia-oculomotor apraxia 3 [MIM: 615217]",
          "OMIM Entry": "611317",
          "Inheritance": "AR"
        },
        {
          "Gene": "PITRM1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 30 [MIM: 619405]",
          "OMIM Entry": "618211",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLD3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 46 [MIM: 617770]",
          "OMIM Entry": "615698",
          "Inheritance": "AD"
        },
        {
          "Gene": "PMM2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ia [MIM: 212065]",
          "OMIM Entry": "601785",
          "Inheritance": "AR"
        },
        {
          "Gene": "PMPCA",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 2 [MIM: 213200]",
          "OMIM Entry": "613036",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNKP",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 2B2 [MIM: 605589]; Ataxia-oculomotor apraxia 4 [MIM: 616267]; Microcephaly, seizures, and developmental delay [MIM: 613402]",
          "OMIM Entry": "605610",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPLA6",
          "Phenotype MIM Number": "Laurence-Moon syndrome [MIM: 245800]; Boucher-Neuhauser syndrome [MIM: 215470]; Oliver-McFarlane syndrome [MIM: 275400]; Spastic paraplegia 39, autosomal recessive [MIM: 612020]",
          "OMIM Entry": "603197",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPT1",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 13 [MIM: 614932]; Deafness, autosomal recessive 70, with or without adult-onset neurodegeneration [MIM: 614934]; Spinocerebellar ataxia 25 [MIM: 608703]",
          "OMIM Entry": "610316",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLG",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 4A (Alpers type) [MIM: 203700]; Mitochondrial DNA depletion syndrome 4B (MNGIE type) [MIM: 613662]; Mitochondrial recessive ataxia syndrome (includes SANDO and SCAE) [MIM: 607459]; Progressive external ophthalmoplegia, autosomal dominant 1 [MIM: 157640]; Progressive external ophthalmoplegia, autosomal recessive 1 [MIM: 258450]",
          "OMIM Entry": "174763",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLR3A",
          "Phenotype MIM Number": "Leukodystrophy, hypomyelinating, 7, with or without oligodontia and/or hypogonadotropic hypogonadism [MIM: 607694]; Wiedemann-Rautenstrauch syndrome [MIM: 264090]",
          "OMIM Entry": "614258",
          "Inheritance": "AR"
        },
        {
          "Gene": "PPP2R2B",
          "Phenotype MIM Number": "Spinocerebellar ataxia 12 [MIM: 604326]",
          "OMIM Entry": "604325",
          "Inheritance": "AD"
        },
        {
          "Gene": "PRKCG",
          "Phenotype MIM Number": "Spinocerebellar ataxia 14 [MIM: 605361]",
          "OMIM Entry": "176980",
          "Inheritance": "AD"
        },
        {
          "Gene": "RFC1",
          "Phenotype MIM Number": "Cerebellar ataxia neuropathy and vestibular areflexia syndrome [MIM: 614575]",
          "OMIM Entry": "102579",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNF170",
          "Phenotype MIM Number": "Ataxia, sensory, 1, autosomal dominant [MIM: 608984]; Spastic paraplegia 85, autosomal recessive [MIM: 619686]",
          "OMIM Entry": "614649",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RNF216",
          "Phenotype MIM Number": "Cerebellar ataxia and hypogonadotropic hypogonadism [MIM: 212840]",
          "OMIM Entry": "609948",
          "Inheritance": "AR"
        },
        {
          "Gene": "RRM2B",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 8A (encephalomyopathic type with renal tubulopathy) [MIM: 612075]; Mitochondrial DNA depletion syndrome 8B (MNGIE type) [MIM: 612075]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 5 [MIM: 613077]; Rod-cone dystrophy, sensorineural deafness, and Fanconi-type renal dysfunction [MIM; 268315]",
          "OMIM Entry": "604712",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RUBCN",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 15 [MIM: 615705]",
          "OMIM Entry": "613516",
          "Inheritance": "AR"
        },
        {
          "Gene": "SACS",
          "Phenotype MIM Number": "Spastic ataxia, Charlevoix-Saguenay type {MIM: 270550]",
          "OMIM Entry": "604490",
          "Inheritance": "AR"
        },
        {
          "Gene": "SAMD9L",
          "Phenotype MIM Number": "Spinocerebellar ataxia 49 [MIM: 619806]; Ataxia-pancytopenia syndrome [MIM: 159550]; Monosomy 7 myelodysplasia and leukemia syndrome 1 [MIM: 252270]",
          "OMIM Entry": "611170",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCN2A",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 11 [MIM: 613721]; Episodic ataxia, type 9 [MIM: 618924]; Seizures, benign familial infantile, 3 [MIM: 607745]",
          "OMIM Entry": "182390",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCYL1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 21 [MIM: 616719]",
          "OMIM Entry": "607982",
          "Inheritance": "AR"
        },
        {
          "Gene": "SETX",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 4, juvenile {MIM: 602433]; Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 2 [MIM: 606002]",
          "OMIM Entry": "608465",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC1A3",
          "Phenotype MIM Number": "Episodic ataxia, type 6 [MIM: 612656]",
          "OMIM Entry": "600111",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC20A2",
          "Phenotype MIM Number": "Basal ganglia calcification, idiopathic, 1 {MIM: 213600]",
          "OMIM Entry": "158378",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC44A1",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with ataxia, tremor, optic atrophy, and cognitive decline [MIM: 618868]",
          "OMIM Entry": "606105",
          "Inheritance": "AR"
        },
        {
          "Gene": "SNX14",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 20 [MIM: 616354]",
          "OMIM Entry": "616105",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPG11",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 5, juvenile [MIM: 602099]; Charcot-Marie-Tooth disease, axonal, type 2X [MIM: 616668]; Spastic paraplegia 11, autosomal recessive {MIM: 604360]",
          "OMIM Entry": "610844",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPG7",
          "Phenotype MIM Number": "Spastic paraplegia 7, autosomal recessive [MIM: 607259]",
          "OMIM Entry": "602783",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPTBN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 5 [MIM: 600224]; Spinocerebellar ataxia, autosomal recessive 14 {MIM: 615386]",
          "OMIM Entry": "604985",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SQSTM1",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 3 [MIM: 616437]; Myopathy, distal, with rimmed vacuoles [MIM: 617158]; Neurodegeneration with ataxia, dystonia, and gaze palsy, childhood-onset [MIM: 617145]; Paget disease of bone 3 [MIM: 167250]",
          "OMIM Entry": "601530",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "STUB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 48 [MIM: 618093]; Spinocerebellar ataxia, autosomal recessive 16 [MIM: 615768]",
          "OMIM Entry": "607207",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SVBP",
          "Phenotype MIM Number": "Neurodevelopmental disorder with ataxia, hypotonia, and microcephaly [MIM: 618569]",
          "OMIM Entry": "617853",
          "Inheritance": "AR"
        },
        {
          "Gene": "SYNE1",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 3, myogenic type [MIM: 618484]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 612998]; Spinocerebellar ataxia, autosomal recessive 8 [MIM: 610743]",
          "OMIM Entry": "608441",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SYT14",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 11 [MIM: 614229]",
          "OMIM Entry": "610949",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBP",
          "Phenotype MIM Number": "{Parkinson disease susceptibility to} [MIM: 168600]; Spinocerebellar ataxia 17 [MIM: 607136]",
          "OMIM Entry": "600075",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "TDP1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 1 [MIM: 607250]",
          "OMIM Entry": "607198",
          "Inheritance": "AR"
        },
        {
          "Gene": "TDP2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 23 [MIM: 616949]",
          "OMIM Entry": "605764",
          "Inheritance": "AR"
        },
        {
          "Gene": "TGM6",
          "Phenotype MIM Number": "Spinocerebellar ataxia 35 [MIM: 613908]",
          "OMIM Entry": "613900",
          "Inheritance": "AR"
        },
        {
          "Gene": "THAP11",
          "Phenotype MIM Number": "Spinocerebellar Ataxia 51 [MIM: 620947]",
          "OMIM Entry": "609119",
          "Inheritance": "AD"
        },
        {
          "Gene": "THG1L",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 28 [MIM: 618800]",
          "OMIM Entry": "618802",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM240",
          "Phenotype MIM Number": "Spinocerebellar ataxia 21 [MIM: 607454]",
          "OMIM Entry": "616101",
          "Inheritance": "AD"
        },
        {
          "Gene": "TPP1",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 2 [MIM: 204500]; Spinocerebellar ataxia, autosomal recessive 7 [MIM: 609270]",
          "OMIM Entry": "607998",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRPC3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 41  [MIM: 616410]",
          "OMIM Entry": "602345",
          "Inheritance": "AD"
        },
        {
          "Gene": "TTBK2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 11 [MIM: 604432]",
          "OMIM Entry": "611695",
          "Inheritance": "AD"
        },
        {
          "Gene": "TTPA",
          "Phenotype MIM Number": "Ataxia with isolated vitamin E deficiency [MIM: 277460]",
          "OMIM Entry": "600415",
          "Inheritance": "AR"
        },
        {
          "Gene": "TUBA4A",
          "Phenotype MIM Number": "Congenital myopathy 26 [MIM: 621225]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 9 [MIM: 616208]; Oocyte/zygote/embryo maturation arrest 23 [MIM: 621231]; Spastic ataxia 11, autosomal dominant [MIM: 621226]",
          "OMIM Entry": "191110",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TWNK",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 7 (hepatocerebral type) [MIM: 271245]; Perrault syndrome 5 [MIM: 616138]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 3 [MIM: 609286]",
          "OMIM Entry": "606075",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "UBA5",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 24[ MIM: 617133]; Developmental and epileptic encephalopathy 44 [MIM: 617132]",
          "OMIM Entry": "610552",
          "Inheritance": "AR"
        },
        {
          "Gene": "VAMP1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 25 [MIM: 618323]; Spastic ataxia 1, autosomal dominant [MIM: 108600]",
          "OMIM Entry": "185880",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "VPS13D",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 4 [MIM: 607317]",
          "OMIM Entry": "608877",
          "Inheritance": "AR"
        },
        {
          "Gene": "VWA3B",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 22 [MIM: 616948]",
          "OMIM Entry": "614884",
          "Inheritance": "AR"
        },
        {
          "Gene": "WASHC5",
          "Phenotype MIM Number": "Ritscher-Schinzel syndrome 1 [MIM: 220210]; Spastic paraplegia 8, autosomal dominant [MIM: 603563]",
          "OMIM Entry": "610657",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "WDR81",
          "Phenotype MIM Number": "Cerebellar ataxia, impaired intellectual development, and dysquilibrium syndrome 2 [MIM: 610185]; Hydrocephalus, congenital, 3, with brain anomalies [MIM: 617967]",
          "OMIM Entry": "614218",
          "Inheritance": "AR"
        },
        {
          "Gene": "WWOX",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 28 [MIM: 616211]; Esophageal squamous cell carcinoma, somatic [MIM: 133233]; Spinocerebellar ataxia, autosomal recessive 12 [MIM: 614322]",
          "OMIM Entry": "605131",
          "Inheritance": "AR"
        },
        {
          "Gene": "XRCC1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 26 [MIM: 617633]",
          "OMIM Entry": "194360",
          "Inheritance": "AR"
        },
        {
          "Gene": "ZFHX3 ",
          "Phenotype MIM Number": "Spinocerebellar ataxia 4 [MIM: 600223]",
          "OMIM Entry": "104155",
          "Inheritance": "AD"
        },
        {
          "Gene": "ZFYVE26",
          "Phenotype MIM Number": "Spastic paraplegia 15, autosomal recessive (MIM: 270700]",
          "OMIM Entry": "612012",
          "Inheritance": "AR"
        }
      ],
      Table4: [
        {
          "Gene": "ABCD3",
          "Phenotype MIM Number": "Bile acid synthesis defect, congenital, 5 [MIM: 616278]",
          "OMIM Entry": "170995",
          "Inheritance": "AR"
        },
        {
          "Gene": "ABHD5",
          "Phenotype MIM Number": "Chanarin-Dorfman syndrome [MIM: 275630]",
          "OMIM Entry": "604780",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACAD9",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 20 [MIM: 61126]",
          "OMIM Entry": "611103",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACADM",
          "Phenotype MIM Number": "Acyl-CoA dehydrogenase, medium chain, deficiency of [MIM: 201450]",
          "OMIM Entry": "607008",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACADS",
          "Phenotype MIM Number": "Acyl-CoA dehydrogenase, short-chain, deficiency of [MIM: 201470]",
          "OMIM Entry": "606885",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACADVL",
          "Phenotype MIM Number": "VLCAD deficiency [MIM: 201475]",
          "OMIM Entry": "609575",
          "Inheritance": "AR"
        },
        {
          "Gene": "ACTA1",
          "Phenotype MIM Number": "Myopathy, scapulohumeroperoneal [MIM: 616582]; Congenital myopathy 2A, typical, autosomal dominant [MIM: 161800]; Congenital myopathy 2B, severe infantile, autosomal recessive [MIM: 620265]; Congenital myopathy 2C, severe infantile, autosomal dominant [MIM: 620278]",
          "OMIM Entry": "102610",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ACTN2",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1AA, with or without LVNC [MIM: 612158]; Cardiomyopathy, hypertrophic, 23, with or without LVNC [MIM: 612158]; Congenital myopathy 8 [MIM: 618654]; Myopathy, distal, 6, adult onset [MIM: 618655]",
          "OMIM Entry": "102573",
          "Inheritance": "AD "
        },
        {
          "Gene": "ADSS1",
          "Phenotype MIM Number": "Myopathy, distal, 5 [MIM: 617030]",
          "OMIM Entry": "612498",
          "Inheritance": "AR"
        },
        {
          "Gene": "AFG3L2",
          "Phenotype MIM Number": "Optic atrophy 12 [MIM: 618977]; Spastic ataxia 5, autosomal recessive [MIM: 614487]; Spinocerebellar ataxia 28 [MIM: 610246]",
          "OMIM Entry": "604581",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "AGK",
          "Phenotype MIM Number": "Cataract 38, autosomal recessive [MIM: 614691]; Sengers syndrome [MIM: 212350]",
          "OMIM Entry": "610345",
          "Inheritance": "AR"
        },
        {
          "Gene": "AGL",
          "Phenotype MIM Number": "Glycogen storage disease IIIa [MIM: 232400]; Glycogen storage disease IIIb [MIM: 232400]",
          "OMIM Entry": "610860",
          "Inheritance": "AR"
        },
        {
          "Gene": "AGRN",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 8, with pre- and postsynaptic defects [MIM: 615120]",
          "OMIM Entry": "103320",
          "Inheritance": "AR"
        },
        {
          "Gene": "AHCY",
          "Phenotype MIM Number": "Hypermethioninemia with deficiency of S-adenosylhomocysteine hydrolase [MIM: 613752]",
          "OMIM Entry": "180960",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALG14",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 15, without tubular aggregates [MIM: 616227]; Intellectual developmental disorder with epilepsy, behavioral abnormalities, and coarse facies [MIM: 619031]; Myopathy, epilepsy, and progressive cerebral atrophy [MIM: 619036] ",
          "OMIM Entry": "612866",
          "Inheritance": "AR"
        },
        {
          "Gene": "ALG2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ii [MIM: 607906]; Myasthenic syndrome, congenital, 14, with tubular aggregates [MIM: 616228]",
          "OMIM Entry": "607905",
          "Inheritance": "AR"
        },
        {
          "Gene": "ANO10",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 10 [MIM: 613728]",
          "OMIM Entry": "613726",
          "Inheritance": "AR"
        },
        {
          "Gene": "ANO5",
          "Phenotype MIM Number": "Gnathodiaphyseal dysplasia [MIM: 166260]; Miyoshi muscular dystrophy 3 [MIM: 613319]; Muscular dystrophy, limb-girdle, autosomal recessive 12 [MIM: 611307]",
          "OMIM Entry": "608662",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "APTX",
          "Phenotype MIM Number": "Ataxia, early-onset, with oculomotor apraxia and hypoalbuminemia [MIM: 208920]",
          "OMIM Entry": "606350",
          "Inheritance": "AR"
        },
        {
          "Gene": "AR",
          "Phenotype MIM Number": "{Prostate cancer, susceptibility to} [MIM: 301120]; Androgen insensitivity [MIM: 300068]; Androgen insensitivity, partial, with or without breast cancer [MIM: 312300]; Hypospadias 1, X-linked [MIM: 300633]; Spinal and bulbar muscular atrophy, X-linked 1 [MIM: 313200]",
          "OMIM Entry": "313700",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "ASAH1",
          "Phenotype MIM Number": "Farber lipogranulomatosis [MIM: 228000]; Spinal muscular atrophy with progressive myoclonic epilepsy [MIM: 159950]",
          "OMIM Entry": "613468",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASCC1",
          "Phenotype MIM Number": "Barrett esophagus/esophageal adenocarcinoma [MIM: 614266]; Spinal muscular atrophy with congenital bone fractures 2 [MIM: 616867]",
          "OMIM Entry": "614215",
          "Inheritance": "AR"
        },
        {
          "Gene": "ASCC3",
          "Phenotype MIM Number": "Intellectual developmental disorder, autosomal recessive 81 [MIM: 620700]",
          "OMIM Entry": "614217",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATCAY",
          "Phenotype MIM Number": "Ataxia, cerebellar, Cayman type [MIM: 601238]",
          "OMIM Entry": "608179",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATG5",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 25 [MIM: 617584]",
          "OMIM Entry": "604261",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATM",
          "Phenotype MIM Number": "{Breast cancer, susceptibility to} [MIM: 114480]; Ataxia-telangiectasia [MIM: 208900]; Lymphoma, B-cell non-Hodgkin, somatic; Lymphoma, mantle cell, somatic; T-cell prolymphocytic leukemia, somatic",
          "OMIM Entry": "607585",
          "Inheritance": "AD, AR, SMu"
        },
        {
          "Gene": "ATN1",
          "Phenotype MIM Number": "Congenital hypotonia, epilepsy, developmental delay, and digital anomalies [618494]; Dentatorubral-pallidoluysian atrophy [MIM: 125370]",
          "OMIM Entry": "607462",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATP2A1",
          "Phenotype MIM Number": "Brody myopathy [MIM: 601003]",
          "OMIM Entry": "108730",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATP2B3",
          "Phenotype MIM Number": "Spinocerebellar ataxia, X-linked 1 [MIM: 302500]",
          "OMIM Entry": "300014",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ATP7A",
          "Phenotype MIM Number": "Menkes disease [MIM: 309400]; Neuronopathy, distal hereditary motor, X-linked [MIM: 300489]; Occipital horn syndrome [MIM: 304150]",
          "OMIM Entry": "300011",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ATP8A2",
          "Phenotype MIM Number": "Cerebellar ataxia, impaired intellectual development, and dysequilibrium syndrome 4 [MIM: 615268]",
          "OMIM Entry": "605870",
          "Inheritance": "AR"
        },
        {
          "Gene": "ATXN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 1 [MIM: 164400]",
          "OMIM Entry": "601556",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN10",
          "Phenotype MIM Number": "Spinocerebellar ataxia 10 [MIM: 603516]",
          "OMIM Entry": "611150",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 2 [MIM: 183090]; {Amyotrophic lateral sclerosis susceptibility to 13} [MIM: 183090]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "601517",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN3",
          "Phenotype MIM Number": "Machado-Joseph disease [MIM: 109150]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
          "OMIM Entry": "607047",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "ATXN7",
          "Phenotype MIM Number": "Spinocerebellar ataxia 7 [MIM: 164500]",
          "OMIM Entry": "607640",
          "Inheritance": "AD"
        },
        {
          "Gene": "ATXN8/ATXN8OS",
          "Phenotype MIM Number": "Spinocerebellar ataxia 8 [MIM: 608768]; {Parkinson disease susceptibility to} [MIM: 168600]",
          "OMIM Entry": "613289; 603680",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "B3GALNT2",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 11 [MIM; 615181]",
          "OMIM Entry": "610194",
          "Inheritance": "AR"
        },
        {
          "Gene": "B4GAT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 13 [MIM: 615287]",
          "OMIM Entry": "605517",
          "Inheritance": "AR"
        },
        {
          "Gene": "BAG3",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal dominant 15 [MIM: 621094]; Cardiomyopathy, dilated, 1HH [MIM: 613381]; Charcot-Marie-Tooth disease, axonal, type 2JJ [MIM; 621095]; Myopathy, myofibrillar, 6 [MIM: 612954] ",
          "OMIM Entry": "603883",
          "Inheritance": "AD"
        },
        {
          "Gene": "BEAN1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 31 [MIM: 117210]",
          "OMIM Entry": "612051",
          "Inheritance": "AD"
        },
        {
          "Gene": "BICD2",
          "Phenotype MIM Number": "Spinal muscular atrophy, lower extremity-predominant, 2A, autosomal dominant [MIM: 615290]; Spinal muscular atrophy, lower extremity-predominant, 2B, autosomal dominant [MIM: 618291] ",
          "OMIM Entry": "609797",
          "Inheritance": "AD"
        },
        {
          "Gene": "BIN1",
          "Phenotype MIM Number": "Centronuclear myopathy 2 [MIM: 255200]",
          "OMIM Entry": "601248",
          "Inheritance": "AR"
        },
        {
          "Gene": "BSCL2",
          "Phenotype MIM Number": "Encephalopathy, progressive, with or without lipodystrophy [MIM: 615942]; Lipodystrophy, congenital generalized, type 2 [MIM: 269700]; Neuronopathy, distal hereditary motor, autosomal dominant 13 [MIM: 619122]; Silver spastic paraplegia syndrome [MIM: 270685]",
          "OMIM Entry": "606158",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "C1QBP",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 33 [MIM: 617773]",
          "OMIM Entry": "601269",
          "Inheritance": "AR"
        },
        {
          "Gene": "C9orf72",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 1 [MIM: 105550]",
          "OMIM Entry": "614260",
          "Inheritance": "AD"
        },
        {
          "Gene": "CA8",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 34 [MIM: 613227]",
          "OMIM Entry": "114815",
          "Inheritance": "AR"
        },
        {
          "Gene": "CACNA1A",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 42 [MIM: 617106]; Episodic ataxia, type 2 [MIM: 108500]; Migraine, familial hemiplegic, 1 [MIM: 141500]; Migraine, familial hemiplegic, 1, with progressive cerebellar ataxia [MIM: 141500]; Spinocerebellar ataxia 6 [MIM: 183086]",
          "OMIM Entry": "601011",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNA1G",
          "Phenotype MIM Number": "Spinocerebellar ataxia 42 [MIM: 616795]; Spinocerebellar ataxia 42, early-onset, severe, with neurodevelopmental deficits [MIM: 618087]",
          "OMIM Entry": "604065",
          "Inheritance": "AD"
        },
        {
          "Gene": "CACNA1S",
          "Phenotype MIM Number": "{Malignant hyperthermia susceptibility 5} [MIM: 601887]; {Thyrotoxic periodic paralysis, susceptibility to, 1} [MIM: 188580]; Congenital myopathy 18 due to dihydropyridine receptor defect [MIM: 620246]; Hypokalemic periodic paralysis, type 1 [MIM: 170400]",
          "OMIM Entry": "114208",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CACNB4",
          "Phenotype MIM Number": "Episodic ataxia, type 5 [MIM: 613855]; {Epilepsy, idiopathic generalized, susceptibility to, 9}  [MIM: 607682]; {Epilepsy, juvenile myoclonic, susceptibility to, 6} [MIM: 607682]",
          "OMIM Entry": "601949",
          "Inheritance": "AD"
        },
        {
          "Gene": "CAPN3",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 4 [MIM: 618129]; Muscular dystrophy, limb-girdle, autosomal recessive 1 [MIM: 253600]",
          "OMIM Entry": "114240",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CASQ1",
          "Phenotype MIM Number": "Myopathy, vacuolar, with CASQ1 aggregates [MIM: 616231]",
          "OMIM Entry": "114250",
          "Inheritance": "AD"
        },
        {
          "Gene": "CAV3",
          "Phenotype MIM Number": "Cardiomyopathy, familial hypertrophic [MIM: 192600]; Creatine phosphokinase, elevated serum [MIM: 123320]; Long QT syndrome 9 [MIM: 611818]; Myopathy, distal, Tateyama type [MIM: 614321]; Rippling muscle disease 2 [MIM: 606072]",
          "OMIM Entry": "601253",
          "Inheritance": "AD, DD"
        },
        {
          "Gene": "CAVIN1",
          "Phenotype MIM Number": "Lipodystrophy, congenital generalized, type 4 [MIM: 613327]",
          "OMIM Entry": "603198",
          "Inheritance": "AR"
        },
        {
          "Gene": "CCDC78",
          "Phenotype MIM Number": "Centronuclear myopathy 4 [MIM: 614807]",
          "OMIM Entry": "614666",
          "Inheritance": "AD"
        },
        {
          "Gene": "CCDC88C",
          "Phenotype MIM Number": "Spinocerebellar ataxia 40 [MIM: 616053]; Hydrocephalus, congenital, 1 [MIM: 236600]",
          "OMIM Entry": "611204",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CFL2",
          "Phenotype MIM Number": "Nemaline myopathy 7, autosomal recessive [MIM 610687]",
          "OMIM Entry": "601443",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHAT",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 6, presynaptic [MIM: 254210]",
          "OMIM Entry": "118490",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHKB",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, megaconial type [MIM: 602541]",
          "OMIM Entry": "612395",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHP1",
          "Phenotype MIM Number": "Spastic ataxia 9, autosomal recessive [MIM: 618438]",
          "OMIM Entry": "606988",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHRNA1",
          "Phenotype MIM Number": "Multiple pterygium syndrome, lethal type [MIM: 253290]; Myasthenic syndrome, congenital, 1A, slow-channel [MIM: 601462]; Myasthenic syndrome, congenital, 1B, fast-channel [MIM: 608930]",
          "OMIM Entry": "100690",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRNB1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 2C, associated with acetylcholine receptor deficiency [MIM: 616314]; Myasthenic syndrome, congenital, 2A, slow-channel [MIM: 616313]",
          "OMIM Entry": "100710",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRND",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 3A, slow-channel [MIM: 616321]; Myasthenic syndrome, congenital, 3C, associated with acetylcholine receptor deficiency [MIM: 616323]; Multiple pterygium syndrome, lethal type [MIM: 253290]; Myasthenic syndrome, congenital, 3B, fast-channel [MIM: 616322]",
          "OMIM Entry": "100720",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRNE",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 4A, slow-channel [MIM: 605809]; Myasthenic syndrome, congenital, 4B, fast-channel [MIM: 616324]; Myasthenic syndrome, congenital, 4C, associated with acetylcholine receptor deficiency [MIM: 608931]",
          "OMIM Entry": "100725",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CHRNG",
          "Phenotype MIM Number": "Escobar syndrome [MIM: 265000] Multiple pterygium syndrome, lethal type [MIM: 253290]",
          "OMIM Entry": "100730",
          "Inheritance": "AR"
        },
        {
          "Gene": "CHST14",
          "Phenotype MIM Number": "Ehlers-Danlos syndrome, musculocontractural type 1 [MIM: 601776]",
          "OMIM Entry": "608429",
          "Inheritance": "AR"
        },
        {
          "Gene": "CLCN1",
          "Phenotype MIM Number": "Myotonia congenita, dominant [MIM: 160880]; Myotonia congenita, recessive [MIM: 255700]; Myotonia levior [MIM: 160800]",
          "OMIM Entry": "118425",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CNBP",
          "Phenotype MIM Number": "Myotonic dystrophy 2 [MIM: 602668]",
          "OMIM Entry": "116955",
          "Inheritance": "AD"
        },
        {
          "Gene": "CNTN1",
          "Phenotype MIM Number": "Congenital myopathy 12 [MIM: 612540]",
          "OMIM Entry": "600016",
          "Inheritance": "AR"
        },
        {
          "Gene": "COA7",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 3 [MIM: 618387]",
          "OMIM Entry": "615623",
          "Inheritance": "AR"
        },
        {
          "Gene": "COL12A1",
          "Phenotype MIM Number": "Ullrich congenital muscular dystrophy 2 [mim: 616470]; Bethlem myopathy 2 [MIM: 616471]",
          "OMIM Entry": "120320",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL13A1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 19 [MIM: 616720]",
          "OMIM Entry": "120350",
          "Inheritance": "AR"
        },
        {
          "Gene": "COL25A1",
          "Phenotype MIM Number": "Fibrosis of extraocular muscles, congenital, 5 [MIM: 616219]",
          "OMIM Entry": "610004",
          "Inheritance": "AR"
        },
        {
          "Gene": "COL6A1",
          "Phenotype MIM Number": "Bethlem myopathy 1A [MIM: 158810]; Ullrich congenital muscular dystrophy 1A [MIM: 254090]",
          "OMIM Entry": "120220",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL6A2",
          "Phenotype MIM Number": "Myosclerosis, congenital [MIM: 255600]; Bethlem myopathy 1B [MIM: 620725]; Ullrich congenital muscular dystrophy 1B [MIM: 620727]",
          "OMIM Entry": "120240",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COL6A3",
          "Phenotype MIM Number": "Bethlem myopathy 1C [MIM: 620726]; Dystonia 27 [MIM; 616411]; Ullrich congenital muscular dystrophy 1C [MIM: 620728]",
          "OMIM Entry": "120250",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COLQ",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 5 [MIM: 603034]",
          "OMIM Entry": "603033",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ2",
          "Phenotype MIM Number": "{Multiple system atrophy, susceptibility to} [MIM: 146500]; Coenzyme Q10 deficiency, primary, 1 [MIM: 607426]",
          "OMIM Entry": "609825",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "COQ4",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 7 [MIM: 616276]; Spastic ataxia 10, autosomal recessive [MIM: 620666]",
          "OMIM Entry": "612898",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ8A",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 4 [MIM: 612016]",
          "OMIM Entry": "606980",
          "Inheritance": "AR"
        },
        {
          "Gene": "COQ9",
          "Phenotype MIM Number": "Coenzyme Q10 deficiency, primary, 5 [MIM: 614654]",
          "OMIM Entry": "612837",
          "Inheritance": "AR"
        },
        {
          "Gene": "CPT2",
          "Phenotype MIM Number": "{Encephalopathy, acute, infection-induced, 4, susceptibility to} [MIM: 614212]; CPT II deficiency, infantile [MIM: 600649]; CPT II deficiency, lethal neonatal [MIM: 608836]; CPT II deficiency, myopathic, stress-induced [MIM: 255110]",
          "OMIM Entry": "600650",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CRPPA",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 7 [MIM: 614643]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 7 [MIM: 616052]",
          "OMIM Entry": "614631",
          "Inheritance": "AR"
        },
        {
          "Gene": "CRYAB",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1II [MIM: 615184]; Cataract 16, multiple types [MIM: 613763]; Myopathy, myofibrillar, 2A, adult-onset [MIM: 608810]; Myopathy, myofibrillar, 2B, infantile-onset [MIM: 613869]",
          "OMIM Entry": "123590",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "CTBP1",
          "Phenotype MIM Number": "Hypotonia, ataxia, developmental delay, and tooth enamel defect syndrome [MIM: 617915]",
          "OMIM Entry": "602618",
          "Inheritance": "AD"
        },
        {
          "Gene": "CWF19L1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 17 [MIM: 616127]",
          "OMIM Entry": "616120",
          "Inheritance": "AR"
        },
        {
          "Gene": "DAB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 37 [MIM: 615945]",
          "OMIM Entry": "603448",
          "Inheritance": "AD"
        },
        {
          "Gene": "DAG1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 9 [MIM: 616538]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 9 [MIM: 613818]",
          "OMIM Entry": "128239",
          "Inheritance": "AR"
        },
        {
          "Gene": "DES",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1I [MIM: 604765]; Myopathy, myofibrillar, 1 [MIM: 601419]; Scapuloperoneal syndrome, neurogenic, Kaeser type [MIM: 181400]",
          "OMIM Entry": "125660",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DMD",
          "Phenotype MIM Number": "Becker muscular dystrophy [MIM: 300376]; Cardiomyopathy, dilated, 3B [MIM: 302045]; Duchenne muscular dystrophy [MIM: 310200]",
          "OMIM Entry": "300377",
          "Inheritance": "XL, XLR"
        },
        {
          "Gene": "DMPK",
          "Phenotype MIM Number": "Myotonic dystrophy 1 [MIM: 160900]",
          "OMIM Entry": "605377",
          "Inheritance": "AD"
        },
        {
          "Gene": "DNA2",
          "Phenotype MIM Number": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 6 [MIM: 615156]; Rothmund-Thomson syndrome, type 4 [MIM: 620819]; Seckel syndrome 8 [MIM: 615807]",
          "OMIM Entry": "601810",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DNAJB4",
          "Phenotype MIM Number": "Congenital myopathy 21 with early respiratory failure [MIM: 620326]",
          "OMIM Entry": "611327",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNAJB6",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 1 [MIM: 603511]",
          "OMIM Entry": "611332",
          "Inheritance": "AD"
        },
        {
          "Gene": "DNAJC3",
          "Phenotype MIM Number": "Ataxia, combined cerebellar and peripheral, with hearing loss and diabetes mellitus [MIM: 616192]",
          "OMIM Entry": "601184",
          "Inheritance": "AR"
        },
        {
          "Gene": "DNM2",
          "Phenotype MIM Number": "Centronuclear myopathy 1 [MIM: 160150]; Charcot-Marie-Tooth disease, axonal type 2M [MIM: 606482]; Charcot-Marie-Tooth disease, dominant intermediate B [MIM: 606482]; Lethal congenital contracture syndrome 5 [MIM; 615368]",
          "OMIM Entry": "602378",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "DNMT1",
          "Phenotype MIM Number": "Cerebellar ataxia, deafness, and narcolepsy, autosomal dominant [MIM: 604121]; Neuropathy, hereditary sensory, type IE [MIM: 614116]",
          "OMIM Entry": "126375",
          "Inheritance": "AD"
        },
        {
          "Gene": "DOK7",
          "Phenotype MIM Number": "Fetal akinesia deformation sequence 3 [MIM: 618389]; Myasthenic syndrome, congenital, 10 [MIM: 254300]",
          "OMIM Entry": "610285",
          "Inheritance": "AR"
        },
        {
          "Gene": "DOLK",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Im [MIM: 610768]",
          "OMIM Entry": "610746",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPAGT1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ij [MIM: 608093]; Myasthenic syndrome, congenital, 13, with tubular aggregates [MIM: 614750]",
          "OMIM Entry": "191350",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPM1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Ie [MIM: 608799]",
          "OMIM Entry": "603503",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPM2",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type Iu [MIM: 615042]",
          "OMIM Entry": "603564",
          "Inheritance": "AR"
        },
        {
          "Gene": "DPM3",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 15 [MIM: 618992]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 15 [MIM: 612937]",
          "OMIM Entry": "605951",
          "Inheritance": "AR"
        },
        {
          "Gene": "DTNA",
          "Phenotype MIM Number": "Left ventricular noncompaction 1, with or without congenital heart defects [MIM: 604169]; Myopathy with myalgia, increased serum creatine kinase, and with or without episodic rhabdomyolysis 2 [MIM: 620971]",
          "OMIM Entry": "601239",
          "Inheritance": "AD"
        },
        {
          "Gene": "DYNC1H1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2O [MIM: 614228]; Cortical dysplasia, complex, with other brain malformations 13 [MIM: 614563]; Spinal muscular atrophy, lower extremity-predominant 1, AD [MIM: 158600]",
          "OMIM Entry": "600112",
          "Inheritance": "AD"
        },
        {
          "Gene": "DYSF",
          "Phenotype MIM Number": "Miyoshi muscular dystrophy 1 [MIM: 254130]; Muscular dystrophy, limb-girdle, autosomal recessive 2 [MIM: 253601]; Myopathy, distal, with anterior tibial onset [MIM: 606768]",
          "OMIM Entry": "603009",
          "Inheritance": "AR"
        },
        {
          "Gene": "EBF3",
          "Phenotype MIM Number": "Hypotonia, ataxia, and delayed development syndrome [MIM: 617330]",
          "OMIM Entry": "607407",
          "Inheritance": "AD"
        },
        {
          "Gene": "ECEL1",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 5D [MIM: 615065]",
          "OMIM Entry": "605896",
          "Inheritance": "AR"
        },
        {
          "Gene": "EEF2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 26 [MIM: 609306]",
          "OMIM Entry": "130610",
          "Inheritance": "AD"
        },
        {
          "Gene": "ELOVL4",
          "Phenotype MIM Number": "Ichthyosis, spastic quadriplegia, and impaired intellectual development [MIM: 614457]; Spinocerebellar ataxia 34 [MIM: 133190]; Stargardt disease 3 [MIM: 600110]",
          "OMIM Entry": "605512",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "ELOVL5",
          "Phenotype MIM Number": "Spinocerebellar ataxia 38 [MIM: 615957]",
          "OMIM Entry": "611805",
          "Inheritance": "AD"
        },
        {
          "Gene": "EMD",
          "Phenotype MIM Number": "Emery-Dreifuss muscular dystrophy 1, X-linked [MIM: 310300]",
          "OMIM Entry": "300384",
          "Inheritance": "XLR"
        },
        {
          "Gene": "ENO3",
          "Phenotype MIM Number": "Glycogen storage disease XIII [MIM: 612932]",
          "OMIM Entry": "131370",
          "Inheritance": "AR"
        },
        {
          "Gene": "EPG5",
          "Phenotype MIM Number": "Vici syndrome [ MIM: 242820]",
          "OMIM Entry": "615068",
          "Inheritance": "AR"
        },
        {
          "Gene": "ETFA",
          "Phenotype MIM Number": "Glutaric acidemia IIA [MIM: 231680]",
          "OMIM Entry": "608053",
          "Inheritance": "AR"
        },
        {
          "Gene": "ETFB",
          "Phenotype MIM Number": "Glutaric acidemia IIB [MIM: 231680]",
          "OMIM Entry": "130410",
          "Inheritance": "AR"
        },
        {
          "Gene": "ETFDH",
          "Phenotype MIM Number": "Glutaric acidemia IIC [MIM: 231680]",
          "OMIM Entry": "231675",
          "Inheritance": "AR"
        },
        {
          "Gene": "EXOSC3",
          "Phenotype MIM Number": "Pontocerebellar hypoplasia, type 1B [MIM: 614678]",
          "OMIM Entry": "606489",
          "Inheritance": "AR"
        },
        {
          "Gene": "FAT2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 45 [MIM: 617769]",
          "OMIM Entry": "604269",
          "Inheritance": "AD"
        },
        {
          "Gene": "FBXL4",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 13 (encephalomyopathic type) [MIM: 615471]",
          "OMIM Entry": "605654",
          "Inheritance": "AR"
        },
        {
          "Gene": "FBXO38",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal dominant 6 [MIM: 625575]",
          "OMIM Entry": "608553",
          "Inheritance": "AD"
        },
        {
          "Gene": "FDX2",
          "Phenotype MIM Number": "Mitochondrial myopathy, episodic, with optic atrophy and reversible leukoencephalopathy [MIM: 251900]",
          "OMIM Entry": "614585",
          "Inheritance": "AR"
        },
        {
          "Gene": "FGF14",
          "Phenotype MIM Number": "Spinocerebellar ataxia 27A [MIM: 193003]; Spinocerebellar ataxia 27B, late-onset [MIM: 620174]",
          "OMIM Entry": "601515",
          "Inheritance": "AD"
        },
        {
          "Gene": "FHL1",
          "Phenotype MIM Number": "Uruguay faciocardiomusculoskeletal syndrome [MIM: 300280]; Emery-Dreifuss muscular dystrophy 6, X-linked [MIM: 300696]; Myopathy, X-linked, with postural muscle atrophy [MIM: 300696]; Reducing body myopathy, X-linked 1a, severe, infantile or early childhood onset [MIM: 300717]; Reducing body myopathy, X-linked 1b, with late childhood or adult onset [MIM: 300718]; Scapuloperoneal myopathy, X-linked dominant [MIM: 300695]",
          "OMIM Entry": "300163",
          "Inheritance": "XL, XLR, XLD"
        },
        {
          "Gene": "FKBP14",
          "Phenotype MIM Number": "Ehlers-Danlos syndrome, kyphoscoliotic type, 2 [MIM: 614557]",
          "OMIM Entry": "614505",
          "Inheritance": "AR"
        },
        {
          "Gene": "FKRP",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 5 [MIM: 613153]; Muscular dystrophy-dystroglycanopathy (congenital with or without impaired intellectual development), type B, 5 [MIM: 606612]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 5 [MIM: 607155]",
          "OMIM Entry": "606596",
          "Inheritance": "AR"
        },
        {
          "Gene": "FKTN",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1X [MIM: 611615]; Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 4 [MIM: 253800]; Muscular dystrophy-dystroglycanopathy (congenital without impaired intellectual development), type B, 4 [MIM: 613152]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 4 [MIM: 611588]",
          "OMIM Entry": "607440",
          "Inheritance": "AR"
        },
        {
          "Gene": "FLAD1",
          "Phenotype MIM Number": "Lipid storage myopathy due to flavin adenine dinucleotide synthetase deficiency [MIM: 255100]",
          "OMIM Entry": "610595",
          "Inheritance": "AR"
        },
        {
          "Gene": "FLNC",
          "Phenotype MIM Number": "Arrhythmogenic right ventricular dysplasia, familial [MIM: 617047]; Cardiomyopathy, familial hypertrophic, 26 [MIM: 617047]; Cardiomyopathy, familial restrictive 5 [MIM: 617047]; Myopathy, distal, 4 [MIM: 614065]; Myopathy, myofibrillar, 5 [MIM: 609524] ",
          "OMIM Entry": "102565",
          "Inheritance": "AD"
        },
        {
          "Gene": "FMR1",
          "Phenotype MIM Number": "Fragile X syndrome [MIM: 300624]; Fragile X tremor/ataxia syndrome [MIM 300623]; Premature ovarian failure 1 [MIM: 311360]",
          "OMIM Entry": "309550",
          "Inheritance": "XLD, XL"
        },
        {
          "Gene": "FXN",
          "Phenotype MIM Number": "Friedreich ataxia [MIM: 229300]; Friedreich ataxia with retained reflexes [MIM: 229300]",
          "OMIM Entry": "606829",
          "Inheritance": "AR"
        },
        {
          "Gene": "FXR1",
          "Phenotype MIM Number": "Congenital myopathy 9A with respiratory insufficiency and bone fractures [MIM: 618822]; Congenital myopathy 9B, proximal, with minicore lesions [MIM: 618823]",
          "OMIM Entry": "600819",
          "Inheritance": "AR"
        },
        {
          "Gene": "GAA",
          "Phenotype MIM Number": "Pompe disease, infantile-onset [MIM: 232300]; Pompe disease, late-onset [MIM: 621314]",
          "OMIM Entry": "606800",
          "Inheritance": "AR"
        },
        {
          "Gene": "GBE1",
          "Phenotype MIM Number": "Glycogen storage disease IV [MIM: 232500]; Polyglucosan body disease, adult form [MIM: 263570]",
          "OMIM Entry": "607839",
          "Inheritance": "AR"
        },
        {
          "Gene": "GDAP2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 27 [MIM: 618369]",
          "OMIM Entry": "618128",
          "Inheritance": "AR"
        },
        {
          "Gene": "GFER",
          "Phenotype MIM Number": "Myopathy, mitochondrial progressive, with congenital cataract and developmental delay [MIM: 613076]",
          "OMIM Entry": "600924",
          "Inheritance": "AR"
        },
        {
          "Gene": "GFPT1",
          "Phenotype MIM Number": "Myasthenia, congenital, 12, with tubular aggregates [MIM: 610542]",
          "OMIM Entry": "138292",
          "Inheritance": "AR"
        },
        {
          "Gene": "GGPS1",
          "Phenotype MIM Number": "Muscular dystrophy, congenital hearing loss, and ovarian insufficiency syndrome [MIM: 619518]",
          "OMIM Entry": "606982",
          "Inheritance": "AR"
        },
        {
          "Gene": "GIPC1",
          "Phenotype MIM Number": "Oculopharyngodistal myopathy 2 [MIM: 618940]",
          "OMIM Entry": "605072",
          "Inheritance": "AD"
        },
        {
          "Gene": "GLDN",
          "Phenotype MIM Number": "Lethal congenital contracture syndrome 11 [MIM: 617194]",
          "OMIM Entry": "608603",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLE1",
          "Phenotype MIM Number": "Congenital arthrogryposis with anterior horn cell disease [MIM: 611890]; Lethal congenital contracture syndrome 1[ MIM: 253310]",
          "OMIM Entry": "603371",
          "Inheritance": "AR"
        },
        {
          "Gene": "GLS",
          "Phenotype MIM Number": "Global developmental delay progressive ataxia and elevated glutamine [MIM: 618412]",
          "OMIM Entry": "138280",
          "Inheritance": "AR"
        },
        {
          "Gene": "GM2A",
          "Phenotype MIM Number": "GM2-gangliosidosis, AB variant [MIM: 272750]",
          "OMIM Entry": "613109",
          "Inheritance": "AR"
        },
        {
          "Gene": "GMPPB",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 14 [MIM: 615350]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 14 [MIM: 615351]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 14 [MIM: 615352]",
          "OMIM Entry": "615320",
          "Inheritance": "AR"
        },
        {
          "Gene": "GNE",
          "Phenotype MIM Number": "Nonaka myopathy [MIM: 605820]; Sialuria [MIM: 269921]; Thrombocytopenia 12 with or without myopathy [MIM: 620757]",
          "OMIM Entry": "603824",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GOLGA2",
          "Phenotype MIM Number": "Developmental delay with hypotonia, myopathy, and brain abnormalities [MIM: 620240]",
          "OMIM Entry": "602580",
          "Inheritance": "AR"
        },
        {
          "Gene": "GOSR2",
          "Phenotype MIM Number": "Epilepsy, progressive myoclonic 6 [MIM: 614018]; Muscular dystrophy, congenital, with or without seizures [MIM: 620166]",
          "OMIM Entry": "604027",
          "Inheritance": "AR"
        },
        {
          "Gene": "GRID2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 18 [MIM: 616204]",
          "OMIM Entry": "602368",
          "Inheritance": "AR"
        },
        {
          "Gene": "GRM1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 44 [MIM: 617691]; Spinocerebellar ataxia, autosomal recessive 13 [MIM: 614831]",
          "OMIM Entry": "604473",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "GYG1",
          "Phenotype MIM Number": "Glycogen storage disease XV [MIM: 613507]; Polyglucosan body myopathy 2 [MIM: 616199]",
          "OMIM Entry": "603942",
          "Inheritance": "AR"
        },
        {
          "Gene": "GYS1",
          "Phenotype MIM Number": "Glycogen storage disease 0, muscle [MIM: 611556]",
          "OMIM Entry": "138570",
          "Inheritance": "AR"
        },
        {
          "Gene": "HACD1",
          "Phenotype MIM Number": "Congenital myopathy 11 [MIM: 619967]",
          "OMIM Entry": "610467",
          "Inheritance": "AR"
        },
        {
          "Gene": "HADHA",
          "Phenotype MIM Number": "Fatty liver, acute, of pregnancy [MIM: 609016]; HELLP syndrome, maternal, of pregnancy [MIM: 609016]; LCHAD deficiency [MIM: 609016]; Mitochondrial trifunctional protein deficiency 1 [MIM: 609015]",
          "OMIM Entry": "600890",
          "Inheritance": "AR"
        },
        {
          "Gene": "HADHB",
          "Phenotype MIM Number": "Mitochondrial trifunctional protein deficiency 2 [MIM: 620300]",
          "OMIM Entry": "143450",
          "Inheritance": "AR"
        },
        {
          "Gene": "HEXA",
          "Phenotype MIM Number": "[Hex A pseudodeficiency] [MIM: 272800]; GM2-gangliosidosis, several forms [MIM: 272800]; Tay-Sachs disease [MIM: 272800]",
          "OMIM Entry": "606869",
          "Inheritance": "AR"
        },
        {
          "Gene": "HEXB",
          "Phenotype MIM Number": "Sandhoff disease, infantile, juvenile, and adult forms [MIM: 268800]",
          "OMIM Entry": "606873",
          "Inheritance": "AR"
        },
        {
          "Gene": "HMGCR",
          "Phenotype MIM Number": "[Low density lipoprotein cholesterol level QTL 3] [MIM: 620410]; [Statins, response to] [MIM: 620410]; Muscular dystrophy, limb-girdle, autosomal recessive 28 [MIM: 620375]",
          "OMIM Entry": "142910",
          "Inheritance": "AR"
        },
        {
          "Gene": "HNRNPA1",
          "Phenotype MIM Number": "Inclusion body myopathy with early-onset Paget disease without frontotemporal dementia 3  [MIM: 615424]; Myopathy, distal, 3 [MIM: 610099]; Amyotrophic lateral sclerosis 20 [MIM: 615426]",
          "OMIM Entry": "164017",
          "Inheritance": "AD"
        },
        {
          "Gene": "HNRNPA2B1",
          "Phenotype MIM Number": "Inclusion body myopathy with early-onset Paget disease with or without frontotemporal dementia 2 [MIM: 615422]; Oculopharyngeal muscular dystrophy 2 [MIM: 620460]",
          "OMIM Entry": "600124",
          "Inheritance": "AD"
        },
        {
          "Gene": "HNRNPDL",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 3 [MIM: 609155]",
          "OMIM Entry": "607137",
          "Inheritance": "AD"
        },
        {
          "Gene": "HSPB1",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2F [MIM: 606595]; Neuronopathy, distal hereditary motor, autosomal dominant 3 [MIM: 608634]",
          "OMIM Entry": "602195",
          "Inheritance": "AD"
        },
        {
          "Gene": "HSPB8",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2L [MIM: 608673]; Myopathy, myofibrillar, 13, with rimmed vacuoles [MIM: 621078]; Neuronopathy, distal hereditary motor, autosomal dominant 2 [MIM: 158590]",
          "OMIM Entry": "608014",
          "Inheritance": "AD"
        },
        {
          "Gene": "HTRA2",
          "Phenotype MIM Number": "{Parkinson disease 13} [MIM: 610297]; 3-methylglutaconic aciduria, type VIII [MIM: 617248]",
          "OMIM Entry": "606441",
          "Inheritance": "AR"
        },
        {
          "Gene": "HTT",
          "Phenotype MIM Number": "Huntington disease [MIM: 143100]; Lopes-Maciel-Rodan syndrome [MIM: 617435]",
          "OMIM Entry": "613004",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "IGHMBP2",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, axonal, type 2S [MIM: 616155]; Neuronopathy, distal hereditary motor, autosomal recessive 1 [MIM: 604320]",
          "OMIM Entry": "600502",
          "Inheritance": "AR"
        },
        {
          "Gene": "INPP5K",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, with cataracts and intellectual disability [MIM: 617404]",
          "OMIM Entry": "607875",
          "Inheritance": "AR"
        },
        {
          "Gene": "ISCU",
          "Phenotype MIM Number": "Myopathy with lactic acidosis, hereditary [MIM: 255125]",
          "OMIM Entry": "611911",
          "Inheritance": "AR"
        },
        {
          "Gene": "ITGA7",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, due to ITGA7 deficiency [MIM: 613204]",
          "OMIM Entry": "600536",
          "Inheritance": "AR"
        },
        {
          "Gene": "ITPR1",
          "Phenotype MIM Number": "Gillespie syndrome [MIM: 206700]; Spinocerebellar ataxia 15 [MIM: 606658]; Spinocerebellar ataxia 29, congenital nonprogressive [MIM: 117360] ",
          "OMIM Entry": "147265",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "JAG2",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 27 [MIM: 619566]",
          "OMIM Entry": "602570",
          "Inheritance": "AR"
        },
        {
          "Gene": "JPH3",
          "Phenotype MIM Number": "Huntington disease-like 2 [MIM: 606438]",
          "OMIM Entry": "605268",
          "Inheritance": "AD"
        },
        {
          "Gene": "KBTBD13",
          "Phenotype MIM Number": "Nemaline myopathy 6, autosomal dominant [MIM: 609273]",
          "OMIM Entry": "613727",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNA1",
          "Phenotype MIM Number": "Episodic ataxia/myokymia syndrome [MIM: 160120]",
          "OMIM Entry": "176260",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCNC3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 13 [MIM: 605259]",
          "OMIM Entry": "176264",
          "Inheritance": "AD"
        },
        {
          "Gene": "KCND3",
          "Phenotype MIM Number": "Brugada syndrome 9 [MIM: 616399]; Spinocerebellar ataxia 19 [MIM: 607346]",
          "OMIM Entry": "605411",
          "Inheritance": "AD"
        },
        {
          "Gene": "KIF1C",
          "Phenotype MIM Number": "Spastic ataxia 2, autosomal recessive [MIM: 611302]",
          "OMIM Entry": "603060",
          "Inheritance": "AR"
        },
        {
          "Gene": "KLHL40",
          "Phenotype MIM Number": "Nemaline myopathy 8, autosomal recessive [MIM: 615348]",
          "OMIM Entry": "615340",
          "Inheritance": "AR"
        },
        {
          "Gene": "KLHL41",
          "Phenotype MIM Number": "Nemaline myopathy 9 [MIM: 615731]",
          "OMIM Entry": "607701",
          "Inheritance": "AR"
        },
        {
          "Gene": "KY",
          "Phenotype MIM Number": "Myopathy, myofibrillar, 7 [MIM: 617114]",
          "OMIM Entry": "605739",
          "Inheritance": "AR"
        },
        {
          "Gene": "LAMA2",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, merosin deficient or partially deficient [MIM: 607855]; Muscular dystrophy, limb-girdle, autosomal recessive 23 [MIM: 618138]",
          "OMIM Entry": "156225",
          "Inheritance": "AR"
        },
        {
          "Gene": "LAMP2",
          "Phenotype MIM Number": "Danon disease [MIM: 300257]",
          "OMIM Entry": "309060",
          "Inheritance": "XLD"
        },
        {
          "Gene": "LARGE1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 6 [MIM: 613154]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 6 [MIM: 608840]",
          "OMIM Entry": "603590",
          "Inheritance": "AR"
        },
        {
          "Gene": "LDB3",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1C, with or without LVNC [MIM: 601493]; Cardiomyopathy, dilated, 2L [MIM: 621237]; Cardiomyopathy, hypertrophic, 24 [MIM: 601493]; Left ventricular noncompaction 3 [MIM: 601493]; Myopathy, myofibrillar, 4 [MIM: 609452]",
          "OMIM Entry": "605906",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "LDHA",
          "Phenotype MIM Number": "Glycogen storage disease XI [MIM: 612933]",
          "OMIM Entry": "150000",
          "Inheritance": "AR"
        },
        {
          "Gene": "LETM1",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with multisystem involvement due to mitochondrial dysfunction [MIM: 620089]",
          "OMIM Entry": "604407",
          "Inheritance": "AR"
        },
        {
          "Gene": "LGI4",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 1, neurogenic, with myelin defect [MIM: 617468]",
          "OMIM Entry": "608303",
          "Inheritance": "AR"
        },
        {
          "Gene": "LIMS2",
          "Phenotype MIM Number": "Muscular dystrophy, autosomal recessive, with cardiomyopathy and triangular tongue [MIM: 616827]",
          "OMIM Entry": "607908",
          "Inheritance": "AR"
        },
        {
          "Gene": "LMNA",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1A [MIM: 115200]; Charcot-Marie-Tooth disease, type 2B1 [MIM: 605588]; Emery-Dreifuss muscular dystrophy 2, autosomal dominant [ MIM: 181350]; Emery-Dreifuss muscular dystrophy 3, autosomal recessive [MIM: 616516]; Heart-hand syndrome, Slovenian type [MIM: 610140]; Hutchinson-Gilford progeria [MIM: 176670]; Lipodystrophy, familial partial, type 2 [MIM: 151600]; Malouf syndrome [MIM: 212112]; Mandibuloacral dysplasia [MIM: 248370]; Muscular dystrophy, congenital [MIM: 613205]; Restrictive dermopathy 2 [MIM: 619793]",
          "OMIM Entry": "150330",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "LMOD3",
          "Phenotype MIM Number": "Nemaline myopathy 10 [MIM: 616165]",
          "OMIM Entry": "616112",
          "Inheritance": "AR"
        },
        {
          "Gene": "LPIN1",
          "Phenotype MIM Number": "Myoglobinuria, acute recurrent, autosomal recessive [MIM: 268200]",
          "OMIM Entry": "605518",
          "Inheritance": "AR"
        },
        {
          "Gene": "LRP12",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 28 [MIM: 620452]; Oculopharyngodistal myopathy 1 [MIM: 164310]",
          "OMIM Entry": "618299",
          "Inheritance": "AD"
        },
        {
          "Gene": "MAP3K20",
          "Phenotype MIM Number": "Centronuclear myopathy 6 with fiber-type disproportion [MIM: 617760]; Split-foot malformation with mesoaxial polydactyly [MIM: 616890]",
          "OMIM Entry": "609479",
          "Inheritance": "AR"
        },
        {
          "Gene": "MARS2",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 25 [MIM: 616430]; Spastic ataxia 3, autosomal recessive [MIM: 611390]",
          "OMIM Entry": "609728",
          "Inheritance": "AR"
        },
        {
          "Gene": "MATR3",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 21 [MIM: 606070]",
          "OMIM Entry": "164015",
          "Inheritance": "AD"
        },
        {
          "Gene": "MB",
          "Phenotype MIM Number": "Myopathy, sarcoplasmic body [MIM: 620286]",
          "OMIM Entry": "160000",
          "Inheritance": "AD"
        },
        {
          "Gene": "MEGF10",
          "Phenotype MIM Number": "Congenital myopathy 10A, severe variant [MIM: 614399]; Congenital myopathy 10B, mild variant [MIM: 620249]",
          "OMIM Entry": "612453",
          "Inheritance": "AR"
        },
        {
          "Gene": "MGME1",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 11 [MIM: 615084]",
          "OMIM Entry": "615076",
          "Inheritance": "AR"
        },
        {
          "Gene": "MICU1",
          "Phenotype MIM Number": "Myopathy with extrapyramidal signs [MIM: 615673]",
          "OMIM Entry": "605084",
          "Inheritance": "AR"
        },
        {
          "Gene": "MLIP",
          "Phenotype MIM Number": "Myopathy with myalgia, increased serum creatine kinase, and with or without episodic rhabdomyolysis [MIM: 620138]",
          "OMIM Entry": "614106",
          "Inheritance": "AR"
        },
        {
          "Gene": "MME",
          "Phenotype MIM Number": "Spinocerebellar ataxia 43 [MIM: 617018]; Charcot-Marie-Tooth disease, axonal, type 2T [MIM: 617017]",
          "OMIM Entry": "120520",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MOCS1",
          "Phenotype MIM Number": "Molybdenum cofactor deficiency A [MIM: 252150]",
          "OMIM Entry": "603707",
          "Inheritance": "AR"
        },
        {
          "Gene": "MRE11",
          "Phenotype MIM Number": "Ataxia-telangiectasia-like disorder 1 [MIM: 604391]",
          "OMIM Entry": "600814",
          "Inheritance": "AR"
        },
        {
          "Gene": "MTM1",
          "Phenotype MIM Number": "Myopathy, centronuclear, X-linked [MIM: 310400]",
          "OMIM Entry": "300415",
          "Inheritance": "XLR"
        },
        {
          "Gene": "MTMR14",
          "Phenotype MIM Number": "{Centronuclear myopathy, autosomal, modifier of} [MIM: 160150]",
          "OMIM Entry": "611089",
          "Inheritance": "AD"
        },
        {
          "Gene": "MTPAP",
          "Phenotype MIM Number": "Spastic ataxia 4, autosomal recessive [MIM: 613672]",
          "OMIM Entry": "613669",
          "Inheritance": "AR"
        },
        {
          "Gene": "MUSK",
          "Phenotype MIM Number": "Fetal akinesia deformation sequence 1 [MIM: 208150]; Myasthenic syndrome, congenital, 9, associated with acetylcholine receptor deficiency [MIM: 616325]",
          "OMIM Entry": "601296",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYBPC1",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 1B [MIM: 614335]; Congenital myopathy 16 [MIM; 618524]; Lethal congenital contracture syndrome 4 [MIM: 614915]",
          "OMIM Entry": "160794",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYH2",
          "Phenotype MIM Number": "Congenital myopathy 6 with ophthalmoplegia [MIM: 605637]",
          "OMIM Entry": "160740",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYH3",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 2A (Freeman-Sheldon) [MIM: 193700]; Arthrogryposis, distal, type 2B3 (Sheldon-Hall) [MIM: 618436]; Contractures, pterygia, and spondylocarpostarsal fusion syndrome 1A [MIM: 178110]; Contractures, pterygia, and spondylocarpotarsal fusion syndrome 1B [MIM: 618469] ",
          "OMIM Entry": "160720",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYH7",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1S [MIM: 613426]; Cardiomyopathy, hypertrophic, 1 [MIM: 192600]; Congenital myopathy 7A, myosin storage, autosomal dominant [MIM: 608358]; Congenital myopathy 7B, myosin storage, autosomal recessive [MIM: 255160]; Laing distal myopathy [MIM: 160500]; Left ventricular noncompaction 5 [MIM: 613426]",
          "OMIM Entry": "160760",
          "Inheritance": "AD, AR, DD"
        },
        {
          "Gene": "MYL1",
          "Phenotype MIM Number": "Congenital myopathy 14 [MIM: 618414]",
          "OMIM Entry": "160780",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYL2",
          "Phenotype MIM Number": "Cardiomyopathy, hypertrophic, 10 [MIM: 608758]; Myopathy, myofibrillar, 12, infantile-onset, with cardiomyopathy [MIM: 619424]",
          "OMIM Entry": "160781",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "MYMK",
          "Phenotype MIM Number": "Carey-Fineman-Ziter syndrome [MIM: 254940]",
          "OMIM Entry": "615345",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYO18B",
          "Phenotype MIM Number": "Klippel-Feil syndrome 4, autosomal recessive, with myopathy and facial dysmorphism [MIM: 616549]",
          "OMIM Entry": "607295",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYO9A",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 24, presynaptic [MIM: 618198]",
          "OMIM Entry": "604875",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYOD1",
          "Phenotype MIM Number": "Congenital myopathy 17 [MIM: 618975]",
          "OMIM Entry": "159970",
          "Inheritance": "AR"
        },
        {
          "Gene": "MYOT",
          "Phenotype MIM Number": "Myopathy, myofibrillar, 3 [MIM: 609200]",
          "OMIM Entry": "604103",
          "Inheritance": "AD"
        },
        {
          "Gene": "MYPN",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1KK [MIM: 615248]; Cardiomyopathy, familial restrictive, 4 [MIM: 615248]; Cardiomyopathy, hypertrophic, 22 [MIM: 615248]; Congenital myopathy 24 [MIM: 617336]",
          "OMIM Entry": "608517",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NALCN",
          "Phenotype MIM Number": "Congenital contractures of the limbs and face, hypotonia, and developmental delay [MIM: 616266]; Hypotonia, infantile, with psychomotor retardation and characteristic facies 1 [MIM: 615419]",
          "OMIM Entry": "611549",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "NEB",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 6 [MIM: 619334]; Nemaline myopathy 2, autosomal recessive [MIM: 256030]",
          "OMIM Entry": "161650",
          "Inheritance": "AR"
        },
        {
          "Gene": "NIPA1",
          "Phenotype MIM Number": "Spastic paraplegia 6, autosomal dominant [MIM: 600363]",
          "OMIM Entry": "608145",
          "Inheritance": "AD"
        },
        {
          "Gene": "NKX6-2",
          "Phenotype MIM Number": "Spastic ataxia 8, autosomal recessive, with hypomyelinating leukodystrophy [MIM: 617560]",
          "OMIM Entry": "605955",
          "Inheritance": "AR"
        },
        {
          "Gene": "NOP56",
          "Phenotype MIM Number": "Spinocerebellar ataxia 36 [MIM: 614153]",
          "OMIM Entry": "614154",
          "Inheritance": "AD"
        },
        {
          "Gene": "NUTM2B-AS1",
          "Phenotype MIM Number": "Oculopharyngeal myopathy with leukoencephalopathy 1 [MIM: 618637]",
          "OMIM Entry": "618639",
          "Inheritance": "AD"
        },
        {
          "Gene": "ORAI1",
          "Phenotype MIM Number": "Immunodeficiency 9 [MIM: 612782]; Myopathy, tubular aggregate, 2 [MIM: 615883]",
          "OMIM Entry": "610277",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PABPN1",
          "Phenotype MIM Number": "Oculopharyngeal muscular dystrophy [MIM: 164300]",
          "OMIM Entry": "602279",
          "Inheritance": "AD"
        },
        {
          "Gene": "PAX7",
          "Phenotype MIM Number": "Congenital myopathy 19 [MIM: 618578]; Rhabdomyosarcoma 2, alveolar [MIM: 268220]",
          "OMIM Entry": "167410",
          "Inheritance": "AR, Smu"
        },
        {
          "Gene": "PCNA",
          "Phenotype MIM Number": "Ataxia-telangiectasia-like disorder 2 [MIM: 615919]",
          "OMIM Entry": "176740",
          "Inheritance": "AR"
        },
        {
          "Gene": "PDYN",
          "Phenotype MIM Number": "Spinocerebellar ataxia 23 [MIM: 610245]",
          "OMIM Entry": "131340",
          "Inheritance": "AD"
        },
        {
          "Gene": "PFKM",
          "Phenotype MIM Number": "Glycogen storage disease VII [MIM: 232800]",
          "OMIM Entry": "610681",
          "Inheritance": "AR"
        },
        {
          "Gene": "PGAM2",
          "Phenotype MIM Number": "Glycogen storage disease X [MIM: 261670]",
          "OMIM Entry": "612931",
          "Inheritance": "AR"
        },
        {
          "Gene": "PGK1",
          "Phenotype MIM Number": "Phosphoglycerate kinase 1 deficiency [MIM: 300653]",
          "OMIM Entry": "311800",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PGM1",
          "Phenotype MIM Number": "Congenital disorder of glycosylation, type It [MIM: 614921]",
          "OMIM Entry": "171900",
          "Inheritance": "AR"
        },
        {
          "Gene": "PHKA1",
          "Phenotype MIM Number": "Muscle glycogenosis [MIM: 300559]",
          "OMIM Entry": "311870",
          "Inheritance": "XLR"
        },
        {
          "Gene": "PHKB",
          "Phenotype MIM Number": "Phosphorylase kinase deficiency of liver and muscle, autosomal recessive [MIM: 261750]",
          "OMIM Entry": "172490",
          "Inheritance": "AR"
        },
        {
          "Gene": "PIEZO2",
          "Phenotype MIM Number": "Marden-Walker syndrome [MIM: 248700]; Arthrogryposis, distal, type 3 [MIM: 114300]; Arthrogryposis, distal, type 5 [MIM: 108145]; Arthrogryposis, distal, with impaired proprioception and touch [MIM: 617146]",
          "OMIM Entry": "613629",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PIK3R5",
          "Phenotype MIM Number": "Ataxia-oculomotor apraxia 3 [MIM: 615217]",
          "OMIM Entry": "611317",
          "Inheritance": "AR"
        },
        {
          "Gene": "PITRM1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 30 [MIM: 619405]",
          "OMIM Entry": "618211",
          "Inheritance": "AR"
        },
        {
          "Gene": "PLD3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 46 [MIM: 617770]",
          "OMIM Entry": "615698",
          "Inheritance": "AD"
        },
        {
          "Gene": "PLEC",
          "Phenotype MIM Number": "Epidermolysis bullosa simplex 5D, generalized intermediate, autosomal recessive [MIM: 616487]; Epidermolysis bullosa simplex 5A, Ogna type [MIM: 131950]; Epidermolysis bullosa simplex 5B, with muscular dystrophy [MIM: 226670]; Epidermolysis bullosa simplex 5C, with pyloric atresia [MIM: 612138]; Muscular dystrophy, limb-girdle, autosomal recessive 17 [MIM: 613723]",
          "OMIM Entry": "601282",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "PLEKHG5",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, recessive intermediate C [MIM: 615376]; Neuronopathy, distal hereditary motor, autosomal recessive 4 [MIM: 611067] ",
          "OMIM Entry": "611101",
          "Inheritance": "AR"
        },
        {
          "Gene": "PMPCA",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 2 [MIM: 213200]",
          "OMIM Entry": "613036",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNKP",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 2B2 [MIM: 605589]; Ataxia-oculomotor apraxia 4 [MIM: 616267]; Microcephaly, seizures, and developmental delay [MIM: 613402]",
          "OMIM Entry": "605610",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPLA2",
          "Phenotype MIM Number": "Neutral lipid storage disease with myopathy {MIM: 610717]",
          "OMIM Entry": "609059",
          "Inheritance": "AR"
        },
        {
          "Gene": "PNPT1",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 13 [MIM: 614932]; Deafness, autosomal recessive 70, with or without adult-onset neurodegeneration [MIM: 614934]; Spinocerebellar ataxia 25 [MIM: 608703]",
          "OMIM Entry": "610316",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POGLUT1",
          "Phenotype MIM Number": "Dowling-Degos disease 4 [MIM: 615696]; Muscular dystrophy, limb-girdle, autosomal recessive 21 [MIM: 617232]",
          "OMIM Entry": "615618",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLG",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 4A (Alpers type) [MIM: 203700]; Mitochondrial DNA depletion syndrome 4B (MNGIE type) [MIM: 613662]; Mitochondrial recessive ataxia syndrome (includes SANDO and SCAE) [MIM: 607459]; Progressive external ophthalmoplegia, autosomal dominant 1 [mim: 157640]; Progressive external ophthalmoplegia, autosomal recessive 1 [MIM: 258450]",
          "OMIM Entry": "174763",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POLG2",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 16 (hepatic type [MIM: 618258]; Mitochondrial DNA depletion syndrome 16B (neuroophthalmic type) [MIM: 619425]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 4 [MIM: 610131]",
          "OMIM Entry": "604983",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "POMGNT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 3 [MIM: 253280]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 3 [MIM: 613151]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 3 [MIM: 613157]; Retinitis pigmentosa 76 [MIM: 617123]",
          "OMIM Entry": "606822",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMGNT2",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 8 [MIM: 614830]; Muscular dystrophy-dystroglycanopathy (limb-girdle) type C, 8 [MIM: 618135]",
          "OMIM Entry": "614828",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMK",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 12 [MIM: 616094]; Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 12 [MIM: 615249]",
          "OMIM Entry": "615247",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 1 [MIM: 236670]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 1 [MIM: 613155]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 1 [MIM: 609308]",
          "OMIM Entry": "607423",
          "Inheritance": "AR"
        },
        {
          "Gene": "POMT2",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 2 [MIM: 613150]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 2 [MIM: 613156]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 2 [MIM: 613158]",
          "OMIM Entry": "607439",
          "Inheritance": "AR"
        },
        {
          "Gene": "POPDC1",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 25 [MIM: 616812]",
          "OMIM Entry": "604577",
          "Inheritance": "AR"
        },
        {
          "Gene": "POPDC3",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 26 [MIM: 618848]",
          "OMIM Entry": "605824",
          "Inheritance": "AR"
        },
        {
          "Gene": "PPP2R2B",
          "Phenotype MIM Number": "Spinocerebellar ataxia 12 [MIM: 604326]",
          "OMIM Entry": "604325",
          "Inheritance": "AD"
        },
        {
          "Gene": "PREPL",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 22 [MIM: 616224]",
          "OMIM Entry": "609557",
          "Inheritance": "AR"
        },
        {
          "Gene": "PRKCG",
          "Phenotype MIM Number": "Spinocerebellar ataxia 14 [MIM: 605361]",
          "OMIM Entry": "176980",
          "Inheritance": "AD"
        },
        {
          "Gene": "PURA",
          "Phenotype MIM Number": "Neurodevelopmental disorder with neonatal respiratory insufficiency, hypotonia, and feeding difficulties [MIM: 616158]",
          "OMIM Entry": "600473",
          "Inheritance": "AD"
        },
        {
          "Gene": "PUS1",
          "Phenotype MIM Number": "Myopathy, lactic acidosis, and sideroblastic anemia 1 [MIM: 600462]",
          "OMIM Entry": "608109",
          "Inheritance": "AR"
        },
        {
          "Gene": "PYGM",
          "Phenotype MIM Number": "McArdle disease [MIM: 232600]",
          "OMIM Entry": "608455",
          "Inheritance": "AR"
        },
        {
          "Gene": "PYROXD1",
          "Phenotype MIM Number": "Myopathy, myofibrillar, 8 [MIM: 617258]",
          "OMIM Entry": "617220",
          "Inheritance": "AR"
        },
        {
          "Gene": "RAPSN",
          "Phenotype MIM Number": "Fetal akinesia deformation sequence 2 [MIM: 618388]; Myasthenic syndrome, congenital, 11, associated with acetylcholine receptor deficiency [MIM: 616236]",
          "OMIM Entry": "601592",
          "Inheritance": "AR"
        },
        {
          "Gene": "RBCK1",
          "Phenotype MIM Number": "Polyglucosan body myopathy 1 with or without immunodeficiency [MIM: 615895]",
          "OMIM Entry": "610924",
          "Inheritance": "AR"
        },
        {
          "Gene": "RFC1",
          "Phenotype MIM Number": "Cerebellar ataxia neuropathy and vestibular areflexia syndrome [MIM: 614575]",
          "OMIM Entry": "102579",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNASEH1",
          "Phenotype MIM Number": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal recessive 2 [MIM: 616479]",
          "OMIM Entry": "604123",
          "Inheritance": "AR"
        },
        {
          "Gene": "RNF170",
          "Phenotype MIM Number": "Ataxia, sensory, 1, autosomal dominant [MIM: 608984]; Spastic paraplegia 85, autosomal recessive [MIM: 619686]",
          "OMIM Entry": "614649",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RNF216",
          "Phenotype MIM Number": "Cerebellar ataxia and hypogonadotropic hypogonadism [MIM: 212840]",
          "OMIM Entry": "609948",
          "Inheritance": "AR"
        },
        {
          "Gene": "RRM2B",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 8A (encephalomyopathic type with renal tubulopathy) [MIM: 612075]; Mitochondrial DNA depletion syndrome 8B (MNGIE type) [MIM: 612075]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 5 [MIM: 613077]; Rod-cone dystrophy, sensorineural deafness, and Fanconi-type renal dysfunction [MIM: 268315]",
          "OMIM Entry": "604712",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RUBCN",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 15 [MIM: 615705]",
          "OMIM Entry": "613516",
          "Inheritance": "AR"
        },
        {
          "Gene": "RXYLT1",
          "Phenotype MIM Number": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 10 [MIM: 615041]",
          "OMIM Entry": "605862",
          "Inheritance": "AR"
        },
        {
          "Gene": "RYR1",
          "Phenotype MIM Number": "{Malignant hyperthermia susceptibility 1} [MIM: 145600]; Congenital myopathy 1A, autosomal dominant, with susceptibility to malignant hyperthermia [MIM: 117000]; Congenital myopathy 1B, autosomal recessive [MIM: 255320]; King-Denborough syndrome [MIM: 619542]",
          "OMIM Entry": "180901",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "RYR3",
          "Phenotype MIM Number": "Congenital myopathy 20 [MIM: 620310]",
          "OMIM Entry": "180903",
          "Inheritance": "AR"
        },
        {
          "Gene": "SACS",
          "Phenotype MIM Number": "Spastic ataxia, Charlevoix-Saguenay type {MIM: 270550]",
          "OMIM Entry": "604490",
          "Inheritance": "AR"
        },
        {
          "Gene": "SAMD9L",
          "Phenotype MIM Number": "Spinocerebellar ataxia 49 [MIM: 619806]; Ataxia-pancytopenia syndrome [MIM: 159550]; Monosomy 7 myelodysplasia and leukemia syndrome 1 [MIM: 252270]",
          "OMIM Entry": "611170",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCN2A",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 11 [MIM: 613721]; Episodic ataxia, type 9 [MIM: 618924]; Seizures, benign familial infantile, 3 [MIM: 607745]",
          "OMIM Entry": "182390",
          "Inheritance": "AD"
        },
        {
          "Gene": "SCN4A",
          "Phenotype MIM Number": "Congenital myopathy 22A, classic [MIM: 620351]; Congenital myopathy 22B, severe fetal [MIM: 620369]; Hyperkalemic periodic paralysis [MIM: 170500]; Hypokalemic periodic paralysis, type 2 [MIM: 613345]; Myasthenic syndrome, congenital, 16 [MIM: 614198]; Myotonia congenita, atypical, acetazolamide-responsive [MIM: 608390]; Paramyotonia congenita [MIM: 168300]  ",
          "OMIM Entry": "603967",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SCYL1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 21 [MIM: 616719]",
          "OMIM Entry": "607982",
          "Inheritance": "AR"
        },
        {
          "Gene": "SDHA",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1GG [MIM: 613642]; Mitochondrial complex II deficiency, nuclear type 1 [MIM: 252011]; Neurodegeneration with ataxia and late-onset optic atrophy [MIM: 619259]; Pheochromocytoma/paraganglioma syndrome 5 [MIM: 614165]",
          "OMIM Entry": "600857",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SELENON",
          "Phenotype MIM Number": "Congenital myopathy 3 with rigid spine [MIM: 602771]",
          "OMIM Entry": "606210",
          "Inheritance": "AR"
        },
        {
          "Gene": "SETX",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 4, juvenile {MIM: 602433]; Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 2 [MIM: 606002]",
          "OMIM Entry": "608465",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SGCA",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 3 [MIM: 608099]",
          "OMIM Entry": "600119",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCB",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 4 [MIM: 604286]",
          "OMIM Entry": "600900",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCD",
          "Phenotype MIM Number": "Cardiomyopathy, dilated, 1L [MIM: 606685]; Muscular dystrophy, limb-girdle, autosomal recessive 6 [MIM: 601287]",
          "OMIM Entry": "601411",
          "Inheritance": "AR"
        },
        {
          "Gene": "SGCE",
          "Phenotype MIM Number": "Dystonia-11, myoclonic [MIM: 159900]",
          "OMIM Entry": "604149",
          "Inheritance": "AD"
        },
        {
          "Gene": "SGCG",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 5 [MIM: 253700]",
          "OMIM Entry": "608896",
          "Inheritance": "AR"
        },
        {
          "Gene": "SIL1",
          "Phenotype MIM Number": "Marinesco-Sjogren syndrome [MIM: 248800]",
          "OMIM Entry": "608005",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC18A3",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 21, presynaptic [MIM: 617239]",
          "OMIM Entry": "600336",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC1A3",
          "Phenotype MIM Number": "Episodic ataxia, type 6 [MIM: 612656]",
          "OMIM Entry": "600111",
          "Inheritance": "AD"
        },
        {
          "Gene": "SLC22A5",
          "Phenotype MIM Number": "Carnitine deficiency, systemic primary [MIM: 212140]",
          "OMIM Entry": "603377",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A1",
          "Phenotype MIM Number": "Combined D-2- and L-2-hydroxyglutaric aciduria [MIM: 615182]; Myasthenic syndrome, congenital, 23, presynaptic [MIM: 618197]",
          "OMIM Entry": "190315",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A20",
          "Phenotype MIM Number": "Carnitine-acylcarnitine translocase deficiency [MIM: 212138]",
          "OMIM Entry": "613698",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A3",
          "Phenotype MIM Number": "Mitochondrial phosphate carrier deficiency [MIM: 610773]",
          "OMIM Entry": "600370",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC25A4",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 12A (cardiomyopathic type) AD [MIM: 617184]; Mitochondrial DNA depletion syndrome 12B (cardiomyopathic type) AR [MIM: 615418]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 2 [MIM: 609283]",
          "OMIM Entry": "103220",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SLC25A42",
          "Phenotype MIM Number": "Metabolic crises, recurrent, with variable encephalomyopathic features and neurologic regression [MIM: 618416]",
          "OMIM Entry": "610823",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC44A1",
          "Phenotype MIM Number": "Neurodegeneration, childhood-onset, with ataxia, tremor, optic atrophy, and cognitive decline [MIM: 618868]",
          "OMIM Entry": "606105",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC52A2",
          "Phenotype MIM Number": "Brown-Vialetto-Van Laere syndrome 2 [MIM: 614707]",
          "OMIM Entry": "607882",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC52A3",
          "Phenotype MIM Number": "Fazio-Londe disease [MIM: 211500]; Brown-Vialetto-Van Laere syndrome 1 [MIM: 211530]",
          "OMIM Entry": "613350",
          "Inheritance": "AR"
        },
        {
          "Gene": "SLC5A7",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 20, presynaptic [MIM: 617143]; Neuronopathy, distal hereditary motor, autosomal dominant 7 [MIM: 158580]",
          "OMIM Entry": "608761",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SMCHD1",
          "Phenotype MIM Number": "Bosma arhinia microphthalmia syndrome [MIM: 603457]; Facioscapulohumeral muscular dystrophy 2, digenic [MIM: 158901]",
          "OMIM Entry": "614982",
          "Inheritance": "AD, DD"
        },
        {
          "Gene": "SMPX",
          "Phenotype MIM Number": "Deafness, X-linked 4 [MIM: 300066]; Myopathy, distal, 7, adult-onset, X-linked [MIM: 301075]",
          "OMIM Entry": "300226",
          "Inheritance": "XLD, XLR"
        },
        {
          "Gene": "SNX14",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 20 [MIM: 616354]",
          "OMIM Entry": "616105",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPEG",
          "Phenotype MIM Number": "Centronuclear myopathy 5 [MIM: 615959]",
          "OMIM Entry": "615950",
          "Inheritance": "AR"
        },
        {
          "Gene": "SPTBN2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 5 [MIM: 600224]; Spinocerebellar ataxia, autosomal recessive 14 {MIM: 615386]",
          "OMIM Entry": "604985",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SPTBN4",
          "Phenotype MIM Number": "Neurodevelopmental disorder with hypotonia, neuropathy, and deafness [MIM: 617519]",
          "OMIM Entry": "606214",
          "Inheritance": "AR"
        },
        {
          "Gene": "SQSTM1",
          "Phenotype MIM Number": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 3 [MIM: 616437]; Myopathy, distal, with rimmed vacuoles [MIM: 617158]; Neurodegeneration with ataxia, dystonia, and gaze palsy, childhood-onset [MIM: 617145]; Paget disease of bone 3 [MIM: 167250]",
          "OMIM Entry": "601530",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "STAC3",
          "Phenotype MIM Number": "Congenital myopathy 13 [MIM: 255995]",
          "OMIM Entry": "615521",
          "Inheritance": "AR"
        },
        {
          "Gene": "STIM1",
          "Phenotype MIM Number": "Immunodeficiency 10 [MIM: 612783]; Myopathy, tubular aggregate, 1 [MIM: 160565]; Stormorken syndrome [MIM: 185070]",
          "OMIM Entry": "605921",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "STUB1",
          "Phenotype MIM Number": "Spinocerebellar ataxia 48 [MIM: 618093]; Spinocerebellar ataxia, autosomal recessive 16 [MIM: 615768]",
          "OMIM Entry": "607207",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SUCLA2",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 5 (encephalomyopathic with or without methylmalonic aciduria) [MIM: 612073]",
          "OMIM Entry": "603921",
          "Inheritance": "AR"
        },
        {
          "Gene": "SUCLG1",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 9 (encephalomyopathic type with methylmalonic aciduria) [MIM: 245400]",
          "OMIM Entry": "611224",
          "Inheritance": "AR"
        },
        {
          "Gene": "SVBP",
          "Phenotype MIM Number": "Neurodevelopmental disorder with ataxia, hypotonia, and microcephaly [MIM: 618569]",
          "OMIM Entry": "617853",
          "Inheritance": "AR"
        },
        {
          "Gene": "SYNE1",
          "Phenotype MIM Number": "Arthrogryposis multiplex congenita 3, myogenic type [MIM: 618484]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 612998]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 610743]",
          "OMIM Entry": "608441",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "SYNE2",
          "Phenotype MIM Number": "Emery-Dreifuss muscular dystrophy 5, autosomal dominant [MIM: 612999]",
          "OMIM Entry": "608442",
          "Inheritance": "AD"
        },
        {
          "Gene": "SYT14",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 11 [MIM: 614229]",
          "OMIM Entry": "610949",
          "Inheritance": "AR"
        },
        {
          "Gene": "SYT2",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 7A, presynaptic, and distal motor neuropathy, autosomal dominant [MIM: 616040]; Myasthenic syndrome, congenital, 7B, presynaptic, autosomal recessive [MIM: 619461]",
          "OMIM Entry": "600104",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TAFAZZIN",
          "Phenotype MIM Number": "Barth syndrome [MIM: 302060]",
          "OMIM Entry": "300394",
          "Inheritance": "XLR"
        },
        {
          "Gene": "TAMM41",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 56 [MIM: 620139]",
          "OMIM Entry": "614948",
          "Inheritance": "AR"
        },
        {
          "Gene": "TANGO2",
          "Phenotype MIM Number": "Metabolic encephalomyopathic crises, recurrent, with rhabdomyolysis, cardiac arrhythmias, and neurodegeneration [MIM: 616878]",
          "OMIM Entry": "616830",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBCK",
          "Phenotype MIM Number": "Hypotonia, infantile, with psychomotor retardation and characteristic facies 3 [MIM: 616900]",
          "OMIM Entry": "616899",
          "Inheritance": "AR"
        },
        {
          "Gene": "TBP  ",
          "Phenotype MIM Number": "{Parkinson disease susceptibility to} [MIM: 168600]; Spinocerebellar ataxia 17 [MIM: 607136]",
          "OMIM Entry": "600075",
          "Inheritance": "AD, Multifactorial"
        },
        {
          "Gene": "TCAP",
          "Phenotype MIM Number": "Cardiomyopathy, hypertrophic, 25 [MIM: 607487]; Muscular dystrophy, limb-girdle, autosomal recessive 7 [MIM: 601954]",
          "OMIM Entry": "604488",
          "Inheritance": "AD. AR"
        },
        {
          "Gene": "TDP1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 1 [MIM: 607250]",
          "OMIM Entry": "607198",
          "Inheritance": "AR"
        },
        {
          "Gene": "TDP2",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 23 [MIM: 616949]",
          "OMIM Entry": "605764",
          "Inheritance": "AR"
        },
        {
          "Gene": "TFG",
          "Phenotype MIM Number": "Spastic paraplegia 57, autosomal recessive [MIM: 615658]; Hereditary motor and sensory neuropathy, Okinawa type [MIM: 604484]",
          "OMIM Entry": "602498",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TGM6",
          "Phenotype MIM Number": "Spinocerebellar ataxia 35 [MIM: 613908]",
          "OMIM Entry": "613900",
          "Inheritance": "AR"
        },
        {
          "Gene": "THAP11",
          "Phenotype MIM Number": "Spinocerebellar Ataxia 51 [MIM: 620947]",
          "OMIM Entry": "609119",
          "Inheritance": "AD"
        },
        {
          "Gene": "THG1L",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 28 [MIM: 618800]",
          "OMIM Entry": "618802",
          "Inheritance": "AR"
        },
        {
          "Gene": "TIA1",
          "Phenotype MIM Number": "Amyotrophic lateral sclerosis 26 with or without frontotemporal dementia [MIM: 619133]; Welander distal myopathy [MIM: 604454]",
          "OMIM Entry": "603518",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TK2",
          "Phenotype MIM Number": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal recessive 3 [MIM: 617069]; Mitochondrial DNA depletion syndrome 2 (myopathic type) [MIM: 609560]",
          "OMIM Entry": "188250",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM126B",
          "Phenotype MIM Number": "Mitochondrial complex I deficiency, nuclear type 29 [MIM: 618250]",
          "OMIM Entry": "615533",
          "Inheritance": "AR"
        },
        {
          "Gene": "TMEM240",
          "Phenotype MIM Number": "Spinocerebellar ataxia 21 [MIM: 607454]",
          "OMIM Entry": "616101",
          "Inheritance": "AD"
        },
        {
          "Gene": "TMEM43",
          "Phenotype MIM Number": "Arrhythmogenic right ventricular dysplasia 5 [MIM: 604400]; Auditory neuropathy, autosomal dominant 3 [MIM: 619832]; Emery-Dreifuss muscular dystrophy 7, AD [MIM: 614302]",
          "OMIM Entry": "612048",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNC2",
          "Phenotype MIM Number": "Congenital myopathy 15 [MIM: 620161]",
          "OMIM Entry": "191039",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNI2",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 2B1 [MIM: 601680]",
          "OMIM Entry": "191043",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNT1",
          "Phenotype MIM Number": "Nemaline myopathy 5A, autosomal recessive, severe infantile [MIM: 605355]; Nemaline myopathy 5B, autosomal recessive, childhood-onset [MIM: 620386]; Nemaline myopathy 5C, autosomal dominant [MIM: 620389]",
          "OMIM Entry": "191041",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNNT3",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 2B2 [MIM: 618435]",
          "OMIM Entry": "600692",
          "Inheritance": "AD"
        },
        {
          "Gene": "TNPO3",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal dominant 2 [MIM: 608423]",
          "OMIM Entry": "610032",
          "Inheritance": "AD"
        },
        {
          "Gene": "TOR1AIP1",
          "Phenotype MIM Number": "Muscular dystrophy, autosomal recessive, with rigid spine and distal joint contractures [MIM: 617072]",
          "OMIM Entry": "614512",
          "Inheritance": "AR"
        },
        {
          "Gene": "TPM2",
          "Phenotype MIM Number": "Arthrogryposis, distal, type 1A [MIM: 108120]; Arthrogryposis, distal, type 2B4 [MIM: 108120]; Congenital myopathy 23 [MIM: 609285]",
          "OMIM Entry": "190990",
          "Inheritance": "AD"
        },
        {
          "Gene": "TPM3",
          "Phenotype MIM Number": "Congenital myopathy 4A, autosomal dominant [MIM: 255310]; Congenital myopathy 4B, autosomal recessive [MIM: 609284]",
          "OMIM Entry": "191030",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TPP1",
          "Phenotype MIM Number": "Ceroid lipofuscinosis, neuronal, 2 [MIM: 204500]; Spinocerebellar ataxia, autosomal recessive 7 [MIM: 609270]",
          "OMIM Entry": "607998",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRAPPC11",
          "Phenotype MIM Number": "Muscular dystrophy, limb-girdle, autosomal recessive 18 [MIM: 615356]",
          "OMIM Entry": "614138",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRDN",
          "Phenotype MIM Number": "Cardiac arrhythmia syndrome, with or without skeletal muscle weakness [MIM: 615441]",
          "OMIM Entry": "603283",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRIM32",
          "Phenotype MIM Number": "Bardet-Biedl syndrome 11 [MIM: 615988]; Muscular dystrophy, limb-girdle, autosomal recessive 8 [MIM: 254110]",
          "OMIM Entry": "602290",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRIP4",
          "Phenotype MIM Number": "Muscular dystrophy, congenital, Davignon-Chauveau type [MIM: 617066]; Spinal muscular atrophy with congenital bone fractures 1 [MIM: 616866]",
          "OMIM Entry": "604501",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRMT5",
          "Phenotype MIM Number": "Peripheral neuropathy with variable spasticity, exercise intolerance, and developmental delay [616539]",
          "OMIM Entry": "611023",
          "Inheritance": "AR"
        },
        {
          "Gene": "TRPC3",
          "Phenotype MIM Number": "Spinocerebellar ataxia 41  [MIM: 616410]",
          "OMIM Entry": "602345",
          "Inheritance": "AD"
        },
        {
          "Gene": "TRPV4",
          "Phenotype MIM Number": "Avascular necrosis of femoral head, primary, 2 [MIM: 617383]; [Sodium serum level QTL 1] [MIM: 613508]; Brachyolmia type 3 [MIM: 113500]; Digital arthropathy-brachydactyly, familial [MIM: 606835]; Hereditary motor and sensory neuropathy, type Iic [MIM: 606071]; Metatropic dysplasia [MIM: 156530]; Neuronopathy, distal hereditary motor, autosomal dominant 8 [MIM: 600175]; Parastremmatic dwarfism [MIM: 168400]; Scapuloperoneal spinal muscular atrophy [MIM: 181405]; SED, Maroteaux type [MIM: 184095]; Spondylometaphyseal dysplasia, Kozlowski type [MIM: 184252] ",
          "OMIM Entry": "605427",
          "Inheritance": "AD"
        },
        {
          "Gene": "TSFM",
          "Phenotype MIM Number": "Combined oxidative phosphorylation deficiency 3 [MIM: 610505]",
          "OMIM Entry": "604723",
          "Inheritance": "AR"
        },
        {
          "Gene": "TTBK2",
          "Phenotype MIM Number": "Spinocerebellar ataxia 11 [MIM: 604432]",
          "OMIM Entry": "611695",
          "Inheritance": "AD"
        },
        {
          "Gene": "TTN",
          "Phenotype MIM Number": "Cardiomyopathy, familial hypertrophic, 9 [MIM: 613765]; Cardiomyopathy, dilated, 1G [MIM: 604145]; Congenital myopathy 5 with cardiomyopathy [MIM: 611705]; Muscular dystrophy, limb-girdle, autosomal recessive 10 [MIM: 608807]; Myopathy myofibrillar, 9, with early respiratory failure [MIM: 603689]; Tibial muscular dystrophy, tardive [MIM: 600334]",
          "OMIM Entry": "188840",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TTPA",
          "Phenotype MIM Number": "Ataxia with isolated vitamin E deficiency [MIM: 277460]",
          "OMIM Entry": "600415",
          "Inheritance": "AR"
        },
        {
          "Gene": "TUBA4A",
          "Phenotype MIM Number": "Congenital myopathy 26 [MIM: 621225]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 9 [MIM: 616208]; Oocyte/zygote/embryo maturation arrest 23 [MIM: 621231]; Spastic ataxia 11, autosomal dominant [MIM: 621226]",
          "OMIM Entry": "191110",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TWNK",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 7 (hepatocerebral type) [MIM: 271245]; Perrault syndrome 5 [MIM: 616138]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 3 [MIM: 609286]",
          "OMIM Entry": "606075",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "TYMP",
          "Phenotype MIM Number": "Mitochondrial DNA depletion syndrome 1 (MNGIE type) [MIM: 603041]",
          "OMIM Entry": "131222",
          "Inheritance": "AR"
        },
        {
          "Gene": "UBA1",
          "Phenotype MIM Number": "Spinal muscular atrophy, X-linked 2, infantile [MIM: 301830]; VEXAS syndrome, somatic [MIM: 301054]",
          "OMIM Entry": "314370",
          "Inheritance": "XLR"
        },
        {
          "Gene": "UBA5",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 24[ MIM: 617133]; Developmental and epileptic encephalopathy 44 [MIM: 617132]",
          "OMIM Entry": "610552",
          "Inheritance": "AR"
        },
        {
          "Gene": "UNC45B",
          "Phenotype MIM Number": "Cataract 43 [MIM: 616279]; Myofibrillar myopathy 11 [MIM: 619178]",
          "OMIM Entry": "611220",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "UNC80",
          "Phenotype MIM Number": "Hypotonia, infantile, with psychomotor retardation and characteristic facies 2 [MIM: 616801]",
          "OMIM Entry": "612636",
          "Inheritance": "AR"
        },
        {
          "Gene": "VAMP1",
          "Phenotype MIM Number": "Myasthenic syndrome, congenital, 25 [MIM: 618323]; Spastic ataxia 1, autosomal dominant [MIM: 108600]",
          "OMIM Entry": "185880",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "VCP",
          "Phenotype MIM Number": "Charcot-Marie-Tooth disease, type 2Y [MIM: 616687]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 6 [MIM: 613954]; Inclusion body myopathy with early-onset Paget disease and frontotemporal dementia 1 [MIM: 167320]",
          "OMIM Entry": "601023",
          "Inheritance": "AD"
        },
        {
          "Gene": "VMA21",
          "Phenotype MIM Number": "Myopathy, X-linked, with excessive autophagy [MIM: 310440]",
          "OMIM Entry": "300913",
          "Inheritance": "XLR"
        },
        {
          "Gene": "VPS13D",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 4 [MIM: 607317]",
          "OMIM Entry": "608877",
          "Inheritance": "AR"
        },
        {
          "Gene": "VRK1",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal recessive 10 [MIM: 620542]; Pontocerebellar hypoplasia type 1A [MIM: 607596]",
          "OMIM Entry": "602168",
          "Inheritance": "AR"
        },
        {
          "Gene": "VWA1",
          "Phenotype MIM Number": "Neuronopathy, distal hereditary motor, autosomal recessive 7 [MIM: 619216]",
          "OMIM Entry": "611901",
          "Inheritance": "AR"
        },
        {
          "Gene": "WASHC5",
          "Phenotype MIM Number": "Ritscher-Schinzel syndrome 1 [MIM: 220210]; Spastic paraplegia 8, autosomal dominant [MIM: 603563]",
          "OMIM Entry": "610657",
          "Inheritance": "AD, AR"
        },
        {
          "Gene": "WDR81",
          "Phenotype MIM Number": "Cerebellar ataxia, impaired intellectual development, and dysquilibrium syndrome 2 [MIM: 610185]; Hydrocephalus, congenital, 3, with brain anomalies [MIM: 617967]",
          "OMIM Entry": "614218",
          "Inheritance": "AR"
        },
        {
          "Gene": "WWOX",
          "Phenotype MIM Number": "Developmental and epileptic encephalopathy 28 [MIM: 616211]; Esophageal squamous cell carcinoma, somatic [MIM: 133233]; Spinocerebellar ataxia, autosomal recessive 12 [MIM: 614322]",
          "OMIM Entry": "605131",
          "Inheritance": "AR"
        },
        {
          "Gene": "XRCC1",
          "Phenotype MIM Number": "Spinocerebellar ataxia, autosomal recessive 26 [MIM: 617633]",
          "OMIM Entry": "194360",
          "Inheritance": "AR"
        },
        {
          "Gene": "YARS2",
          "Phenotype MIM Number": "Myopathy, lactic acidosis, and sideroblastic anemia 2 [MIM: 613561]",
          "OMIM Entry": "610957",
          "Inheritance": "AR"
        },
        {
          "Gene": "ZC4H2",
          "Phenotype MIM Number": "Wieacker-Wolff syndrome [MIM: 314580]; Wieacker-Wolff syndrome, female-restricted [MIM: 301041]",
          "OMIM Entry": "300897",
          "Inheritance": "XLR, XLD"
        },
        {
          "Gene": "ZFHX3 ",
          "Phenotype MIM Number": "Spinocerebellar ataxia 4 [MIM: 600223]",
          "OMIM Entry": "104155",
          "Inheritance": "AD"
        },
        {
          "Gene": "ZFYVE26",
          "Phenotype MIM Number": "Spastic paraplegia 15, autosomal recessive (MIM: 270700]",
          "OMIM Entry": "612012",
          "Inheritance": "AR"
        }
      ],

      tableData: [],
      tableColumns: {
        // table1的列配置（原有逻辑）
        // table1: [
        //   {
        //     prop: 'disorder',
        //     label: 'Disorder(s)',
        //     showOverflowTooltip: true,
        //     // 自定义渲染函数
        //     render: (row) => this.formatDisorderText(row.disorder)
        //   },
        //   {
        //     prop: 'gene',
        //     label: 'Gene(s)',
        //     width: 200,
        //     align: 'center',
        //     showOverflowTooltip: true
        //   },
        //   {
        //     prop: 'inheritance',
        //     label: 'Inheritance Pattern',
        //     width: 250,
        //     align: 'center',
        //     showOverflowTooltip: true
        //   },
        //   {
        //     prop: 'repeat',
        //     label: 'Repeat',
        //     width: 200,
        //     align: 'center',
        //     showOverflowTooltip: true
        //   }
        // ],
        table1: [
          {
            prop: 'Gene',
            label: 'Gene',
            width: 150,
            align: 'center',
            showOverflowTooltip: true
          },
          {
            prop: 'Phenotype MIM Number',
            label: 'Phenotype MIM Number',
            showOverflowTooltip: true,
            // 复用原有MIM链接生成逻辑
            render: (row) => this.formatDisorderText(row['Phenotype MIM Number'])
          },
          {
            prop: 'OMIM Entry',
            label: 'OMIM Entry',
            width: 180,
            align: 'center',
            showOverflowTooltip: true,
            // OMIM Entry专属链接生成
            render: (row) => this.formatOmimEntryText(row['OMIM Entry'])
          },
          {
            prop: 'Inheritance',
            label: 'Inheritance',
            width: 200,
            align: 'center',
            showOverflowTooltip: true
          }
        ],
        // table2/table3/table4共用的列配置
        table2: [
          {
            prop: 'Gene',
            label: 'Gene',
            width: 150,
            align: 'center',
            showOverflowTooltip: true
          },
          {
            prop: 'Phenotype MIM Number',
            label: 'Phenotype MIM Number',
            showOverflowTooltip: true,
            // 复用原有MIM链接生成逻辑
            render: (row) => this.formatDisorderText(row['Phenotype MIM Number'])
          },
          {
            prop: 'OMIM Entry',
            label: 'OMIM Entry',
            width: 180,
            align: 'center',
            showOverflowTooltip: true,
            // OMIM Entry专属链接生成
            render: (row) => this.formatOmimEntryText(row['OMIM Entry'])
          },
          {
            prop: 'Inheritance',
            label: 'Inheritance',
            width: 200,
            align: 'center',
            showOverflowTooltip: true
          }
        ],
        // table3/table4复用table2的列配置（如需差异化可单独定义）
        table3: [],
        table4: [],
      },
      filteredTableData: [], // 筛选后的表格数据
      filterKeyword: '', // 筛选关键词

    };
  },
  created() {
    // 51 1146 121 375
    // console.log(this.Table1.length, this.Table2.length, this.Table3.length, this.Table4.length)
    this.tableColumns.table3 = [...this.tableColumns.table2]
    this.tableColumns.table4 = [...this.tableColumns.table2]
    this.initTable()

  },
  // // 监听content.type变化，重新初始化表格（可选）
  // watch: {
  //   'content.type': {
  //     handler() {
  //       this.initTable();
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    cancel() { },
    isInheritanceColumnKey(key) {
      return String(key || '').trim().toLowerCase() === 'inheritance';
    },
    getSearchableRowValues(row) {
      return Object.keys(row || {})
        .filter(key => !this.isInheritanceColumnKey(key))
        .map(key => row[key]);
    },
    // 格式化疾病文本，将MIM编号转为可点击链接
    // table1/Phenotype MIM Number列的MIM链接生成（原有逻辑）
    formatDisorderText(text) {
      const inputText = String(text || '');
      const mimRegex = /MIM:\s*(\d+)/g;
      if (!inputText.trim()) {
        return inputText;
      }
      return inputText.replace(mimRegex, (match, mimNumber) => {
        const omimUrl = `https://www.omim.org/clinicalSynopsis/${mimNumber}`;
        return `MIM: <a href="${omimUrl}" target="_blank" class="mim-link">${mimNumber}</a>`;
      });
    },

    // OMIM Entry列的专属链接生成（新逻辑）
    formatOmimEntryText(text) {
      const inputText = String(text || '');
      if (!inputText.trim()) {
        return inputText;
      }
      // OMIM Entry是纯数字，直接拼接链接
      const omimUrl = `https://www.omim.org/entry/${inputText}`;
      return `<a href="${omimUrl}" target="_blank" class="mim-link">${inputText}</a>`;
    },

    // 初始化表格数据和列配置
    initTable() {
      this.$nextTick(() => {
        // 预处理content.type（兼容旧逻辑，去空格+转小写）
        let type = '';
        if (this.content) {
          const originalType = String(this.content.type || '');
          if (originalType.trim() !== '') {
            type = originalType.toLowerCase().replace(/\s+/g, '');
          }
        }


        // 定义不同类型的数据源映射（替换你实际的Table1/Table2等）
        const dataMap = {
          table1: this.Table1 || [],
          table2: this.Table2 || [],
          table3: this.Table3 || [],
          table4: this.Table4 || []
        };

        // 赋值原始表格数据
        this.tableData = [...(dataMap[type] || [])];
        // 初始化筛选后的数据
        this.filteredTableData = [...this.tableData]
      });
    },
    // 实时筛选表格数据
    handleFilterInput() {
      const keyword = this.filterKeyword.trim().toLowerCase();
      if (!keyword) {
        this.filteredTableData = [...this.tableData];
        return;
      }
      // 筛选包含关键词的行
      this.filteredTableData = this.tableData.filter(row =>
        this.getSearchableRowValues(row).some(val => String(val || '').toLowerCase().includes(keyword))
      );
    },
    // 核心方法：处理文本高亮 + 原有链接渲染逻辑（修复正则转义）
    // highlightKeyword(row, col) {
    //   const keyword = this.filterKeyword.trim();
    //   if (!keyword) {
    //     // 无关键词时，直接渲染链接或原文本
    //     return this.renderColumnContent(row, col);
    //   }

    //   // 先获取处理后的文本（含链接）
    //   let text = this.renderColumnContent(row, col);
    //   // 转义关键词中的特殊字符（如 . * + 等），避免正则报错
    //   const escapeKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    //   // 构建正则：不区分大小写 + 全局匹配
    //   const reg = new RegExp(`(${escapeKeyword})`, 'gi');
    //   // 高亮关键词
    //   return text.replace(reg, '<span class="highlight-text">$1</span>');
    // }, 

    highlightKeyword(row, col) {
      const keyword = this.filterKeyword.trim();
      if (!keyword || this.isInheritanceColumnKey(col.prop)) {
        // 无关键词时，直接渲染链接或原文本 + 套上不截断样式
        const text = this.renderColumnContent(row, col);
        // 核心：套一层 style 样式，强制不截断单词、自动换行
        return `<div style="white-space: pre-line; word-break: keep-all; overflow: visible;">${text}</div>`;
      }

      // 先获取处理后的文本（含链接）
      let text = this.renderColumnContent(row, col);
      // 转义关键词中的特殊字符（如 . * + 等），避免正则报错
      const escapeKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // 构建正则：不区分大小写 + 全局匹配
      const reg = new RegExp(`(${escapeKeyword})`, 'gi');
      // 高亮关键词
      const highlightedText = text.replace(reg, '<span class="highlight-text">$1</span>');

      // 👇 关键：高亮后也套上不截断样式
      return `<div style="white-space: pre-line; word-break: keep-all; overflow: visible;">${highlightedText}</div>`;
    },
    // 单独处理列的链接渲染逻辑
    renderColumnContent(row, col) {
      const val = String(row[col.prop] || '-');
      // Gene 列：斜体
      if (col.prop === 'Gene') {
        return `<em>${val}</em>`;   // 或 <i>${val}</i>
      }

      // 匹配需要生成链接的列
      if (col.prop === 'disorder' || col.prop === 'Phenotype MIM Number') {
        const mimRegex = /MIM:\s*(\d+)/g;
        return val.replace(mimRegex, (_, num) =>
          `MIM: <a href="https://www.omim.org/clinicalSynopsis/${num}" target="_blank" class="mim-link">${num}</a>`
        );
      } else if (col.prop === 'OMIM Entry') {
        return val === '-' ? '-' : `<a href="https://www.omim.org/entry/${val}" target="_blank" class="mim-link">${val}</a>`;
      }
      return val;
    },


    // 核心改动2：返回高亮类名，而不是直接写样式
    getRowClassName(row) {
      const keyword = this.filterKeyword.trim().toLowerCase();
      if (!keyword) return '';
      const isMatch = this.getSearchableRowValues(row).some(val => String(val || '').toLowerCase().includes(keyword));
      return isMatch ? 'highlight-row' : '';
    },
  }
};
</script>


<!-- 去掉scoped，通过外层类名限制样式作用域 -->
<style lang='scss'>
.table-container-dialog {
  .table-filter-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .table-wrapper {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    overflow: hidden;
  }

  // 只作用于当前组件的表格：通过双层类名提升权重
  .keyword-highlight-table {
    .el-table__body-wrapper {
      .cell {
        // border-bottom: 1px solid #f0f0f0;
        font-size: 14px;
        color: #333;
        line-height: 1.8;
        white-space: normal !important;
        word-break: break-all !important;
        text-overflow: unset !important;
        overflow: visible !important;
      }

      // 关键词高亮样式：权重足够覆盖Element UI默认样式
      .highlight-text {
        background-color: #ffeb3b !important;
        color: #333 !important;
        padding: 0 2px;
        border-radius: 2px;
        font-weight: 500;
      }

      // 链接样式
      .mim-link {
        color: #409eff;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/table.vue